// sometimes constant numeration starts from 0 for backwards compability (when it's undefined)

export * from './text-constants';

export const STATUS = {
	SUCCESS: 1,
	FAILURE: 2,
	ERROR: 3,

	ACTIVE: 4,
	INACTIVE: 5,

	PROCESSING: 6,
	FINISHED: 7,

	CREATED: 8,

	STARTED: 9,
	CANCELLED: 10,

	SEEN: 11,
	UNREAD: 12,
	READ: 13,

	OPEN: 14,
	RESOLVED: 15,

	PENDING: 16,
	IN_PROGRESS: 17,
	COMPLETE: 18,

	DECLINED: 19,
	VOIDED: 20,

	NOT_APPLICABLE: 21,

	ABANDONED: 22,
	IDLE: 23,

	APPROVED: 24,
	REFUNDED: 25,
	PARTIALLY_REFUNDED: 26,
	SOLD: 27,

	GRANTED: 28,

	INIT: 29,
	TIMEOUT: 30,

	BOOKED: 31,

	REQUESTED: 32,
	ASSIGNED: 33,
	SETUP_COMPLETE: 34,
	POST_SETUP_ADMIN_COMPLETE: 35,
	READY_TO_BOOK_TRANSPORT: 36,

	KIOSK_SETUP_COMPLETE: 37,
	MARKET_SETUP_SITE_VISIT_COMPLETE: 38,
	MARKET_SETUP_CONFIGURATION_COMPLETE: 39,
	PRE_DEPLOYMENT_CLIENT_STEPS_COMPLETE: 40,
	PRE_DEPLOYMENT_OPERATIONAL_STEPS_COMPLETE: 41,
};

export const SETUP_COMPLETION_FILTER = {
	ALL: 'all',
	INCOMPLETE: 'incomplete',
	COMPLETE: 'complete',
};

export const LOCATION_SETUP_TYPE_FILTER = {
	ALL: 'all',
	MARKET: 'market',
	MACHINE: 'machine',
};

export const STATUS_NAMES = {
	1: 'Success',
	2: 'Failure',
	3: 'Error',

	4: 'Active',
	5: 'Inactive',

	6: 'Processing',
	7: 'Finished',

	8: 'Created',

	9: 'Started',
	10: 'Cancelled',

	11: 'Seen',
	12: 'Unread',
	13: 'Read',

	14: 'Open',
	15: 'Resolved',

	16: 'Pending',
	17: 'In Progress',
	18: 'Complete',

	19: 'Declined',
	20: 'Voided',

	21: 'n/a',

	22: 'Abandoned',
	23: 'Idle',

	24: 'Approved',
	25: 'Refunded',
	26: 'Partially refunded',
	27: 'Sold',

	28: 'Granted',

	29: 'Init',
	30: 'Timeout',

	31: 'Booked',

	32: 'Requested',
	33: 'Assigned',
	34: 'Setup complete',
	35: 'Post setup admin complete',
	36: 'Ready to book transport',
	37: 'Kiosk setup complete',
	38: 'Market site visit complete',
	39: 'Market configuration complete',
	40: 'Pre-deployment client steps complete',
	41: 'Pre-deployment operational steps complete',
};

export const CANCELLED_TRANSACTION_REVIEW_STATUS = {
	UNREVIEWED: 1,
	CONFIRMED_THEFT: 2,
	CLEARED: 3,
	MONITOR: 4,
};

export const CANCELLED_TRANSACTION_TRACKED_BASKET_STATUSES = [
	STATUS.CANCELLED,
	STATUS.ABANDONED,
	STATUS.ERROR,
];

export const CANCELLED_TRANSACTION_REVIEW_STATUS_NAMES = {
	[CANCELLED_TRANSACTION_REVIEW_STATUS.UNREVIEWED]: 'Unreviewed',
	[CANCELLED_TRANSACTION_REVIEW_STATUS.CONFIRMED_THEFT]: 'Confirmed theft',
	[CANCELLED_TRANSACTION_REVIEW_STATUS.CLEARED]: 'Cleared',
	[CANCELLED_TRANSACTION_REVIEW_STATUS.MONITOR]: 'Monitor',
};

// People (phase 1) uses numeric constants (aligned with the rest of the system) instead of string enums.
// Employee status reuses the shared STATUS codes so we don't introduce another status number set.
export const PEOPLE_EMPLOYEE_STATUS = {
	DRAFT: STATUS.CREATED,
	INVITED: STATUS.REQUESTED,
	ACTIVE: STATUS.ACTIVE,
	TERMINATED: STATUS.INACTIVE,
	ARCHIVED: STATUS.ABANDONED,
};

export const PEOPLE_EMPLOYEE_STATUS_NAMES = {
	[PEOPLE_EMPLOYEE_STATUS.DRAFT]: 'Draft',
	[PEOPLE_EMPLOYEE_STATUS.INVITED]: 'Invited',
	[PEOPLE_EMPLOYEE_STATUS.ACTIVE]: 'Active',
	[PEOPLE_EMPLOYEE_STATUS.TERMINATED]: 'Terminated',
	[PEOPLE_EMPLOYEE_STATUS.ARCHIVED]: 'Archived',
};

export const PEOPLE_ONBOARDING_INVITE_EXPIRES_DAYS = 14;

// Employee termination reasons (phase 1): stored as stable string keys so UI can provide consistent options
// while still allowing us to add/rename reasons later without migrations.
export const PEOPLE_EMPLOYEE_TERMINATION_REASON = {
	RESIGNED_CAREER_PROGRESSION: 'resignedCareerProgression',
	RESIGNED_PERSONAL_COMMITMENTS: 'resignedPersonalCommitments',
	RESIGNED_INJURY: 'resignedInjury',
	RESIGNED_DISSATISFACTION: 'resignedDissatisfaction',
	TERMINATED_LATENESS_ABSENTEEISM: 'terminatedLatenessAbsenteeism',
	TERMINATED_MISCONDUCT: 'terminatedMisconduct',
	TERMINATED_UNDERPERFORMANCE: 'terminatedUnderperformance',
	TERMINATED_REDUNDANCY: 'terminatedRedundancy',
	UNSUCCESSFUL_TRIAL: 'unsuccessfulTrial',
};

export const PEOPLE_EMPLOYEE_TERMINATION_REASON_NAMES = {
	[PEOPLE_EMPLOYEE_TERMINATION_REASON.RESIGNED_CAREER_PROGRESSION]: 'Voluntary - career progression',
	[PEOPLE_EMPLOYEE_TERMINATION_REASON.RESIGNED_PERSONAL_COMMITMENTS]: 'Voluntary - personal commitments',
	[PEOPLE_EMPLOYEE_TERMINATION_REASON.RESIGNED_INJURY]: 'Voluntary - injury',
	[PEOPLE_EMPLOYEE_TERMINATION_REASON.RESIGNED_DISSATISFACTION]: 'Voluntary - dissatisfaction',
	[PEOPLE_EMPLOYEE_TERMINATION_REASON.TERMINATED_LATENESS_ABSENTEEISM]: 'Involuntary - lateness and absenteeism',
	[PEOPLE_EMPLOYEE_TERMINATION_REASON.TERMINATED_MISCONDUCT]: 'Involuntary - misconduct',
	[PEOPLE_EMPLOYEE_TERMINATION_REASON.TERMINATED_UNDERPERFORMANCE]: 'Involuntary - underperformance',
	[PEOPLE_EMPLOYEE_TERMINATION_REASON.TERMINATED_REDUNDANCY]: 'Involuntary - redundancy',
	[PEOPLE_EMPLOYEE_TERMINATION_REASON.UNSUCCESSFUL_TRIAL]: 'Unsuccessful trial',
};

export const PEOPLE_EMPLOYMENT_TYPE = {
	FULL_TIME: 1,
	PART_TIME: 2,
	CASUAL: 3,
	CONTRACTOR: 4,
};

export const PEOPLE_EMPLOYMENT_TYPE_NAMES = {
	1: 'Full time',
	2: 'Part time',
	3: 'Casual',
	4: 'Contractor',
};

export const PEOPLE_PAY_RATE_FIELD = {
	WEEKDAY: 'weekdayRateCents',
	SATURDAY: 'saturdayRateCents',
	SUNDAY: 'sundayRateCents',
	PUBLIC_HOLIDAY: 'publicHolidayRateCents',
};

export const PEOPLE_PAY_RATE_FIELD_NAMES = {
	[PEOPLE_PAY_RATE_FIELD.WEEKDAY]: 'Ordinary hours',
	[PEOPLE_PAY_RATE_FIELD.SATURDAY]: 'Saturday rate',
	[PEOPLE_PAY_RATE_FIELD.SUNDAY]: 'Sunday rate',
	[PEOPLE_PAY_RATE_FIELD.PUBLIC_HOLIDAY]: 'Public holiday rate',
};

// Stable display order for the four casual rates across forms, panels and history.
export const PEOPLE_PAY_RATE_FIELDS_ORDERED = [
	PEOPLE_PAY_RATE_FIELD.WEEKDAY,
	PEOPLE_PAY_RATE_FIELD.SATURDAY,
	PEOPLE_PAY_RATE_FIELD.SUNDAY,
	PEOPLE_PAY_RATE_FIELD.PUBLIC_HOLIDAY,
];

export const PEOPLE_EMPLOYMENT_CHANGE_TYPE = {
	INITIAL: 1,
	PROMOTION: 2,
	POSITION_CHANGE: 3,
	EMPLOYMENT_TYPE_CHANGE: 4,
	SALARY_CHANGE: 5,
	TRANSFER: 6,
	CORRECTION: 7,
	OTHER: 8,
	START_DATE_CORRECTION: 9,
};

export const PEOPLE_EMPLOYMENT_CHANGE_TYPE_NAMES = {
	[PEOPLE_EMPLOYMENT_CHANGE_TYPE.INITIAL]: 'Initial employment terms',
	[PEOPLE_EMPLOYMENT_CHANGE_TYPE.PROMOTION]: 'Promotion',
	[PEOPLE_EMPLOYMENT_CHANGE_TYPE.POSITION_CHANGE]: 'Position change',
	[PEOPLE_EMPLOYMENT_CHANGE_TYPE.EMPLOYMENT_TYPE_CHANGE]: 'Employment type change',
	[PEOPLE_EMPLOYMENT_CHANGE_TYPE.SALARY_CHANGE]: 'Salary change',
	[PEOPLE_EMPLOYMENT_CHANGE_TYPE.TRANSFER]: 'Transfer',
	[PEOPLE_EMPLOYMENT_CHANGE_TYPE.CORRECTION]: 'Correction',
	[PEOPLE_EMPLOYMENT_CHANGE_TYPE.OTHER]: 'Other',
	[PEOPLE_EMPLOYMENT_CHANGE_TYPE.START_DATE_CORRECTION]: 'Start date correction',
};

export const PEOPLE_EMPLOYMENT_CHANGE_STATUS = {
	APPLIED: 1,
	CANCELLED: 2,
	PENDING: 3,
	APPLYING: 4,
};

export const PEOPLE_EMPLOYMENT_CHANGE_STATUS_NAMES = {
	[PEOPLE_EMPLOYMENT_CHANGE_STATUS.APPLIED]: 'Applied',
	[PEOPLE_EMPLOYMENT_CHANGE_STATUS.CANCELLED]: 'Cancelled',
	[PEOPLE_EMPLOYMENT_CHANGE_STATUS.PENDING]: 'Pending',
	[PEOPLE_EMPLOYMENT_CHANGE_STATUS.APPLYING]: 'Applying',
};

export const PEOPLE_PAYROLL_DETAILS_CHANGE_STATUS = Object.freeze({
	PENDING: 'pending',
	APPLYING: 'applying',
	APPROVED: 'approved',
	REJECTED: 'rejected',
	STALE: 'stale',
});

export const PEOPLE_PAYROLL_DETAILS_CHANGE_STATUS_NAMES = Object.freeze({
	[PEOPLE_PAYROLL_DETAILS_CHANGE_STATUS.PENDING]: 'Pending approval',
	[PEOPLE_PAYROLL_DETAILS_CHANGE_STATUS.APPLYING]: 'Applying',
	[PEOPLE_PAYROLL_DETAILS_CHANGE_STATUS.APPROVED]: 'Approved',
	[PEOPLE_PAYROLL_DETAILS_CHANGE_STATUS.REJECTED]: 'Rejected',
	[PEOPLE_PAYROLL_DETAILS_CHANGE_STATUS.STALE]: 'Needs resubmission',
});

export const PEOPLE_PAYROLL_DETAILS_SECTION = Object.freeze({
	BANKING: 'banking',
	SUPERANNUATION: 'superannuation',
});

export const PEOPLE_EMPLOYMENT_CHANGE_DOCUMENT_MODE = {
	NONE: 1,
	ACKNOWLEDGEMENT: 2,
	VARIATION_LETTER: 3,
	NEW_CONTRACT: 4,
	CUSTOM_PACKAGE: 5,
};

export const PEOPLE_EMPLOYMENT_CHANGE_DOCUMENT_MODE_NAMES = {
	[PEOPLE_EMPLOYMENT_CHANGE_DOCUMENT_MODE.NONE]: 'No document required',
	[PEOPLE_EMPLOYMENT_CHANGE_DOCUMENT_MODE.ACKNOWLEDGEMENT]: 'Acknowledgement',
	[PEOPLE_EMPLOYMENT_CHANGE_DOCUMENT_MODE.VARIATION_LETTER]: 'Variation letter',
	[PEOPLE_EMPLOYMENT_CHANGE_DOCUMENT_MODE.NEW_CONTRACT]: 'New contract',
	[PEOPLE_EMPLOYMENT_CHANGE_DOCUMENT_MODE.CUSTOM_PACKAGE]: 'Custom document package',
};

export const PEOPLE_LEAVE_ENTITLEMENT = {
	ANNUAL: 1,
	SICK: 2,
	PERSONAL: 3,
	UNPAID: 4,
	PARENTAL: 5,
	BEREAVEMENT: 6,
	FAMILY_AND_DOMESTIC_VIOLENCE: 7,
};

export const PEOPLE_LEAVE_ENTITLEMENT_NAMES = {
	[PEOPLE_LEAVE_ENTITLEMENT.ANNUAL]: 'Annual leave',
	[PEOPLE_LEAVE_ENTITLEMENT.SICK]: 'Sick/personal carer\'s leave',
	[PEOPLE_LEAVE_ENTITLEMENT.PERSONAL]: 'Personal leave',
	[PEOPLE_LEAVE_ENTITLEMENT.UNPAID]: 'Unpaid leave',
	[PEOPLE_LEAVE_ENTITLEMENT.PARENTAL]: 'Parental leave',
	[PEOPLE_LEAVE_ENTITLEMENT.BEREAVEMENT]: 'Bereavement leave',
	[PEOPLE_LEAVE_ENTITLEMENT.FAMILY_AND_DOMESTIC_VIOLENCE]: 'Family and domestic violence leave',
};

// Review states for approved Sentry leave written to Xero. `needsAttention` is the flag
// Chris reviews (cancelled or already-processed leave); `manual` is leave with no clear
// Xero equivalent; `matched` is pre-go-live leave already entered in Xero.
export const XERO_LEAVE_SYNC_STATUS = {
	PENDING: 'pending',
	RUNNING: 'running',
	SENT: 'sent',
	FAILED: 'failed',
	NEEDS_ATTENTION: 'needsAttention',
	MATCHED: 'matched',
	MANUAL: 'manual',
};

export const XERO_LEAVE_SYNC_STATUS_NAMES = {
	[XERO_LEAVE_SYNC_STATUS.PENDING]: 'Queued',
	[XERO_LEAVE_SYNC_STATUS.RUNNING]: 'Sending',
	[XERO_LEAVE_SYNC_STATUS.SENT]: 'Sent',
	[XERO_LEAVE_SYNC_STATUS.FAILED]: 'Failed',
	[XERO_LEAVE_SYNC_STATUS.NEEDS_ATTENTION]: 'Needs attention',
	[XERO_LEAVE_SYNC_STATUS.MATCHED]: 'Already matched',
	[XERO_LEAVE_SYNC_STATUS.MANUAL]: 'Manual',
};

// States for the per-employee Xero timesheet export run. One record doubles as the background
// queue item and the run-log row, so `skipped` covers every employee the preview left out.
export const XERO_TIMESHEET_EXPORT_STATUS = {
	PENDING: 'pending',
	RUNNING: 'running',
	SENT: 'sent',
	FAILED: 'failed',
	SKIPPED: 'skipped',
};

export const XERO_TIMESHEET_EXPORT_STATUS_NAMES = {
	[XERO_TIMESHEET_EXPORT_STATUS.PENDING]: 'Queued',
	[XERO_TIMESHEET_EXPORT_STATUS.RUNNING]: 'Sending',
	[XERO_TIMESHEET_EXPORT_STATUS.SENT]: 'Sent',
	[XERO_TIMESHEET_EXPORT_STATUS.FAILED]: 'Failed',
	[XERO_TIMESHEET_EXPORT_STATUS.SKIPPED]: 'Skipped',
};

// Preview-only classification of what the run will do for one employee.
export const XERO_TIMESHEET_EXPORT_ACTION = {
	CREATE: 'create',
	UPDATE: 'update',
	RECREATE: 'recreate',
	ALREADY_SENT: 'alreadySent',
	EXCLUDED: 'excluded',
};

export const XERO_TIMESHEET_EXPORT_RECONCILIATION_STATUS = {
	PENDING: 'pending',
	COMPLETE: 'complete',
	UNAVAILABLE: 'unavailable',
};

export const PEOPLE_TEAM = {
	OPERATIONS: 101,
	ACCOUNT_MANAGEMENT: 102,
	FINANCE: 103,
	PEOPLE_OPERATIONS: 104,
	MARKETING: 105,
	COMMERCIAL: 106,
	PROJECTS_TECHNOLOGY_AND_SYSTEMS: 107,
	EXECUTIVE: 108,
};

export const PEOPLE_TEAM_NAMES = {
	101: 'Operations',
	102: 'Account management',
	103: 'Finance',
	104: 'People operations',
	105: 'Marketing',
	106: 'Commercial',
	107: 'Projects, technology and systems',
	108: 'Executive',
};

// Rostering (Deputy replacement). Areas are one fixed list shared by all states for now;
// long term these may link to actual scheduled work (service runs, training).
export const PEOPLE_ROSTER_AREA = {
	DRIVER: 1,
	PICKER: 2,
	DRIVER_TRAINING: 3,
	WAREHOUSE: 4,
	OFFICE: 5,
	WORKING_FROM_HOME: 6,
	OTHER: 99,
};

export const PEOPLE_ROSTER_AREA_NAMES = {
	[PEOPLE_ROSTER_AREA.DRIVER]: 'Driver',
	[PEOPLE_ROSTER_AREA.PICKER]: 'Picker',
	[PEOPLE_ROSTER_AREA.DRIVER_TRAINING]: 'Driver training',
	[PEOPLE_ROSTER_AREA.WAREHOUSE]: 'Warehouse',
	[PEOPLE_ROSTER_AREA.OFFICE]: 'Office',
	[PEOPLE_ROSTER_AREA.WORKING_FROM_HOME]: 'Working from home',
	[PEOPLE_ROSTER_AREA.OTHER]: 'Other',
};

// Shifts are built as drafts and only become visible to employees once published.
export const PEOPLE_ROSTER_SHIFT_STATUS = {
	DRAFT: 1,
	PUBLISHED: 2,
};

export const PEOPLE_ROSTER_SHIFT_STATUS_NAMES = {
	[PEOPLE_ROSTER_SHIFT_STATUS.DRAFT]: 'Draft',
	[PEOPLE_ROSTER_SHIFT_STATUS.PUBLISHED]: 'Published',
};

// Open shifts accept employee applications until the shift's day is finished; accepting an
// application creates a published roster shift, so one open shift can be filled several times.
export const PEOPLE_OPEN_SHIFT_APPLICATION_STATUS = {
	PENDING: 1,
	ACCEPTED: 2,
	DECLINED: 3,
};

export const PEOPLE_OPEN_SHIFT_APPLICATION_STATUS_NAMES = {
	[PEOPLE_OPEN_SHIFT_APPLICATION_STATUS.PENDING]: 'Pending',
	[PEOPLE_OPEN_SHIFT_APPLICATION_STATUS.ACCEPTED]: 'Accepted',
	[PEOPLE_OPEN_SHIFT_APPLICATION_STATUS.DECLINED]: 'Declined',
};

export const PEOPLE_TIMESHEET_STATUS = {
	PENDING: 1,
	APPROVED: 2,
	DISCARDED: 3,
};

export const PEOPLE_TIMESHEET_STATUS_NAMES = {
	[PEOPLE_TIMESHEET_STATUS.PENDING]: 'Pending',
	[PEOPLE_TIMESHEET_STATUS.APPROVED]: 'Approved',
	[PEOPLE_TIMESHEET_STATUS.DISCARDED]: 'Discarded',
};

export const CHECKLIST_PURPOSE = {
	LEAVE_WAREHOUSE: 1,
	VEHICLE_END_OF_DAY: 2,
	SELF_DEBRIEF: 3,
	WAREHOUSE_OPEN: 4,
	WAREHOUSE_CLOSE: 5,
	CUSTOM: 99,
};

export const CHECKLIST_SUBMISSION_STATUS = {
	SUBMITTED: 1,
	APPROVED: 2,
};

// Push data type that opens the checklist sign-off page in the Sentry phone app.
export const CHECKLIST_SIGN_OFF_PUSH_TYPE = 'checklistSignOff';

export const MY_DAY_CLOCK_IN_REQUIREMENT = {
	OFF: 'off',
	SOFT: 'soft',
	HARD: 'hard',
};

export const MY_DAY_SELF_DEBRIEF_MODE = {
	OFF: 'off',
	OPTIONAL: 'optional',
	REQUIRED: 'required',
};

export const PICK_LIST_RECALCULATION_MODE = {
	UNFINISHED: 'UNFINISHED',
	TOP_UP_ALL: 'TOP_UP_ALL',
};

// How a user-triggered recalculation is recorded in the Stock movement log
export const PICK_LIST_RECALCULATION_LOG_MODE = {
	...PICK_LIST_RECALCULATION_MODE,
	SINGLE_MACHINE: 'SINGLE_MACHINE',
};

export const PICK_LIST_RECALCULATION_LOG_MODE_NAMES = {
	[PICK_LIST_RECALCULATION_LOG_MODE.UNFINISHED]: 'Unfinished packs',
	[PICK_LIST_RECALCULATION_LOG_MODE.TOP_UP_ALL]: 'Top up all',
	[PICK_LIST_RECALCULATION_LOG_MODE.SINGLE_MACHINE]: 'Single machine',
};

// Per-run driver confirmations recorded from the "My day" board
export const MY_DAY_CONFIRMATION_KEY = {
	BRIEF_READ: 'briefRead',
	RUN_OVERVIEW: 'runOverview',
	TUBS_LOADED: 'tubsLoaded',
	PICK_TOP_UP_NOT_NEEDED: 'pickTopUpNotNeeded',
	ACCESS_KEYS: 'accessKeys',
	TICKETS_SUMMARY: 'ticketsSummary',
	SERVICE_RUN_STARTED: 'serviceRunStarted',
	MONEY_BAGS: 'moneyBags',
	RETURN_KEYS: 'returnKeys',
	RETURN_STOCK: 'returnStock',
};

export const PEOPLE_UNAVAILABILITY_KIND = {
	UNAVAILABLE: 1,
	LEAVE: 2,
};

export const PEOPLE_UNAVAILABILITY_KIND_NAMES = {
	[PEOPLE_UNAVAILABILITY_KIND.UNAVAILABLE]: 'Unavailable',
	[PEOPLE_UNAVAILABILITY_KIND.LEAVE]: 'Leave',
};

// Unavailability is usually auto-approved; casual requests that conflict with assigned shifts need approval.
export const PEOPLE_UNAVAILABILITY_STATUS = {
	PENDING: 1,
	APPROVED: 2,
	DECLINED: 3,
};

export const PEOPLE_UNAVAILABILITY_STATUS_NAMES = {
	[PEOPLE_UNAVAILABILITY_STATUS.PENDING]: 'Pending',
	[PEOPLE_UNAVAILABILITY_STATUS.APPROVED]: 'Approved',
	[PEOPLE_UNAVAILABILITY_STATUS.DECLINED]: 'Declined',
};

export const PEOPLE_WORK_STATUS_ERROR_CODE = {
	DECISION_CONFLICT: 'PEOPLE_WORK_STATUS_DECISION_CONFLICT',
};

export const PEOPLE_DOCUMENT_STAGE = {
	ONBOARDING: 1,
	ONGOING: 2,
	BOTH: 3,
};

export const PEOPLE_DOCUMENT_STAGE_NAMES = {
	[PEOPLE_DOCUMENT_STAGE.ONBOARDING]: 'Onboarding',
	[PEOPLE_DOCUMENT_STAGE.ONGOING]: 'Ongoing',
	[PEOPLE_DOCUMENT_STAGE.BOTH]: 'Both',
};

export const PEOPLE_DOCUMENT_CADENCE = {
	ONCE: 1,
	PER_VERSION: 2,
	EVERY_X_DAYS: 3,
	MAINTAIN_VALID: 4,
};

export const PEOPLE_DOCUMENT_CADENCE_NAMES = {
	[PEOPLE_DOCUMENT_CADENCE.ONCE]: 'Once',
	[PEOPLE_DOCUMENT_CADENCE.PER_VERSION]: 'Per version',
	[PEOPLE_DOCUMENT_CADENCE.EVERY_X_DAYS]: 'Every X days',
	[PEOPLE_DOCUMENT_CADENCE.MAINTAIN_VALID]: 'Maintain valid',
};

export const PEOPLE_DOCUMENT_ASSIGNMENT_STATUS = {
	REQUIRED: 1,
	COMPLETE: 2,
	OVERDUE: 3,
	WAIVED: 4,
	OPTIONAL: 5,
};

export const PEOPLE_DOCUMENT_ASSIGNMENT_STATUS_NAMES = {
	[PEOPLE_DOCUMENT_ASSIGNMENT_STATUS.REQUIRED]: 'Required',
	[PEOPLE_DOCUMENT_ASSIGNMENT_STATUS.COMPLETE]: 'Complete',
	[PEOPLE_DOCUMENT_ASSIGNMENT_STATUS.OVERDUE]: 'Overdue',
	[PEOPLE_DOCUMENT_ASSIGNMENT_STATUS.WAIVED]: 'No longer required',
	[PEOPLE_DOCUMENT_ASSIGNMENT_STATUS.OPTIONAL]: 'Optional',
};

export const PEOPLE_DOCUMENT_ASSIGNMENT_SOURCE = {
	REQUIREMENT: 1,
	ISSUE: 2,
};

export const PEOPLE_DOCUMENT_ASSIGNMENT_SOURCE_NAMES = {
	[PEOPLE_DOCUMENT_ASSIGNMENT_SOURCE.REQUIREMENT]: 'Requirement',
	[PEOPLE_DOCUMENT_ASSIGNMENT_SOURCE.ISSUE]: 'Issue',
};

export const PEOPLE_TRAINING_STAGE = {
	ONBOARDING: 1,
	ONGOING: 2,
	BOTH: 3,
};

export const PEOPLE_TRAINING_STAGE_NAMES = {
	[PEOPLE_TRAINING_STAGE.ONBOARDING]: 'Onboarding',
	[PEOPLE_TRAINING_STAGE.ONGOING]: 'Ongoing',
	[PEOPLE_TRAINING_STAGE.BOTH]: 'Both',
};

export const PEOPLE_TRAINING_CADENCE = {
	ONCE: 1,
	PER_VERSION: 2,
	EVERY_X_DAYS: 3,
};

export const PEOPLE_TRAINING_CADENCE_NAMES = {
	[PEOPLE_TRAINING_CADENCE.ONCE]: 'Once',
	[PEOPLE_TRAINING_CADENCE.PER_VERSION]: 'Per version',
	[PEOPLE_TRAINING_CADENCE.EVERY_X_DAYS]: 'Every X days',
};

export const PEOPLE_TRAINING_MODULE_TYPE = {
	PRACTICAL: 'practical',
	SLIDES: 'slides',
	RICH_TEXT: 'richText',
	PDF: 'pdf',
};

export const PEOPLE_TRAINING_MODULE_TYPE_NAMES = {
	[PEOPLE_TRAINING_MODULE_TYPE.PRACTICAL]: 'Practical training',
	[PEOPLE_TRAINING_MODULE_TYPE.SLIDES]: 'Slides',
	[PEOPLE_TRAINING_MODULE_TYPE.RICH_TEXT]: 'RTE',
	[PEOPLE_TRAINING_MODULE_TYPE.PDF]: 'PDF',
};

export const PEOPLE_TRAINING_PRACTICAL_OUTCOME = {
	COMPETENT: 'competent',
	NEEDS_FOLLOW_UP: 'needsFollowUp',
};

export const PEOPLE_TRAINING_PRACTICAL_OUTCOME_NAMES = {
	[PEOPLE_TRAINING_PRACTICAL_OUTCOME.COMPETENT]: 'Competent',
	[PEOPLE_TRAINING_PRACTICAL_OUTCOME.NEEDS_FOLLOW_UP]: 'Needs follow-up',
};

export const PEOPLE_TRAINING_ASSIGNMENT_STATUS = {
	REQUIRED: 1,
	IN_PROGRESS: 2,
	SUBMITTED_PENDING_REVIEW: 3,
	PASSED: 4,
	FAILED_REQUIRES_IN_PERSON: 5,
	COMPLETED_IN_PERSON: 6,
	OVERDUE: 7,
	WAIVED: 8,
	FAILED_RETRY_AVAILABLE: 9,
	REISSUED: 10,
};

export const PEOPLE_TRAINING_ASSIGNMENT_STATUS_NAMES = {
	[PEOPLE_TRAINING_ASSIGNMENT_STATUS.REQUIRED]: 'Required',
	[PEOPLE_TRAINING_ASSIGNMENT_STATUS.IN_PROGRESS]: 'In progress',
	[PEOPLE_TRAINING_ASSIGNMENT_STATUS.SUBMITTED_PENDING_REVIEW]: 'Submitted pending review',
	[PEOPLE_TRAINING_ASSIGNMENT_STATUS.PASSED]: 'Passed',
	[PEOPLE_TRAINING_ASSIGNMENT_STATUS.FAILED_REQUIRES_IN_PERSON]: 'Failed - requires in-person',
	[PEOPLE_TRAINING_ASSIGNMENT_STATUS.COMPLETED_IN_PERSON]: 'Completed in-person',
	[PEOPLE_TRAINING_ASSIGNMENT_STATUS.OVERDUE]: 'Overdue',
	[PEOPLE_TRAINING_ASSIGNMENT_STATUS.WAIVED]: 'Waived',
	[PEOPLE_TRAINING_ASSIGNMENT_STATUS.FAILED_RETRY_AVAILABLE]: 'Failed - retry available',
	[PEOPLE_TRAINING_ASSIGNMENT_STATUS.REISSUED]: 'Re-issued',
};

// Assignment statuses that still need employee action. Shared by the phone app training
// badges and pointer, matching the employee-facing outstanding set used by People:
// resolved attempts (passed, completed in person, waived, submitted for review) are excluded.
export const PEOPLE_TRAINING_OUTSTANDING_STATUSES = [
	PEOPLE_TRAINING_ASSIGNMENT_STATUS.REQUIRED,
	PEOPLE_TRAINING_ASSIGNMENT_STATUS.IN_PROGRESS,
	PEOPLE_TRAINING_ASSIGNMENT_STATUS.OVERDUE,
	PEOPLE_TRAINING_ASSIGNMENT_STATUS.FAILED_REQUIRES_IN_PERSON,
	PEOPLE_TRAINING_ASSIGNMENT_STATUS.FAILED_RETRY_AVAILABLE,
];

// Aggregated per employee × module statuses shown on the training matrix.
// EXPIRED is reserved for future expiry/re-do support and is not produced yet.
export const PEOPLE_TRAINING_MATRIX_STATUS = {
	COMPLETE: 1,
	NOT_DONE: 2,
	EXPIRED: 3,
	NOT_APPLICABLE: 4,
	WAIVED: 5,
};

export const PEOPLE_TRAINING_MATRIX_STATUS_NAMES = {
	[PEOPLE_TRAINING_MATRIX_STATUS.COMPLETE]: 'Complete',
	[PEOPLE_TRAINING_MATRIX_STATUS.NOT_DONE]: 'Not done',
	[PEOPLE_TRAINING_MATRIX_STATUS.EXPIRED]: 'Expired',
	[PEOPLE_TRAINING_MATRIX_STATUS.NOT_APPLICABLE]: 'Not applicable',
	[PEOPLE_TRAINING_MATRIX_STATUS.WAIVED]: 'Waived',
};

export const PEOPLE_TRAINING_REVIEW_STATUS = {
	NOT_REQUIRED: 1,
	PENDING: 2,
	REVIEWED_PASSED: 3,
	REVIEWED_FAILED: 4,
};

export const PEOPLE_TRAINING_REVIEW_STATUS_NAMES = {
	[PEOPLE_TRAINING_REVIEW_STATUS.NOT_REQUIRED]: 'Not required',
	[PEOPLE_TRAINING_REVIEW_STATUS.PENDING]: 'Pending',
	[PEOPLE_TRAINING_REVIEW_STATUS.REVIEWED_PASSED]: 'Reviewed passed',
	[PEOPLE_TRAINING_REVIEW_STATUS.REVIEWED_FAILED]: 'Reviewed failed',
};

// Stored on free-text training answers that have an AI marking suggestion.
export const PEOPLE_TRAINING_AI_GRADING_STATUS = {
	SUGGESTED: 'suggested',
	FAILED: 'failed',
};

export const PEOPLE_TRAINING_SCHEDULE_TRIGGER = {
	ON_COMMENCEMENT: 1,
	DAYS_AFTER_COMMENCEMENT: 2,
	YEARLY: 3,
};

export const PEOPLE_TRAINING_SCHEDULE_TRIGGER_NAMES = {
	[PEOPLE_TRAINING_SCHEDULE_TRIGGER.ON_COMMENCEMENT]: 'On employment commencement date',
	[PEOPLE_TRAINING_SCHEDULE_TRIGGER.DAYS_AFTER_COMMENCEMENT]: 'X days after employment commencement date',
	[PEOPLE_TRAINING_SCHEDULE_TRIGGER.YEARLY]: 'On a specific day every year',
};

export const PEOPLE_TRAINING_SCHEDULE_RUN_RESULT = {
	ASSIGNED: 1,
	SKIPPED: 2,
	FAILED: 3,
};

export const PEOPLE_TRAINING_SCHEDULE_RUN_RESULT_NAMES = {
	[PEOPLE_TRAINING_SCHEDULE_RUN_RESULT.ASSIGNED]: 'Assigned',
	[PEOPLE_TRAINING_SCHEDULE_RUN_RESULT.SKIPPED]: 'Skipped',
	[PEOPLE_TRAINING_SCHEDULE_RUN_RESULT.FAILED]: 'Failed',
};

// -1 means the last occurrence of the weekday in the month.
export const PEOPLE_TRAINING_SCHEDULE_WEEKDAY_OCCURRENCE_NAMES = {
	1: 'First',
	2: 'Second',
	3: 'Third',
	4: 'Fourth',
	[-1]: 'Last',
};

export const PEOPLE_COMPANY_DOCUMENT_CATEGORY = {
	CONTRACT: 1,
	ONBOARDING_FORM: 2,
	POLICY: 3,
	PROCEDURE: 4,
	TEMPLATE: 5,
	POSITION_DESCRIPTION: 6,
};

export const PEOPLE_COMPANY_DOCUMENT_CATEGORY_NAMES = {
	1: 'Contract',
	2: 'Form',
	3: 'Policy',
	4: 'Procedure',
	5: 'Template',
	6: 'Position description',
};

export const PEOPLE_EMPLOYEE_EVENT_TYPE = {
	INJURY: 1,
	// Incident and Note are retired categories kept only so older events still display.
	INCIDENT: 2,
	NOTE: 3,
	OTHER: 4,
	MEDICAL: 5,
	EMPLOYMENT_CHANGE: 6,
	// Value 7 was the "Event" category created for performance records.
	PERFORMANCE: 7,
	HAZARD: 8,
	PROPERTY_DAMAGE: 9,
	MISCONDUCT: 10,
	GRIEVANCE: 11,
	MEETING: 12,
	LEAVE_ATTENDANCE: 13,
	RETURN_TO_WORK: 14,
	RECOGNITION: 15,
};

export const PEOPLE_EMPLOYEE_EVENT_TYPE_NAMES = {
	1: 'Injury / first aid',
	2: 'Incident',
	3: 'Note',
	4: 'Other',
	5: 'Medical / health',
	6: 'Employment change',
	7: 'Performance / conduct',
	8: 'Hazard / near miss / safety',
	9: 'Property / equipment damage',
	10: 'Misconduct / policy breach',
	11: 'Employee complaint / grievance',
	12: 'Meeting / discussion',
	13: 'Leave / attendance',
	14: 'Return to work / injury management',
	15: 'Recognition / positive feedback',
};

// Categories offered for new events, in the order People managers asked for.
export const PEOPLE_EMPLOYEE_EVENT_SELECTABLE_TYPES = [
	PEOPLE_EMPLOYEE_EVENT_TYPE.INJURY,
	PEOPLE_EMPLOYEE_EVENT_TYPE.HAZARD,
	PEOPLE_EMPLOYEE_EVENT_TYPE.PROPERTY_DAMAGE,
	PEOPLE_EMPLOYEE_EVENT_TYPE.PERFORMANCE,
	PEOPLE_EMPLOYEE_EVENT_TYPE.MISCONDUCT,
	PEOPLE_EMPLOYEE_EVENT_TYPE.GRIEVANCE,
	PEOPLE_EMPLOYEE_EVENT_TYPE.MEETING,
	PEOPLE_EMPLOYEE_EVENT_TYPE.MEDICAL,
	PEOPLE_EMPLOYEE_EVENT_TYPE.LEAVE_ATTENDANCE,
	PEOPLE_EMPLOYEE_EVENT_TYPE.RETURN_TO_WORK,
	PEOPLE_EMPLOYEE_EVENT_TYPE.EMPLOYMENT_CHANGE,
	PEOPLE_EMPLOYEE_EVENT_TYPE.RECOGNITION,
	PEOPLE_EMPLOYEE_EVENT_TYPE.OTHER,
];

export const PEOPLE_EMPLOYEE_EVENT_TYPE_PROMPTS = {
	[PEOPLE_EMPLOYEE_EVENT_TYPE.INJURY]: 'Record any workplace injury, illness, first aid treatment or injury requiring medical attention. Include what happened, when and where it occurred, any treatment provided and any follow-up required.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.HAZARD]: 'Record any workplace hazard, unsafe condition, near miss or safety concern that could cause injury, illness or damage. Include what was identified and any action taken to reduce the risk.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.PROPERTY_DAMAGE]: 'Record any damage to company vehicles, equipment, property, vending machines or other assets. Include what was damaged, what happened and any action or follow-up required.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.PERFORMANCE]: 'Record performance or workplace conduct concerns, including coaching, performance discussions, repeated issues or expectations that have not been met. Include specific facts, examples and any agreed actions.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.MISCONDUCT]: 'Record any suspected or confirmed breach of company policies, procedures, workplace standards or expected behaviour. Record the facts, policy or standard involved and any action or follow-up required.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.GRIEVANCE]: 'Record an employee concern, complaint or grievance regarding their workplace, treatment, working environment or another team member. Record the concern objectively, including relevant facts and any follow-up required.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.MEETING]: 'Record an important employee meeting or discussion that should be documented for future reference. Include the purpose of the discussion, key points raised, any decisions made and agreed actions.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.MEDICAL]: 'Record relevant medical or health information provided by the employee, such as medical certificates, work restrictions, fitness-for-work information or recommended workplace adjustments. Only record information necessary for employment purposes.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.LEAVE_ATTENDANCE]: 'Record significant attendance or leave-related matters, including unexplained absences, repeated lateness, attendance concerns or discussions regarding leave requirements. Include relevant dates and any agreed follow-up.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.RETURN_TO_WORK]: 'Record information relating to an employee\'s return to work following injury or illness, including medical restrictions, suitable duties, workplace adjustments, return-to-work plans and follow-up actions.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.EMPLOYMENT_CHANGE]: 'Record a change to the employee\'s employment, including promotions, transfers, secondments, changes to role, salary, employment status, hours or other significant employment conditions.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.RECOGNITION]: 'Record positive feedback, recognition, achievements or examples of the employee demonstrating company values, strong performance or a positive contribution to the team.',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.OTHER]: 'Record any important employee-related matter that does not fit within the categories above. Provide enough detail to clearly explain what occurred and any action or follow-up required.',
};

export const PEOPLE_EMPLOYEE_EVENT_REVIEW_STATUS = {
	PENDING: 1,
	REVIEWED: 2,
};

export const PEOPLE_EMPLOYEE_EVENT_REVIEW_STATUS_NAMES = {
	[PEOPLE_EMPLOYEE_EVENT_REVIEW_STATUS.PENDING]: 'Pending',
	[PEOPLE_EMPLOYEE_EVENT_REVIEW_STATUS.REVIEWED]: 'Reviewed',
};

export const PEOPLE_EMPLOYEE_EVENT_REVIEW_REQUIRED_TYPES = [
	PEOPLE_EMPLOYEE_EVENT_TYPE.INJURY,
	PEOPLE_EMPLOYEE_EVENT_TYPE.INCIDENT,
	PEOPLE_EMPLOYEE_EVENT_TYPE.HAZARD,
	PEOPLE_EMPLOYEE_EVENT_TYPE.PROPERTY_DAMAGE,
];

// Event types employees may self-report from My account; other types are admin record-keeping.
// Hazard and property damage replace the retired Incident category.
export const PEOPLE_EMPLOYEE_EVENT_SELF_REPORT_TYPES = [
	PEOPLE_EMPLOYEE_EVENT_TYPE.INJURY,
	PEOPLE_EMPLOYEE_EVENT_TYPE.HAZARD,
	PEOPLE_EMPLOYEE_EVENT_TYPE.PROPERTY_DAMAGE,
	PEOPLE_EMPLOYEE_EVENT_TYPE.OTHER,
];

// Tenant settings fields holding the default reviewer per review-required event type.
// Hazard and property damage share the incident reviewer they had as Incident events.
export const PEOPLE_EMPLOYEE_EVENT_DEFAULT_REVIEWER_SETTINGS_FIELDS = {
	[PEOPLE_EMPLOYEE_EVENT_TYPE.INJURY]: 'peopleDefaultInjuryEventReviewer',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.INCIDENT]: 'peopleDefaultIncidentEventReviewer',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.HAZARD]: 'peopleDefaultIncidentEventReviewer',
	[PEOPLE_EMPLOYEE_EVENT_TYPE.PROPERTY_DAMAGE]: 'peopleDefaultIncidentEventReviewer',
};

export const PEOPLE_EMPLOYEE_WARNING_TYPE = {
	VERBAL: 1,
	WRITTEN: 2,
	FINAL: 3,
};

export const PEOPLE_EMPLOYEE_WARNING_TYPE_NAMES = {
	[PEOPLE_EMPLOYEE_WARNING_TYPE.VERBAL]: 'Verbal',
	[PEOPLE_EMPLOYEE_WARNING_TYPE.WRITTEN]: 'Written',
	[PEOPLE_EMPLOYEE_WARNING_TYPE.FINAL]: 'Final',
};

export const PEOPLE_EMPLOYEE_WARNING_STATUS = {
	DRAFT: 1,
	ISSUED: 2,
};

export const PEOPLE_EMPLOYEE_WARNING_STATUS_NAMES = {
	[PEOPLE_EMPLOYEE_WARNING_STATUS.DRAFT]: 'Draft',
	[PEOPLE_EMPLOYEE_WARNING_STATUS.ISSUED]: 'Issued',
};

export const PEOPLE_VEHICLE_FINE_STATUS = {
	LOGGED: 1,
	NOMINATED: 2,
	PAID: 3,
	CANCELLED: 4,
};

export const PEOPLE_VEHICLE_FINE_STATUS_NAMES = {
	[PEOPLE_VEHICLE_FINE_STATUS.LOGGED]: 'Logged',
	[PEOPLE_VEHICLE_FINE_STATUS.NOMINATED]: 'Nominated',
	[PEOPLE_VEHICLE_FINE_STATUS.PAID]: 'Paid',
	[PEOPLE_VEHICLE_FINE_STATUS.CANCELLED]: 'Cancelled',
};

export const PEOPLE_PERFORMANCE_REVIEW_TYPE = {
	PROBATION: 1,
	PERFORMANCE_IMPROVEMENT_PLAN: 2,
};

export const PEOPLE_PERFORMANCE_REVIEW_TYPE_NAMES = {
	[PEOPLE_PERFORMANCE_REVIEW_TYPE.PROBATION]: 'Probation review',
	[PEOPLE_PERFORMANCE_REVIEW_TYPE.PERFORMANCE_IMPROVEMENT_PLAN]: 'Performance improvement plan',
};

export const PEOPLE_PROBATION_REVIEW_MONTHS = {
	THREE_MONTH: 3,
	SIX_MONTH: 6,
};

export const PEOPLE_PROBATION_REVIEW_MONTH_OPTIONS = [
	PEOPLE_PROBATION_REVIEW_MONTHS.THREE_MONTH,
	PEOPLE_PROBATION_REVIEW_MONTHS.SIX_MONTH,
];

export const PEOPLE_PROBATION_REVIEW_NAMES = {
	[PEOPLE_PROBATION_REVIEW_MONTHS.THREE_MONTH]: '3-month probation review',
	[PEOPLE_PROBATION_REVIEW_MONTHS.SIX_MONTH]: '6-month probation review',
};

export const PEOPLE_PROBATION_REVIEW_FORM_TEMPLATE_TITLES = {
	[PEOPLE_PROBATION_REVIEW_MONTHS.THREE_MONTH]: '3 month probation form',
	[PEOPLE_PROBATION_REVIEW_MONTHS.SIX_MONTH]: '6 month probation form',
};

export const PEOPLE_PERFORMANCE_IMPROVEMENT_PLAN_REVIEW_PERIOD = {
	ONE_MONTH: 1,
	TWO_MONTHS: 2,
	THREE_MONTHS: 3,
};

export const PEOPLE_PERFORMANCE_IMPROVEMENT_PLAN_REVIEW_PERIOD_OPTIONS = [
	PEOPLE_PERFORMANCE_IMPROVEMENT_PLAN_REVIEW_PERIOD.ONE_MONTH,
	PEOPLE_PERFORMANCE_IMPROVEMENT_PLAN_REVIEW_PERIOD.TWO_MONTHS,
	PEOPLE_PERFORMANCE_IMPROVEMENT_PLAN_REVIEW_PERIOD.THREE_MONTHS,
];

export const PEOPLE_PERFORMANCE_IMPROVEMENT_PLAN_REVIEW_PERIOD_NAMES = {
	[PEOPLE_PERFORMANCE_IMPROVEMENT_PLAN_REVIEW_PERIOD.ONE_MONTH]: '1 month',
	[PEOPLE_PERFORMANCE_IMPROVEMENT_PLAN_REVIEW_PERIOD.TWO_MONTHS]: '2 months',
	[PEOPLE_PERFORMANCE_IMPROVEMENT_PLAN_REVIEW_PERIOD.THREE_MONTHS]: '3 months',
};

export const PEOPLE_PERFORMANCE_IMPROVEMENT_PLAN_FORM_TEMPLATE_TITLE = 'Performance improvement plan form';

export const PEOPLE_PERFORMANCE_REVIEW_STATUS = {
	DRAFT: 1,
	COMPLETED: 2,
	IN_PROGRESS: 3,
};

export const PEOPLE_PERFORMANCE_REVIEW_STATUS_NAMES = {
	[PEOPLE_PERFORMANCE_REVIEW_STATUS.DRAFT]: 'Draft',
	[PEOPLE_PERFORMANCE_REVIEW_STATUS.COMPLETED]: 'Completed',
	[PEOPLE_PERFORMANCE_REVIEW_STATUS.IN_PROGRESS]: 'In progress',
};

export const PEOPLE_PERFORMANCE_REVIEW_OUTCOME = {
	PASS: 1,
	IMPROVEMENT_REQUIRED: 2,
	TERMINATE: 3,
};

export const PEOPLE_PERFORMANCE_REVIEW_OUTCOME_NAMES = {
	[PEOPLE_PERFORMANCE_REVIEW_OUTCOME.PASS]: 'Pass',
	[PEOPLE_PERFORMANCE_REVIEW_OUTCOME.IMPROVEMENT_REQUIRED]: 'Improvement required',
	[PEOPLE_PERFORMANCE_REVIEW_OUTCOME.TERMINATE]: 'Terminate',
};

export const PEOPLE_ANNOUNCEMENT_TYPE = {
	GENERAL: 1,
	BIRTHDAY: 2,
};

export const PEOPLE_ANNOUNCEMENT_TYPE_NAMES = {
	[PEOPLE_ANNOUNCEMENT_TYPE.GENERAL]: 'General',
	[PEOPLE_ANNOUNCEMENT_TYPE.BIRTHDAY]: 'Birthday',
};

// Employee document categories (phase 1): stored as strings to keep the list flexible while
// allowing system-generated categories (e.g. event attachments) to render nicely.
export const PEOPLE_EMPLOYEE_DOCUMENT_CATEGORY = {
	EVENT_ATTACHMENT: 'eventAttachment',
	RESUME: 'resume',
	COVER_LETTER: 'coverLetter',
};

export const PEOPLE_EMPLOYEE_DOCUMENT_CATEGORY_NAMES = {
	[PEOPLE_EMPLOYEE_DOCUMENT_CATEGORY.EVENT_ATTACHMENT]: 'Event attachment',
	[PEOPLE_EMPLOYEE_DOCUMENT_CATEGORY.RESUME]: 'Resume',
	[PEOPLE_EMPLOYEE_DOCUMENT_CATEGORY.COVER_LETTER]: 'Cover letter',
};

// People access roles (phase 1): stable keys used by People app access management.
export const PEOPLE_ACCESS_ROLE_KEY = {
	ADMIN: 'ADMIN',
	USER: 'USER',
};

// User-facing labels shown in the People app.
export const PEOPLE_ACCESS_ROLE_LABELS = {
	[PEOPLE_ACCESS_ROLE_KEY.ADMIN]: 'Admin',
	[PEOPLE_ACCESS_ROLE_KEY.USER]: 'User',
};

// Internal role names stored in the Roles collection (kept distinct from Web/Link roles).
export const PEOPLE_ACCESS_ROLE_DB_NAMES = {
	[PEOPLE_ACCESS_ROLE_KEY.ADMIN]: 'People admin',
	[PEOPLE_ACCESS_ROLE_KEY.USER]: 'People employee',
};

export const PEOPLE_ACCESS_RESERVED_ROLE_NAMES = [
	'Super admin',
];

export const CLIENT_SECURED_LOCATION_STATUS = {
	PENDING_REVIEW: 1,
	CONFIRMED: 2,
	REJECTED: 3,
};

export const CLIENT_SECURED_LOCATION_STATUS_NAMES = {
	[CLIENT_SECURED_LOCATION_STATUS.PENDING_REVIEW]: 'Pending review',
	[CLIENT_SECURED_LOCATION_STATUS.CONFIRMED]: 'Confirmed',
	[CLIENT_SECURED_LOCATION_STATUS.REJECTED]: 'Rejected',
};

export const CLIENT_LEAD_STATUS = {
	NEW_LEAD: 1,
	CONTACTED: 2,
	HOT_LEAD: 3,
	WARM_LEAD: 4,
	COLD_LEAD: 5,
	DEAD_LEAD: 6,
	SECURED_AS_CLIENT: 7,
	ISSUE_NOT_A_LEAD: 8,
	ON_PAUSE: 9,
};

export const CLIENT_LEAD_STATUS_NAMES = {
	[CLIENT_LEAD_STATUS.NEW_LEAD]: 'New lead',
	[CLIENT_LEAD_STATUS.CONTACTED]: 'Contacted',
	[CLIENT_LEAD_STATUS.HOT_LEAD]: 'Hot lead',
	[CLIENT_LEAD_STATUS.WARM_LEAD]: 'Warm lead',
	[CLIENT_LEAD_STATUS.COLD_LEAD]: 'Cold lead',
	[CLIENT_LEAD_STATUS.DEAD_LEAD]: 'Dead lead',
	[CLIENT_LEAD_STATUS.SECURED_AS_CLIENT]: 'Secured as client',
	[CLIENT_LEAD_STATUS.ISSUE_NOT_A_LEAD]: 'Issue (not a lead)',
	[CLIENT_LEAD_STATUS.ON_PAUSE]: 'On pause',
};

export const CLIENT_LEAD_STATUS_ORDER = [
	CLIENT_LEAD_STATUS.NEW_LEAD,
	CLIENT_LEAD_STATUS.CONTACTED,
	CLIENT_LEAD_STATUS.HOT_LEAD,
	CLIENT_LEAD_STATUS.WARM_LEAD,
	CLIENT_LEAD_STATUS.COLD_LEAD,
	CLIENT_LEAD_STATUS.ON_PAUSE,
	CLIENT_LEAD_STATUS.DEAD_LEAD,
	CLIENT_LEAD_STATUS.SECURED_AS_CLIENT,
	CLIENT_LEAD_STATUS.ISSUE_NOT_A_LEAD,
];

export const CLIENT_LEAD_TYPE = {
	SALES_LEAD: 1,
	ISSUE: 2,
	OTHER: 3,
};

export const CLIENT_LEAD_TYPE_NAMES = {
	[CLIENT_LEAD_TYPE.SALES_LEAD]: 'Sales lead',
	[CLIENT_LEAD_TYPE.ISSUE]: 'Issue',
	[CLIENT_LEAD_TYPE.OTHER]: 'Other',
};

export const CLIENT_LEAD_SOURCE = {
	MANUAL_ENTRY: 1,
	WEBSITE_INQUIRY: 2,
	PHONE_CALL_INQUIRY: 3,
	REFERRAL: 4,
	EVENT_EXPO: 5,
	LINKEDIN_POST: 6,
	COLD_CALL: 7,
};

export const CLIENT_LEAD_SOURCE_NAMES = {
	[CLIENT_LEAD_SOURCE.MANUAL_ENTRY]: 'Manual entry',
	[CLIENT_LEAD_SOURCE.WEBSITE_INQUIRY]: 'Website inquiry',
	[CLIENT_LEAD_SOURCE.PHONE_CALL_INQUIRY]: 'Phone call inquiry',
	[CLIENT_LEAD_SOURCE.REFERRAL]: 'Referral',
	[CLIENT_LEAD_SOURCE.EVENT_EXPO]: 'Event/expo',
	[CLIENT_LEAD_SOURCE.LINKEDIN_POST]: 'LinkedIn post',
	[CLIENT_LEAD_SOURCE.COLD_CALL]: 'Cold call',
};

export const CLIENT_LEAD_STATE = {
	NATIONAL_MULTIPLE_STATES: 'National / Multiple states',
};

export const CLIENT_LEAD_WEBSITE = {
	AVC: 1,
	VENDY: 2,
	AGORA_MARKETS: 3,
	MELBOURNE_VENDING_CO: 4,
};

export const CLIENT_LEAD_WEBSITE_NAMES = {
	[CLIENT_LEAD_WEBSITE.AVC]: 'AVC',
	[CLIENT_LEAD_WEBSITE.VENDY]: 'Vendy',
	[CLIENT_LEAD_WEBSITE.AGORA_MARKETS]: 'Agora markets',
	[CLIENT_LEAD_WEBSITE.MELBOURNE_VENDING_CO]: 'Melbourne Vending Co',
};

export const WEBSITE_ENQUIRY_INTENT = {
	SALES: 'sales',
	SUPPORT: 'support',
	GENERAL: 'general',
};

export const WEBSITE_ENQUIRY_INTENT_NAMES = {
	[WEBSITE_ENQUIRY_INTENT.SALES]: 'Sales',
	[WEBSITE_ENQUIRY_INTENT.SUPPORT]: 'Support',
	[WEBSITE_ENQUIRY_INTENT.GENERAL]: 'General',
};

export const WEBSITE_ENQUIRY_ORIGIN = {
	AVC: 'avc',
	VENDY: 'vendy',
	AGORA_MARKETS: 'agora_markets',
	MELBOURNE_VENDING_CO: 'melbourne_vending_co',
};

export const WEBSITE_ENQUIRY_ORIGIN_NAMES = {
	[WEBSITE_ENQUIRY_ORIGIN.AVC]: 'AVC',
	[WEBSITE_ENQUIRY_ORIGIN.VENDY]: 'Vendy',
	[WEBSITE_ENQUIRY_ORIGIN.AGORA_MARKETS]: 'Agora markets',
	[WEBSITE_ENQUIRY_ORIGIN.MELBOURNE_VENDING_CO]: 'Melbourne Vending Co',
};

export const WEBSITE_ENQUIRY_STATUS = {
	NEW: 1,
	IN_REVIEW: 2,
	CONVERTED_TO_TICKET: 3,
	RESOLVED: 4,
	SPAM: 5,
};

export const WEBSITE_ENQUIRY_STATUS_NAMES = {
	[WEBSITE_ENQUIRY_STATUS.NEW]: 'New',
	[WEBSITE_ENQUIRY_STATUS.IN_REVIEW]: 'In review',
	[WEBSITE_ENQUIRY_STATUS.CONVERTED_TO_TICKET]: 'Converted to ticket',
	[WEBSITE_ENQUIRY_STATUS.RESOLVED]: 'Resolved',
	[WEBSITE_ENQUIRY_STATUS.SPAM]: 'Spam',
};

export const WEBSITE_ENQUIRY_SUPPORT_CATEGORY = {
	PAYMENT_NO_VEND: 'payment_no_vend',
	ITEM_STUCK: 'item_stuck',
	CARD_READER: 'card_reader',
	CASH_OR_CHANGE: 'cash_or_change',
	PRODUCT_QUALITY: 'product_quality',
	MACHINE_FAULT: 'machine_fault',
	CHARGED_INCORRECTLY: 'charged_incorrectly',
	ITEM_WONT_SCAN: 'item_wont_scan',
	KIOSK_FAULT: 'kiosk_fault',
	APP_ISSUE: 'app_issue',
	REFUND: 'refund',
	OTHER: 'other',
};

export const WEBSITE_ENQUIRY_SUPPORT_CATEGORY_NAMES = {
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.PAYMENT_NO_VEND]: 'Payment taken but item not received',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.ITEM_STUCK]: 'Item is stuck',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.CARD_READER]: 'Card reader or payment problem',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.CASH_OR_CHANGE]: 'Coin, note or change problem',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.PRODUCT_QUALITY]: 'Product quality or expired product',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.MACHINE_FAULT]: 'Machine not working, cooling or powered',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.CHARGED_INCORRECTLY]: 'Charged incorrectly or double charged',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.ITEM_WONT_SCAN]: 'Item won\'t scan or shows no price',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.KIOSK_FAULT]: 'Kiosk, fridge or freezer not working',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.APP_ISSUE]: 'App or account problem',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.REFUND]: 'Refund question',
	[WEBSITE_ENQUIRY_SUPPORT_CATEGORY.OTHER]: 'Other issue',
};

export const CLIENT_LEAD_DEAD_REASON = {
	PRICES_TOO_HIGH: 1,
	COMMISSION_TOO_LOW: 2,
	PRODUCT_OFFERING_INCOMPLETE: 3,
	DOES_NOT_QUALIFY: 4,
	OTHER: 5,
};

export const CLIENT_LEAD_DEAD_REASON_NAMES = {
	[CLIENT_LEAD_DEAD_REASON.PRICES_TOO_HIGH]: 'Prices offered too high',
	[CLIENT_LEAD_DEAD_REASON.COMMISSION_TOO_LOW]: 'Commission offered not high enough',
	[CLIENT_LEAD_DEAD_REASON.PRODUCT_OFFERING_INCOMPLETE]: 'Product offering not complete',
	[CLIENT_LEAD_DEAD_REASON.DOES_NOT_QUALIFY]: 'Doesn\'t qualify (too small, too far away, etc)',
	[CLIENT_LEAD_DEAD_REASON.OTHER]: 'Other',
};

export const OMNIBAR_ITEM_TYPE = {
	MACHINE: 1,
	PRODUCT: 2,
	LOCATION: 3,
	CLIENT: 4,
	ROUTE: 5,
	PLANOGRAM: 6,

	PAGE: 7,

	TICKET: 8,
	PERSON: 9,
	USER: 10,
	MARKET: 11,
	COMM_DEVICE: 12,
	VEHICLE: 13,
	LEAD: 14,
	EMPLOYEE: 15,
	COMPANY_DOCUMENT: 16,
	EMPLOYEE_DOCUMENT: 17,
	TRAINING_MODULE: 18,
	EMPLOYEE_POSITION: 19,
};

export const PAYMENT_METHOD = {
	CASH: 1,
	CREDIT_CARD: 2,
	APPLE_PAY: 3,
	GOOGLE_PAY: 4,
	CASH_BALANCE: 5,
	POINT_BALANCE: 6,
	FREE: 7,
};

export const PAYMENT_METHOD_NAME = {
	1: 'Cash',
	2: 'Credit card',
	3: 'Apple pay',
	4: 'Google pay',
	5: 'Cash balance',
	6: 'Point balance',
	7: 'Free',
};

export const BALANCE_TYPE = {
	CASH: 1,
	POINTS: 2,
};

export const BALANCE_TYPE_NAMES = {
	1: 'Cash',
	2: 'Points',
};

export const BALANCE_TRANSACTION_TYPE = {
	EARNED: 1,
	SPENT: 2,
	EXPIRED: 3,
	ADJUSTMENT: 4,
};

export const BALANCE_TRANSACTION_TYPE_NAMES = {
	1: 'Earned',
	2: 'Spent',
	3: 'Expired',
	4: 'Adjustment',
};

export const BALANCE_TRANSACTION_SOURCE = {
	// Points sources
	BIRTHDAY: 1,
	CLIENT_SUBSIDY: 2,
	MANUAL_ADJUSTMENT: 3,

	// Cash sources
	TOPUP: 10,
	REFUND: 11,
	GOOGLE_REVIEW: 12,

	// Spending sources
	PURCHASE: 20,

	// System sources
	EXPIRATION: 30,
	MIGRATION: 31,
};

export const BALANCE_TRANSACTION_SOURCE_NAMES = {
	1: 'Birthday',
	2: 'Client subsidy',
	3: 'Manual adjustment',
	10: 'Top-up',
	11: 'Refund',
	12: 'Google review',
	20: 'Purchase',
	30: 'Expiration',
	31: 'Migration',
};

// Kristian gets every 30-day micro market follow-up.
export const MARKET_FOLLOW_UP_RECIPIENT_EMAIL = 'kristian@ausvend.co';

export const MANUAL_BALANCE_ADJUSTMENT_REASON_MAX_LENGTH = 250;

export const COMMISSION_TYPE = {
	PER_VEND: 1,
	PER_CENT: 2,
};

export const COMMISSION_TYPE_NAME = {
	1: 'Per vend',
	2: 'Per cent',
};

export const COMMISSION_RATE_GROUPING = {
	PRODUCT_SUB_TYPE: 1,
	POS_BRAND: 2,
};

export const COMMISSION_RATE_GROUPING_NAME = {
	[COMMISSION_RATE_GROUPING.PRODUCT_SUB_TYPE]: 'Product sub-types',
	[COMMISSION_RATE_GROUPING.POS_BRAND]: 'POS brands',
};

export const COMMISSION_REPORTING_PERIOD = {
	MONTHLY: 'monthly',
	QUARTERLY: 'quarterly',
};

export const COMMISSION_REPORTING_PERIOD_NAME = {
	[COMMISSION_REPORTING_PERIOD.MONTHLY]: 'Monthly',
	[COMMISSION_REPORTING_PERIOD.QUARTERLY]: 'Quarterly',
};

export const COMMISSION_RCTI_MODE = {
	SUMMARY: 'summary',
	POS_BREAKDOWN: 'posBreakdown',
};

export const COMMISSION_RCTI_MODE_NAME = {
	[COMMISSION_RCTI_MODE.SUMMARY]: 'Summary',
	[COMMISSION_RCTI_MODE.POS_BREAKDOWN]: 'POS breakdown',
};

export const COMMISSION_PAYMENT_METHOD = {
	RCTI: 'rcti',
	CLIENT_ISSUED_INVOICE: 'clientIssuedInvoice',
};

export const COMMISSION_PAYMENT_METHOD_NAME = {
	[COMMISSION_PAYMENT_METHOD.RCTI]: 'RCTI payment',
	[COMMISSION_PAYMENT_METHOD.CLIENT_ISSUED_INVOICE]: 'Client-issued invoice',
};

export const COMMISSION_ATTACHMENT_TYPE = {
	PDF_REPORT: 'pdfReport',
	COMMISSION_SALES_REPORT: 'commissionSalesReport',
	PRODUCT_SALES_REPORT: 'productSalesReport',
};

export const COMMISSION_ATTACHMENT_TYPE_NAME = {
	[COMMISSION_ATTACHMENT_TYPE.PDF_REPORT]: 'PDF report',
	[COMMISSION_ATTACHMENT_TYPE.COMMISSION_SALES_REPORT]: 'Commission sales report',
	[COMMISSION_ATTACHMENT_TYPE.PRODUCT_SALES_REPORT]: 'Product sales report',
};

export const COMMISSION_PAYEE_TYPE = {
	CLIENT: 'client',
	REFERRER: 'referrer',
};

export const COMMISSION_PAYEE_TYPE_NAME = {
	[COMMISSION_PAYEE_TYPE.CLIENT]: 'Client',
	[COMMISSION_PAYEE_TYPE.REFERRER]: 'Referrer',
};

export const COMMISSION_RUN_STATUS = {
	DRAFT: 'draft',
	APPROVED: 'approved',
	PAID: 'paid',
	SENT: 'sent',
	PARTIALLY_SENT: 'partiallySent',
};

export const COMMISSION_RUN_STATUS_NAME = {
	[COMMISSION_RUN_STATUS.DRAFT]: 'Draft',
	[COMMISSION_RUN_STATUS.APPROVED]: 'Approved',
	[COMMISSION_RUN_STATUS.PAID]: 'Paid',
	[COMMISSION_RUN_STATUS.SENT]: 'Sent',
	[COMMISSION_RUN_STATUS.PARTIALLY_SENT]: 'Partially sent',
};

export const COMMISSION_PAYMENT_STATUS = {
	UNPAID: 'unpaid',
	INCLUDED_IN_ABA: 'includedInAba',
	AWAITING_CLIENT_INVOICE: 'awaitingClientInvoice',
	PAID: 'paid',
};

export const COMMISSION_PAYMENT_STATUS_NAME = {
	[COMMISSION_PAYMENT_STATUS.UNPAID]: 'Unpaid',
	[COMMISSION_PAYMENT_STATUS.INCLUDED_IN_ABA]: 'ABA exported',
	[COMMISSION_PAYMENT_STATUS.AWAITING_CLIENT_INVOICE]: 'Awaiting client invoice',
	[COMMISSION_PAYMENT_STATUS.PAID]: 'Paid',
};

export const COMMISSION_SEND_STATUS = {
	NOT_SENT: 'notSent',
	QUEUED: 'queued',
	SENT: 'sent',
	FAILED: 'failed',
	PARTIALLY_SENT: 'partiallySent',
};

export const COMMISSION_SEND_STATUS_NAME = {
	[COMMISSION_SEND_STATUS.NOT_SENT]: 'Not sent',
	[COMMISSION_SEND_STATUS.QUEUED]: 'Queued',
	[COMMISSION_SEND_STATUS.SENT]: 'Sent',
	[COMMISSION_SEND_STATUS.FAILED]: 'Failed',
	[COMMISSION_SEND_STATUS.PARTIALLY_SENT]: 'Partially sent',
};

export const COMMISSION_RUN_EVENT_TYPE = {
	CREATED: 'created',
	REFRESHED: 'refreshed',
	APPROVED: 'approved',
	UNAPPROVED: 'unapproved',
	APPROVAL_REPAIRED: 'approvalRepaired',
	ABA_GENERATED: 'abaGenerated',
	MARKED_PAID: 'markedPaid',
	EMAIL_QUEUED: 'emailQueued',
	EMAIL_TEST_QUEUED: 'emailTestQueued',
	EMAIL_SENT: 'emailSent',
	EMAIL_FAILED: 'emailFailed',
	SUBCONTRACTOR_COMMISSION_SET: 'subcontractorCommissionSet',
	SUBCONTRACTOR_STATEMENT_CHANGED: 'subcontractorStatementChanged',
	SUBCONTRACTOR_PAYMENT_RECEIVED: 'subcontractorPaymentReceived',
};

export const MONTHLY_REPORT_OUTPUT_FORMAT = {
	PDF: 'PDF',
	XLSX: 'XLSX',
};

export const MONTHLY_REPORT_OUTPUT_FORMAT_NAME = {
	[MONTHLY_REPORT_OUTPUT_FORMAT.PDF]: 'PDF report',
	[MONTHLY_REPORT_OUTPUT_FORMAT.XLSX]: 'Excel report',
};

export const MONTHLY_REPORTING_RUN_SOURCE = {
	SCHEDULED: 'scheduled',
	MANUAL: 'manual',
};

export const MONTHLY_REPORTING_RUN_STATUS = {
	GENERATING: 'generating',
	GENERATED: 'generated',
	PARTIALLY_FAILED: 'partiallyFailed',
	FAILED: 'failed',
};

export const MONTHLY_REPORTING_RUN_STATUS_NAME = {
	[MONTHLY_REPORTING_RUN_STATUS.GENERATING]: 'Generating',
	[MONTHLY_REPORTING_RUN_STATUS.GENERATED]: 'Generated',
	[MONTHLY_REPORTING_RUN_STATUS.PARTIALLY_FAILED]: 'Partially failed',
	[MONTHLY_REPORTING_RUN_STATUS.FAILED]: 'Failed',
};

export const MONTHLY_REPORTING_RUN_ITEM_GENERATION_STATUS = {
	GENERATING: 'generating',
	GENERATED: 'generated',
	FAILED: 'failed',
};

export const MONTHLY_REPORTING_RUN_ITEM_GENERATION_STATUS_NAME = {
	[MONTHLY_REPORTING_RUN_ITEM_GENERATION_STATUS.GENERATING]: 'Generating',
	[MONTHLY_REPORTING_RUN_ITEM_GENERATION_STATUS.GENERATED]: 'Generated',
	[MONTHLY_REPORTING_RUN_ITEM_GENERATION_STATUS.FAILED]: 'Failed',
};

export const MONTHLY_REPORTING_RUN_ITEM_STATUS = {
	NOT_ACTIONED: 'notActioned',
	VIEWED: 'viewed',
	SENT_TO_CLIENT: 'sentToClient',
};

export const MONTHLY_REPORTING_RUN_ITEM_STATUS_NAME = {
	[MONTHLY_REPORTING_RUN_ITEM_STATUS.NOT_ACTIONED]: 'Not actioned',
	[MONTHLY_REPORTING_RUN_ITEM_STATUS.VIEWED]: 'Viewed',
	[MONTHLY_REPORTING_RUN_ITEM_STATUS.SENT_TO_CLIENT]: 'Sent to client',
};

// Subsidy runs mirror commission runs but are invoiced to clients through Xero
// (normal invoice, not RCTI), so payment tracking stays in Xero.
export const SUBSIDY_RUN_STATUS = {
	DRAFT: 'draft',
	APPROVED: 'approved',
	INVOICED: 'invoiced',
	PARTIALLY_INVOICED: 'partiallyInvoiced',
};

export const SUBSIDY_RUN_STATUS_NAME = {
	[SUBSIDY_RUN_STATUS.DRAFT]: 'Draft',
	[SUBSIDY_RUN_STATUS.APPROVED]: 'Approved',
	[SUBSIDY_RUN_STATUS.INVOICED]: 'Invoiced',
	[SUBSIDY_RUN_STATUS.PARTIALLY_INVOICED]: 'Partially invoiced',
};

export const SUBSIDY_INVOICE_STATUS = {
	NOT_CREATED: 'notCreated',
	PENDING: 'pending',
	CREATED: 'created',
	FAILED: 'failed',
};

export const SUBSIDY_INVOICE_STATUS_NAME = {
	[SUBSIDY_INVOICE_STATUS.NOT_CREATED]: 'Not created',
	[SUBSIDY_INVOICE_STATUS.PENDING]: 'Creating in Xero',
	[SUBSIDY_INVOICE_STATUS.CREATED]: 'Created',
	[SUBSIDY_INVOICE_STATUS.FAILED]: 'Failed',
};

export const SUBSIDY_RUN_EVENT_TYPE = {
	CREATED: 'created',
	REFRESHED: 'refreshed',
	APPROVED: 'approved',
	INVOICE_LINE_UPDATED: 'invoiceLineUpdated',
	INVOICE_CREATED: 'invoiceCreated',
	INVOICE_RECREATION_REQUESTED: 'invoiceRecreationRequested',
	INVOICE_FAILED: 'invoiceFailed',
};

export const KAM_COMMISSION_RUN_STATUS = {
	DRAFT: 'draft',
	FINALISED: 'finalised',
	PAID: 'paid',
};

export const KAM_COMMISSION_RUN_STATUS_NAME = {
	[KAM_COMMISSION_RUN_STATUS.DRAFT]: 'Draft',
	[KAM_COMMISSION_RUN_STATUS.FINALISED]: 'Finalised',
	[KAM_COMMISSION_RUN_STATUS.PAID]: 'Paid',
};

export const KAM_COMMISSION_RUN_LOCATION_DECISION = {
	PENDING: 'pending',
	APPROVED: 'approved',
	NO_COMMISSION: 'noCommission',
	NOT_QUALIFIED: 'notQualified',
	NOT_YET_OPERATIONAL: 'notYetOperational',
	ALREADY_INCLUDED: 'alreadyIncluded',
};

export const SECURED_LOCATION_COMMISSION_STATUS = {
	PENDING: 'pending',
	QUALIFIED: 'qualified',
	EXCLUDED: 'excluded',
};

export const KAM_COMMISSION_RUN_STATEMENT_EMAIL_STATUS = {
	QUEUED: 'queued',
	SENT: 'sent',
	FAILED: 'failed',
};

export const KAM_COMMISSION_RUN_EVENT_TYPE = {
	CREATED: 'created',
	REFRESHED: 'refreshed',
	APPROVED: 'approved',
	REJECTED: 'rejected',
	FINALISED: 'finalised',
	MARKED_PAID: 'markedPaid',
};

export const PREDEFINED_USER_ROLES = {
	DRIVER: 'Driver',
	ADMIN: 'Admin',
	TECHNICIAN: 'Technician',
};

export const PREDEFINED_ROLE_NAMES = Object.values(PREDEFINED_USER_ROLES);

export const CHANGE_TYPES = {
	FORCE: 1,
	NEXT_SERVICE: 2,
	NEXT_EMPTY: 3,
	NEXT_EMPTY_TIMED: 4,
};

export const CHANGE_TYPE_NAMES = {
	1: 'Force',
	2: 'Next service',
	3: 'Next empty',
	// Use concise wording so dropdown buttons stay compact while remaining descriptive
	4: 'Next empty timed',
};

export const NEXT_EMPTY_CHANGE_TYPES = [
	CHANGE_TYPES.NEXT_EMPTY,
	CHANGE_TYPES.NEXT_EMPTY_TIMED,
];

export const isNextEmptyChangeType = changeType => {
	if (!changeType) {
		return false;
	}

	return NEXT_EMPTY_CHANGE_TYPES.includes(changeType);
};

// Bulk price adjustment constants
export const BULK_PRICE_ADJUSTMENT_METHOD = {
	PERCENT: 1,
	AMOUNT: 2,
	CUSTOM: 3,
};

export const BULK_PRICE_ADJUSTMENT_METHOD_NAMES = {
	1: 'Percentage',
	2: 'Fixed $ amount',
	3: 'Custom prices',
};

export const BULK_PRICE_ADJUSTMENT_STATUS = {
	DRAFT: 1,
	APPLIED: 2,
	APPLYING: 3,
	ACTION_REQUIRED: 4,
};

export const BULK_PRICE_ADJUSTMENT_ITEM_STATUS = {
	PENDING: 1,
	APPLIED: 2,
	UNCHANGED: 3,
	ACTION_REQUIRED: 4,
};

export const BULK_PRICE_ADJUSTMENT_PROPAGATION_STATUS = {
	PENDING: 1,
	COMPLETE: 2,
	ACTION_REQUIRED: 3,
};

export const BULK_PRICE_ADJUSTMENT_SOURCE = {
	TOOL: 1,
	LEGACY_API: 2,
};

// Rounding steps in cents offered when creating an adjustment.
export const BULK_PRICE_ADJUSTMENT_ROUNDING_OPTIONS = [1, 5, 10, 20, 50, 100];

export const BULK_PRICE_ADJUSTMENT_DEFAULT_ROUNDING_STEP = 10;

// Product discontinuation constants
export const DISCONTINUATION_STRATEGY = {
	IMMEDIATE: 1,
	WHEN_OUT_OF_STOCK: 2,
	ON_DATE: 3,
	MANUAL: 4,
};

export const DISCONTINUATION_STRATEGY_NAMES = {
	1: 'Immediate',
	2: 'When out of stock',
	3: 'On specific date',
	4: 'Manual',
};

export const REMOVAL_TIMING = {
	IMMEDIATE: 1,
	ON_EMPTY: 2,
};

export const REMOVAL_TIMING_NAMES = {
	1: 'Remove immediately',
	2: 'Remove when stock reaches zero',
};

export const PRICE_ADJUSTMENT_TYPE = {
	FIXED: 1,
	ADD_AMOUNT: 2,
	MULTIPLY_PERCENT: 3,
	NO_CHANGE: 4,
};

export const PRICE_ADJUSTMENT_TYPE_NAMES = {
	1: 'Fixed price',
	2: 'Add amount',
	3: 'Percentage change',
	4: 'No price change',
};

// Note: react dnd expects values of these
// constants to be strings
export const DRAG_DROP_TYPES = {
	LIST_ITEM: '1',
	DAILY_VIEW_ITEM: '2',
	ROUTE_PLANNER_ITEM: '3',
	MARKET_ASSET: '4',
	MARKET_ASSET_ITEM: '5',
	SERVICE_RUN_ORDER: '6',
	TICKET_CARD: '7',
	PICKING_DOCKET: '8',
};

export const LOGICAL_OPERATOR = {
	AND: 0,
	OR: 1,
};

export const ALERT_TRIGGER_TYPE = {
	// time
	NO_SALES: 1,
	NO_COMMUNICATION: 2,
	NO_SERVICE: 3,
	NO_NOTES_INSERTED: 4,
	NO_COINS_INSERTED: 5,

	// vendouts
	VENDOUTS: 6,

	// reported price
	REPORTED_PRICE_BELOW: 7,
	REPORTED_PRICE_ABOVE: 8,
	REPORTED_PRICE_NOT_DIVISIBLE: 9,

	// temperature
	TEMPERATURE_OUTSIDE_RANGE: 10,

	// others
	DOOR_OPENED_WHEN_NO_SERVICE_RUN: 11,
	SALE_ON_DISABLED_SELECTION: 12,
	PRICE_MISMATCH: 13,

	EMPTY_COIN_MECH_TUBE: 14,
	POWER_OUTAGE: 15,
	MANUAL_RESTOCK: 16,

	NO_CASH_DISPENSED: 17,

	PLANOGRAM_ITEM_NO_SALES: 18,

	SCANNED_BARCODE_NOT_IN_PLANOGRAM: 19,

	USER_MARKED_TICKET_NOT_RESOLVED: 20,
	USER_LEFT_A_NOTE_ON_TICKET: 21,
	USER_CREATED_A_TICKET: 22,
	SCANNED_PRODUCT_NOT_IN_PLANOGRAM: 23,
	ERRONEOUS_BASKETS: 24,
	MISSING_PRODUCTS: 25,
	PLANOMGRAM_ITEM_PRICE_DIFFERENT_THAN_DEFAULT_PRODUCT_PRICE: 26,
	STOCK_LEVEL_VENDOUTS: 27,
	PRICE_INCONSISTENCY_ACROSS_CLIENT: 28,
	VEHICLE_SPEEDING: 29,
	SITE_PERMISSION_EXPIRY: 30,
	REPEATED_TICKET_TYPE: 31,
	PLANOGRAM_ITEM_PRODUCT_CHANGED: 32,
	CANCELLED_TRANSACTIONS_RATE: 33,
	WAREHOUSE_PRODUCT_STOCK_BELOW_PERCENT: 34,
	RESTRICTED_PRODUCT_IN_PLANOGRAM: 35,
	NO_PRODUCT_IN_ACTIVE_SELECTION: 36,
	VEHICLE_MOVED_WITHOUT_SCHEDULED_JOB: 37,
	MANUFACTURER_PRODUCTS_OUT_OF_STOCK_ON_SITE: 38,
};

export const ALERT_TRIGGER_TYPE_NAMES = {
	// time
	1: 'No sales',
	2: 'No communication',
	3: 'No service',
	4: 'No notes inserted',
	5: 'No coins inserted',

	// vendouts
	6: 'Vendouts',

	// reported price
	7: 'Reported price below',
	8: 'Reported price above',
	9: 'Reported price not divisible by',

	// temperature
	10: 'Temperature outside range',

	// others
	11: 'Door opened on day when machine is not in a service run',
	12: 'Sale on disabled selection',
	13: 'Price mismatch',

	14: 'Empty coin mech tube',
	15: 'Power outage',
	16: 'Manual restock',

	17: 'No cash dispensed',

	18: 'Planogram item has made no sales',

	19: 'Scanned barcode is not in market\'s planogram',

	20: 'User marked ticket as not resolved',
	21: 'User left note on ticket',
	22: 'User created a ticket',
	23: 'Scanned product is not in market\'s planogram',
	24: 'Erroneous baskets',
	25: 'Missing products',
	26: 'Planogram item price is different than the default product price',
	27: 'Stock levels confirmed with vendouts',
	28: 'Price inconsistency across client',
	29: 'Vehicle speeding',
	30: 'Site permission expiry',
	31: 'Repeated ticket type',
	32: 'Product changed in planogram item',
	33: 'Cancelled transactions rate',
	34: 'Warehouse product stock below %',
	35: 'Restricted product in planogram',
	36: 'No product in active selection',
	37: 'Vehicle moved without scheduled job',
	38: 'Manufacturer products out of stock on site',
};

export const SITE_PERMISSION_POLICY = {
	REQUIRED: 'REQUIRED',
	PROHIBITED: 'PROHIBITED',
};

export const SITE_PERMISSION_POLICY_LABEL = {
	[SITE_PERMISSION_POLICY.REQUIRED]: 'Required to allow access',
	[SITE_PERMISSION_POLICY.PROHIBITED]: 'Blocks access when assigned',
};

// Short variants for list chips and selector suffixes; forms keep the full labels above.
export const SITE_PERMISSION_POLICY_SHORT_LABEL = {
	[SITE_PERMISSION_POLICY.REQUIRED]: 'Required',
	[SITE_PERMISSION_POLICY.PROHIBITED]: 'Blocks access',
};

export const DAYS_OF_WEEK = [0, 1, 2, 3, 4, 5, 6];

export const DAY_OF_WEEK_LABEL = {
	0: 'Sunday',
	1: 'Monday',
	2: 'Tuesday',
	3: 'Wednesday',
	4: 'Thursday',
	5: 'Friday',
	6: 'Saturday',
};

export const DAY_OF_WEEK_SHORT_LABEL = {
	0: 'Sun',
	1: 'Mon',
	2: 'Tue',
	3: 'Wed',
	4: 'Thu',
	5: 'Fri',
	6: 'Sat',
};

export const DEFAULT_SITE_PERMISSION_DAYS_OF_WEEK = [...DAYS_OF_WEEK];
export const DEFAULT_ORDER_DAYS_OF_WEEK = [...DAYS_OF_WEEK];

// Fresh food supplier ordering. Buffer percentages live on the tenant and are seeded with
// these bands so they can be tuned without a deploy. Products are classified by their own
// shelf life in days rather than by a hardcoded product list.
export const FRESH_FOOD_ORDER_STATUS = {
	DRAFT: STATUS.PENDING,
	CONFIRMED: STATUS.COMPLETE,
	CANCELLED: STATUS.CANCELLED,
};

export const DEFAULT_FRESH_FOOD_SHELF_LIFE_CATEGORIES = [
	{ key: 'ULTRA_SHORT', name: 'Ultra short shelf life (1-2 days)', minDays: 1, maxDays: 2, bufferPercent: 5 },
	{ key: 'SHORT', name: 'Short shelf life (3-4 days)', minDays: 3, maxDays: 4, bufferPercent: 10 },
	{ key: 'LONG', name: 'Long shelf life (5+ days)', minDays: 5, maxDays: null, bufferPercent: 0 },
];

// A fresh food product with no shelf life set gets no uplift rather than an invented one.
export const FRESH_FOOD_UNCLASSIFIED_BUFFER_PERCENT = 0;
export const DEFAULT_FRESH_FOOD_ORDER_DAY_OF_WEEK = 4; // Thursday
export const DEFAULT_FRESH_FOOD_SALES_WINDOW_DAYS = 7;
// A buffer override is an exception, so cap it at double the expected need; a larger value is
// almost certainly a typo and would multiply the supplier order rather than tune it.
export const MAX_FRESH_FOOD_BUFFER_PERCENT = 100;

// The list contains alerts which are just single events oppositely to the other ones which represent some state.
export const EVENT_ALERT_TRIGGERS = [
	ALERT_TRIGGER_TYPE.MANUAL_RESTOCK, ALERT_TRIGGER_TYPE.SALE_ON_DISABLED_SELECTION,
	ALERT_TRIGGER_TYPE.DOOR_OPENED_WHEN_NO_SERVICE_RUN, ALERT_TRIGGER_TYPE.USER_MARKED_TICKET_NOT_RESOLVED,
	ALERT_TRIGGER_TYPE.USER_LEFT_A_NOTE_ON_TICKET, ALERT_TRIGGER_TYPE.USER_CREATED_A_TICKET,
	ALERT_TRIGGER_TYPE.SCANNED_PRODUCT_NOT_IN_PLANOGRAM, ALERT_TRIGGER_TYPE.SCANNED_BARCODE_NOT_IN_PLANOGRAM,
	ALERT_TRIGGER_TYPE.MISSING_PRODUCTS, ALERT_TRIGGER_TYPE.STOCK_LEVEL_VENDOUTS,
	ALERT_TRIGGER_TYPE.VEHICLE_SPEEDING,
	ALERT_TRIGGER_TYPE.REPEATED_TICKET_TYPE,
	ALERT_TRIGGER_TYPE.PLANOGRAM_ITEM_PRODUCT_CHANGED,
	ALERT_TRIGGER_TYPE.VEHICLE_MOVED_WITHOUT_SCHEDULED_JOB,
];

export const VEHICLE_DAILY_LOCK_EVENT_ALERT_TRIGGERS = [
	ALERT_TRIGGER_TYPE.VEHICLE_MOVED_WITHOUT_SCHEDULED_JOB,
];

export const MEASUREMENT_UNIT = {
	UNIT: 0,
	GRAM: 1,
	KILOGRAM: 2,
	MILLILITRE: 3,
	LITRE: 4,
};

export const MEASUREMENT_UNIT_MAX_DECIMALS = {
	0: 0, // unit
	1: 2, // gram
	2: 2, // kilogram
	3: 2, // millilitre
	4: 2, // litre
};

export const MEASUREMENT_UNIT_NAME = {
	0: 'Unit',
	1: 'Gram',
	2: 'Kilogram',
	3: 'Millilitre',
	4: 'Litre',
};

export const MEASUREMENT_UNIT_SHORT_NAME = {
	0: 'units',
	1: 'g',
	2: 'kg',
	3: 'ml',
	4: 'l',
};

export const MAP_MARKERS_COLOR_BY = {
	ROUTE: 1,
	VENDOUTS: 2,
	DSLS: 3,
	LAST_COMM: 4,
	// SALES_LAST_7_DAYS: 5,
};

export const MAP_MARKERS_COLOR_BY_NAMES = {
	0: 'None',
	1: 'Route',
	2: 'Vendouts',
	3: 'Days since last service',
	4: 'Last communication',
};

export const MACHINE_SERVICE_TYPES = {
	RESTOCK_AND_REPAIR: 1,
	REPAIR: 2,
	RESTOCK: 3,
};

export const MACHINE_SERVICE_TYPE_NAMES = {
	1: 'Restock and repair',
	2: 'Repair',
	3: 'Restock',
};

export const RESTOCK_TYPE = {
	ALL_PRODUCTS: 1,
	FRESH_FOOD_ONLY: 2,
	EXCLUDE_FRESH_FOOD: 3,
};

export const RESTOCK_TYPE_NAMES = {
	1: 'All products',
	2: 'Fresh food only',
	3: 'Exclude fresh food',
};

export const PICKER_ASSIGNMENT_SOURCE = {
	AUTOMATIC: 1,
	MANUAL: 2,
};

export const PICKING_WORK_AVAILABILITY = {
	ELIGIBLE: 'eligible',
	RESTORABLE: 'restorable',
	ALREADY_ADDED: 'alreadyAdded',
	COMPLETED: 'completed',
	RESTOCKED: 'restocked',
	PICKED: 'picked',
	PARTLY_PICKED: 'partlyPicked',
	STARTED: 'started',
	NO_PICK_WORK: 'noPickWork',
};

export const WAREHOUSE_PRINT_JOB_TYPE = {
	REPAIR: 'repair',
	TUB: 'tub',
	PACK: 'pack',
	TEST: 'test',
};

export const WAREHOUSE_PRINT_JOB_STATUS = {
	QUEUED: 'queued',
	CLAIMED: 'claimed',
	COMPLETED: 'completed',
	FAILED: 'failed',
	UNCERTAIN: 'uncertain',
	CANCELLED: 'cancelled',
};

export const WAREHOUSE_LABEL_PRINTER = {
	MODEL: 'QL-820NWB',
	MEDIA: '62x100',
	WIDTH_MM: 100,
	HEIGHT_MM: 62,
	WIDTH_PX: 1109,
	HEIGHT_PX: 696,
};

export const TAG_TYPES = {
	PRODUCT: 1,
	MACHINE: 2,
	TICKET: 3,
	LOCATION: 4,
	PACK: 5,
};

export const TAG_TYPE_NAMES = {
	1: 'Product',
	2: 'Machine/Market',
	3: 'Ticket',
	4: 'Location',
	5: 'Pack',
};

// last ID: 173
export const ROLE_PERMISSIONS = {
	// Machines
	VIEW_MACHINE_LIST_PAGE: 62,
	VIEW_MACHINE_DETAIL_PAGE: 30,
	ADD_EDIT_MACHINES: 12,
	VIEW_PLANOGRAM_LIST_PAGE: 31,
	ADD_EDIT_PLANOGRAMS: 23,
	VIEW_PLACE_LIST_PAGE: 74,
	VIEW_PLACE_DETAIL_PAGE: 75,
	ADD_EDIT_PLACES: 76,
	VIEW_LOCATION_LIST_PAGE: 32,
	VIEW_LOCATION_DETAIL_PAGE: 33,
	ADD_EDIT_LOCATIONS: 13,
	VIEW_COMM_DEVICE_LIST_PAGE: 34,
	VIEW_COMM_DEVICE_DETAIL_PAGE: 35,
	ADD_EDIT_COMM_DEVICES: 14,
	VIEW_COMM_DATA_LIST: 70,
	ADD_EDIT_COMM_DATA: 71,
	VIEW_SOLD_PRODUCT_LIST: 72,
	ADD_EDIT_SOLD_PRODUCTS: 73,
	VIEW_MACHINE_MAP_PAGE: 36,
	VIEW_MACHINE_PHOTOS: 8,

	VIEW_CAMPAIGN_LIST_PAGE: 98,
	VIEW_CAMPAIGN_DETAIL_PAGE: 99,
	ADD_EDIT_CAMPAIGNS: 100,
	VIEW_PROMOTION_LIST_PAGE: 101,
	VIEW_PROMOTION_DETAIL_PAGE: 102,
	ADD_EDIT_PROMOTIONS: 103,

	VIEW_BASKET_LIST_PAGE: 104,

	// Routes
	VIEW_ROUTE_LIST_PAGE: 63,
	VIEW_ROUTE_DETAIL_PAGE: 64,
	ADD_EDIT_ROUTES: 15,
	VIEW_SERVICE_RUN_LIST_PAGE: 65,
	VIEW_SERVICE_RUN_DETAIL_PAGE: 66,
	ADD_EDIT_SERVICE_RUNS: 16,
	EDIT_CASH_COLLECTION: 77,
	ADD_EDIT_PICK_LISTS: 84,
	VIEW_DAILY_VIEW_PAGE: 67,
	APPROVE_CHECKLIST_SUBMISSIONS: 170,
	COMPLETE_ASSIGNED_MARKET_SETUPS: 172,

	// Clients
	VIEW_CLIENT_LIST_PAGE: 37,
	VIEW_CLIENT_DETAIL_PAGE: 38,
	ADD_EDIT_CLIENTS: 17,
	VIEW_COMMISSION_LIST_PAGE: 39,
	VIEW_COMMISSION_DETAIL_PAGE: 40,
	VIEW_COMMISSION_DATA: 11,
	ADD_EDIT_COMMISSIONS: 18,
	VIEW_CONTACT_LIST_PAGE: 41,
	VIEW_CONTACT_DETAIL_PAGE: 42,
	ADD_EDIT_CONTACTS: 19,
	VIEW_PRICE_BOOK_LIST_PAGE: 123,
	VIEW_PRICE_BOOK_DETAIL_PAGE: 124,
	ADD_EDIT_PRICE_BOOKS: 125,
	VIEW_SITE_PERMISSION_LIST_PAGE: 117,
	VIEW_SITE_PERMISSION_DETAIL_PAGE: 118,
	ADD_EDIT_SITE_PERMISSIONS: 119,
	VIEW_USER_SITE_PERMISSION_LIST_PAGE: 120,
	VIEW_USER_SITE_PERMISSION_DETAIL_PAGE: 121,
	ADD_EDIT_USER_SITE_PERMISSIONS: 122,

	// Referrers
	VIEW_REFERRER_LIST_PAGE: 111,
	VIEW_REFERRER_DETAIL_PAGE: 112,
	ADD_EDIT_REFERRERS: 113,

	// Tenants (operators)
	VIEW_TENANT_LIST_PAGE: 114,
	VIEW_TENANT_DETAIL_PAGE: 115,
	ADD_EDIT_TENANTS: 116,

	// Warehousing
	VIEW_PRODUCT_LIST_PAGE: 43,
	VIEW_PRODUCT_DETAIL_PAGE: 44,
	ADD_EDIT_PRODUCTS: 20,
	VIEW_STOCK_PAGE: 45,
	MODIFY_STOCK_LEVELS: 46,
	VIEW_WAREHOUSE_LIST_PAGE: 47,
	VIEW_WAREHOUSE_DETAIL_PAGE: 48,
	ADD_EDIT_WAREHOUSES: 49,
	VIEW_STOCKTAKE_LIST_PAGE: 85,
	VIEW_STOCKTAKE_DETAIL_PAGE: 86,
	ADD_EDIT_STOCKTAKES: 87,
	VIEW_STOCK_MOVEMENT_LOG_PAGE: 97,

	// Reports
	VIEW_REPORTS: 2,

	// Operations
	VIEW_ALERT_LIST_PAGE: 21,
	VIEW_ALERT_DETAIL_PAGE: 53,
	ADD_EDIT_ALERTS: 54,
	VIEW_TICKET_LIST_PAGE: 55,
	VIEW_TICKET_DETAIL_PAGE: 56,
	ADD_EDIT_TICKETS: 6,
	ADD_EDIT_TICKET_PHOTOS: 25,
	VIEW_TICKET_SCHEDULE_LIST_PAGE: 28,
	VIEW_TICKET_SCHEDULE_DETAIL_PAGE: 57,
	ADD_EDIT_TICKET_SCHEDULES: 58,
	VIEW_VEHICLE_LIST_PAGE: 59,
	VIEW_VEHICLE_DETAIL_PAGE: 60,
	ADD_EDIT_VEHICLES: 61,
	ADD_EDIT_NOTES: 3,
	VIEW_SUPPLIER_LIST_PAGE: 81,
	VIEW_SUPPLIER_DETAIL_PAGE: 82,
	ADD_EDIT_SUPPLIERS: 83,
	VIEW_STOCK_SUPPLIER_LIST_PAGE: 88,
	VIEW_STOCK_SUPPLIER_DETAIL_PAGE: 89,
	ADD_EDIT_STOCK_SUPPLIERS: 90,
	VIEW_STOCK_DELIVERY_LIST_PAGE: 91,
	VIEW_STOCK_DELIVERY_DETAIL_PAGE: 92,
	ADD_EDIT_STOCK_DELIVERIES: 93,
	VIEW_PURCHASE_ORDER_LIST_PAGE: 94,
	VIEW_PURCHASE_ORDER_DETAIL_PAGE: 95,
	ADD_EDIT_PURCHASE_ORDERS: 96,
	VIEW_LOCATION_MAP_LIST_PAGE: 106,
	ADD_EDIT_LOCATION_MAP: 107,

	VIEW_PRODUCT_EXPIRY_CHECK_SCHEDULE_DETAIL_PAGE: 108,
	VIEW_PRODUCT_EXPIRY_CHECK_SCHEDULE_LIST_PAGE: 109,
	ADD_EDIT_PRODUCT_EXPIRY_CHECK_SCHEDULES: 110,

	VIEW_TRANSACTION_LIST_PAGE: 29,

	VIEW_IMPORT_TOOLS: 26,
	VIEW_PRODUCT_GALLERIES: 78,
	VIEW_DATA_HISTORY: 69,
	VIEW_MACHINE_EVENTS: 79,
	VIEW_MACHINE_COIN_MECH: 80,

	// Users
	MANAGE_USERS_AND_ROLES: 5,

	// Settings
	EDIT_COMPANY_SETTINGS: 10,
	EDIT_LIST_SETTINGS: 9,
	EDIT_MACHINE_PHOTO_SETTINGS: 24,
	EDIT_REPORT_SETTINGS: 105,

	// Other
	LOG_IN_TO_WEB_APP: 4,
	LOG_IN_TO_MOBILE_APP: 68,
	LOG_IN_TO_CLOCK_KIOSK_APP: 143,
	VIEW_GPS_DATA: 7,
	VIEW_DASHBOARD: 22,

	// People
	LOG_IN_TO_PEOPLE_APP: 126,
	PEOPLE_VIEW_EMPLOYEE_DIRECTORY: 127,
	PEOPLE_MANAGE_EMPLOYEES: 128,
	PEOPLE_VIEW_EMPLOYEE_HISTORY: 129,
	PEOPLE_VIEW_SENSITIVE_EMPLOYEE_FIELDS: 130,
	PEOPLE_EDIT_SENSITIVE_EMPLOYEE_FIELDS: 131,
	PEOPLE_MANAGE_COMPANY_DOCUMENTS: 132,
	PEOPLE_MANAGE_EMPLOYEE_DOCUMENTS: 133,
	PEOPLE_VIEW_EMPLOYEE_EVENTS: 134,
	PEOPLE_MANAGE_EMPLOYEE_EVENTS: 135,
	PEOPLE_GRANT_LINK_ACCESS: 136,
	PEOPLE_EDIT_COMPANY_SETTINGS: 137,
	PEOPLE_MANAGE_ANNOUNCEMENTS: 138,
	PEOPLE_VIEW_EMPLOYEE_DOCUMENTS: 139,
	PEOPLE_VIEW_EMPLOYEE_SALARY: 140,
	PEOPLE_VIEW_EMPLOYEE_DOCUMENT_INSTANCES: 141,
	PEOPLE_MANAGE_ACCESS: 142,
	PEOPLE_VIEW_CLOCK_EVENTS: 144,
	PEOPLE_MANAGE_TRAININGS: 145,
	PEOPLE_VIEW_TRAININGS: 146,
	PEOPLE_VIEW_TRAINING_RECORDS: 147,
	PEOPLE_VIEW_DASHBOARD: 148,
	LOG_IN_TO_CLIENTS_APP: 149,
	CLIENTS_VIEW_LEADS: 150,
	CLIENTS_MANAGE_LEADS: 151,
	CLIENTS_CONVERT_LEADS: 152,
	CLIENTS_VIEW_CLIENTS: 153,
	CLIENTS_MANAGE_CLIENTS: 154,
	CLIENTS_MODIFY_ACCOUNT_MANAGERS: 173,
	PEOPLE_GRANT_CLIENTS_ACCESS: 155,
	CLIENTS_VIEW_DASHBOARD: 156,
	CLIENTS_MANAGE_ACCESS: 157,
	PEOPLE_VIEW_ACCESS_USERS: 158,
	PEOPLE_MANAGE_ACCESS_USERS: 159,
	PEOPLE_MANAGE_ACCESS_ROLES: 160,
	PEOPLE_VIEW_ROSTER: 161,
	PEOPLE_MANAGE_ROSTER: 162,
	PEOPLE_VIEW_TIMESHEETS: 163,
	PEOPLE_MANAGE_TIMESHEETS: 164,
	PEOPLE_VIEW_DRIVER_PICKER_SALARY: 165,
	PEOPLE_MANAGE_DRIVER_PICKER_SALARY: 166,
	PEOPLE_MANAGE_EMPLOYEE_SALARY: 167,
	PEOPLE_VIEW_CONFIDENTIAL_EMPLOYEE_EVENTS: 168,
	PEOPLE_SCOPE_TO_OWN_STATE: 169,
	PEOPLE_APPROVE_PAYROLL_DETAIL_CHANGES: 171,
};

export const ROLE_PERMISSION_NAMES = {
	// Machines
	62:	'View machine list page',
	30:	'View machine detail page',
	12:	'Add/Edit machines',
	31:	'View planogram list page',
	23:	'Add/Edit planograms',
	74:	'View place list page',
	75:	'View place detail page',
	76:	'Add/Edit places',
	32:	'View location list page',
	33:	'View location detail page',
	13:	'Add/Edit locations',
	34:	'View comm device list page',
	35:	'View comm device detail page',
	14:	'Edit comm devices',
	70:	'View comm data list',
	71:	'Add/Edit comm data',
	72:	'View sales list',
	73:	'Add/Edit sales',
	36:	'View machine map page',

	8:	'View machine photos',

	98: 'View campaign list page',
	99: 'View campaign detail page',
	100: 'Add/Edit campaigns',
	101: 'View promotion list page',
	102: 'View promotion detail page',
	103: 'Add/Edit promotions',
	104: 'View transaction list page',

	// Routes
	63:	'View route list page',
	64:	'View route detail page',
	15:	'Add/Edit routes',
	65:	'View service run list page',
	66:	'View service run detail page',
	16:	'Add/Edit service runs',
	77:	'Edit cash collection',
	84: 'Edit pick list',
	67:	'View daily view page',
	170: 'Approve checklist submissions',
	172: 'Complete assigned market setups',

	// Clients
	37:	'View client list page',
	38:	'View client detail page',
	17:	'Add/Edit clients',
	39:	'View commission list page',
	40:	'View commission detail page',
	11:	'View commission data',
	18:	'Add/Edit commissions',
	41:	'View contact list page',
	42:	'View contact detail page',
	19:	'Add/Edit contacts',
	123: 'View price book list page',
	124: 'View price book detail page',
	125: 'Add/Edit price books',
	117:	'View site permission list page',
	118:	'View site permission detail page',
	119:	'Add/Edit site permissions',
	120:	'View driver site permission list page',
	121:	'View driver site permission detail page',
	122:	'Add/Edit driver site permissions',

	// Referrers
	111: 'View referrer list page',
	112: 'View referrer detail page',
	113: 'Add/Edit referrers',

	// Tenants (operators)
	114: 'View operator list page',
	115: 'View operator detail page',
	116: 'Add/Edit operators',

	// Warehousing
	43:	'View product list page',
	44:	'View product detail page',
	20:	'Add/Edit products',
	45:	'View stock page',
	46:	'Modify stock levels',
	47:	'View warehouse list page',
	48:	'View warehouse detail page',
	49:	'Add/Edit warehouses',
	85: 'View stocktakes page',
	86: 'View stocktakes detail page',
	87: 'Add/Edit stocktakes',
	88: 'View stock supplier list page',
	89: 'View stock supplier detail page',
	90: 'Add/Edit stock suppliers',
	91: 'View stock delivery list page',
	92: 'View stock delivery detail page',
	93: 'Add/Edit stock deliveries',
	94: 'View purchase order list page',
	95: 'View purchase order detail page',
	96: 'Add/Edit purchase orders',
	97: 'View stock movement log page',

	// Reports
	2:	'View reports',

	// Operations
	21:	'View alert list page',
	53:	'View alert detail page',
	54:	'Add/Edit alerts',
	55:	'View ticket list page',
	56:	'View ticket detail page',
	6:	'Add/Edit tickets',
	25:	'Add/Edit ticket photos',
	28:	'View ticket schedule list page',
	57:	'View ticket schedule detail page',
	58:	'Add/edit ticket schedules',
	59:	'View vehicle list page',
	60:	'View vehicle detail page',
	61:	'Add/Edit vehicles',
	3:	'Add/Edit notes',
	// 81: 'View third party supplier list page',
	// 82: 'View third party supplier detail page',
	// 83: 'Add/Edit third party suppliers',

	29:	'View transaction list page',

	26:	'View import tools',
	78: 'View product galleries',
	69:	'View data history',
	79:	'View machine events',
	80: 'View machine coin mech data',

	// Users
	5:	'Manage users and roles',

	// Settings
	10:	'Edit company settings',
	9:	'Edit list settings',
	24:	'Edit machine photo settings',
	105: 'Edit recurring reports',

	// Other
	4:	'Log in to web app',
	68:	'Log in to mobile app',
	143: 'Log in to clock kiosk app',
	7:	'View gps data',
	22:	'View dashboard',

	// People
	126: 'Log in to People app',
	127: 'View employee directory',
	128: 'Manage employees',
	129: 'View employee history',
	130: 'View sensitive employee fields',
	131: 'Edit sensitive employee fields',
	132: 'Manage company documents',
	133: 'Manage employee documents',
	134: 'View employee events',
	135: 'Manage employee events',
	136: 'Grant Link access',
	137: 'Edit company settings',
	138: 'Manage announcements',
	139: 'View employee document definitions',
	140: 'View other employee salaries',
	141: 'View document records',
	142: 'Manage access',
	144: 'View clock events',
	145: 'Manage trainings',
	146: 'View trainings',
	147: 'View training records',
	148: 'View People dashboard',
	149: 'Log in to Clients app',
	150: 'View CRM leads',
	151: 'Manage CRM leads',
	152: 'Convert CRM leads',
	153: 'View CRM clients',
	154: 'Manage CRM clients',
	155: 'Grant Clients access',
	156: 'View Clients dashboard',
	157: 'Manage Clients access',
	158: 'View users',
	159: 'Manage users',
	160: 'Manage roles',
	161: 'View roster',
	162: 'Manage roster',
	163: 'View timesheets',
	164: 'Manage timesheets',
	165: 'View driver/picker salaries',
	166: 'Manage driver/picker salaries',
	167: 'Manage other employee salaries',
	168: 'View confidential employee events',
	169: 'Scope to own state',
	171: 'Approve payroll detail changes',
	173: 'Modify client/location account managers',
};

export const NO_PERMISSION_REASON = {
	NO_USER: 1,
	NO_ROLE_PERMISSION: 2,
	NOT_ROOT_TENANT: 3,
};

export const APP_ID = {
	WEB: 1,
	MOBILE: 2,
	ADMIN: 3,
	POS: 4,
	LINK: 5,
	SUPPLIERS: 6,
	SUPPLIERS_MOBILE: 7,
	SENTRY_MARKETS: 8,
	PEOPLE: 9,
	CLOCK_KIOSK: 10,
	CLIENTS: 11,
	CHAT: 12,
	DEV: 13,
};

export const APP_NAME = {
	1: 'Web',
	2: 'Mobile',
	3: 'Admin',
	4: 'POS',
	5: 'Link',
	6: 'Suppliers', // deleted
	7: 'Suppliers Mobile', // deleted
	9: 'People',
	10: 'Clock kiosk',
	11: 'Clients',
	12: 'Chat',
	13: 'Dev',
};

export const TENANT_CONSTANT_TYPE = {
	MACHINE_WRAP: 1,
	MACHINE_MODEL: 2,
	MACHINE_TYPE: 3,
	MACHINE_COMPLIANCE_LABELS: 6,
	MACHINE_CREDIT_CARD_SURCHARGE: 7,
	MACHINE_NOTE_READER: 8,
	MACHINE_COIN_MECH: 9,
	MACHINE_AERIAL_POSITION: 10,
	MACHINE_KEY: 11,
	MACHINE_MANUFACTURER: 12,
	MACHINE_DISTRIBUTOR: 13,
	MACHINE_MOTHERBOARD: 14,
	PLANOGRAM_COMPLIANCE: 15,
	ASSET_MODEL: 16,
	EMPLOYEE_JOB_TITLE: 17,
	GOVEE_DEVICE: 18,
	EMPLOYEE_DOCUMENT_TYPE: 19,
	COMPANY_DOCUMENT_CATEGORY: 20,
	ROSTER_AREA: 21,
	INCOMING_ASSET_SUPPLIER: 22,
};

// used in drag&drop
export const DROP_POSITION = {
	TOP: 1,
	BOTTOM: 2,
	LEFT: 3,
	RIGHT: 4,
	NONE: 5,
};

export const TICKET_TYPE_CATEGORY = {
	ISSUE: 'Issue',
	JOB: 'Job',
	MAINTENANCE: 'Maintenance',
};

export const TICKET_TYPE = {
	// issue
	CARD_READER_OTHER_ISSUE: 1,
	CARD_READER_OFFLINE: 2,
	COIN_JAMMED: 3,
	COIN_LOST: 4,
	NO_CHANGE_RECEIVED: 5,
	NO_PRODUCT_RECEIVED_NOT_VENDED: 6,
	NO_PRODUCT_RECEIVED_STUCK: 7,
	DRINKS_FROZEN_COMPRESSOR_ISSUE: 8,
	DROPBIN_BLOCKED: 9,
	DROPBIN_SENSOR_NOT_WORKING: 10,
	EXPIRED_PRODUCT: 11,
	LED_LIGHTS_NOT_WORKING: 12,
	LOUD_MACHINE: 13,
	MACHINE_NOT_COOLING_COMPRESSOR_ISSUE: 14,
	MISCELLANEOUS_ISSUE: 15,
	NO_POWER: 16,
	NOTE_JAMMED: 17,
	NOTE_LOST: 18,

	// job
	CHANGE_COIL: 19,
	CHANGE_MOTOR: 20,
	CHANGE_OTHER_EQUIPMENT: 21,
	CHANGE_PAYMENT_DEVICES: 22,
	CHECK_FRIDGE_TEMPERATURES: 23,
	CHECK_USE_BY_DATES: 24,
	EMPTY_PRODUCTS: 25,
	MACHINE_MERCHANDISING: 26,
	MARKET_MERCHANDISING: 27,
	MISCELLANEOUS_JOB: 28,
	PRODUCT_PLANOGRAM_OPTIMISATION: 29,
	RELOCATE_MACHINE: 30,
	UPCOMING_PRODUCT_USE_BY_DATE: 31,

	// maintenance
	COMPRESSOR_CLEAN: 32,
	FRIDGE_CLEAN: 33,
	KIOSK_CLEAN: 34,
	MACHINE_CLEAN: 35,
	TEST_AND_TAG: 36,

	AUTOMATICALLY_GENERATED: 37,

	// Appended last because persisted ticket type numbers must never be renumbered; classified as Issue by the category helpers.
	PAR_LEVEL_CAPACITY_INCORRECT: 38,

	// Appended to preserve persisted type numbers; classified as Job by the category helpers.
	FULL_PLANOGRAM_OPTIMISATION: 39,
};

export const TICKET_TYPE_NAME = {
	// issue
	1: 'Card reader - other issue',
	2: 'Card reader offline',
	3: 'Coin(s) jammed',
	4: 'Coin(s) lost',
	5: 'Didn\'t receive change',
	6: 'Didn\'t receive product - product did not vend',
	7: 'Didn\'t receive product - product got stuck',
	8: 'Drinks are frozen - compressor issue',
	9: 'Dropbin blocked',
	10: 'Dropbin sensor not working',
	11: 'Expired product',
	12: 'LED lights are not working',
	13: 'Loud machine',
	14: 'Machine is not cooling - compressor issue',
	15: 'Miscellaneous issue',
	16: 'No power to machine',
	17: 'Note(s) jammed',
	18: 'Note(s) lost',

	// job
	19: 'Change coil',
	20: 'Change motor',
	21: 'Change other equipment',
	22: 'Change payment device(s)',
	23: 'Check fridge temperatures',
	24: 'Check use-by-dates',
	25: 'Empty product(s)',
	26: 'Machine merchandising',
	27: 'Market merchandising',
	28: 'Miscellaneous job',
	29: 'Product / planogram optimisation',
	30: 'Relocate machine',
	31: 'Upcoming product use by date',

	// maintenance
	32: 'Compressor clean',
	33: 'Fridge clean',
	34: 'Kiosk clean',
	35: 'Machine clean',
	36: 'Test & tag',

	37: 'Automatically generated',

	// issue
	38: 'Par level/capacity incorrect',

	// job
	39: 'Full planogram optimisation',
};

export const TICKET_AI_SUGGESTION_STATUS = {
	PENDING: 'PENDING',
	APPLIED: 'APPLIED',
	DISMISSED: 'DISMISSED',
};

export const RECOMMENDATION_CATEGORY = {
	ORDERING: 'ordering',
	ASSORTMENT: 'assortment',
	SEASONAL: 'seasonal',
};

export const RECOMMENDATION_CATEGORY_NAME = {
	[RECOMMENDATION_CATEGORY.ORDERING]: 'Ordering',
	[RECOMMENDATION_CATEGORY.ASSORTMENT]: 'Assortment',
	[RECOMMENDATION_CATEGORY.SEASONAL]: 'Seasonal preparation',
};

export const RECOMMENDATION_STATUS = {
	OPEN: 'open',
	ACCEPTED: 'accepted',
	DISMISSED: 'dismissed',
	SNOOZED: 'snoozed',
	COMPLETED: 'completed',
	EXPIRED: 'expired',
	SUPERSEDED: 'superseded',
};

export const RECOMMENDATION_STATUS_NAME = {
	[RECOMMENDATION_STATUS.OPEN]: 'Open',
	[RECOMMENDATION_STATUS.ACCEPTED]: 'Accepted',
	[RECOMMENDATION_STATUS.DISMISSED]: 'Dismissed',
	[RECOMMENDATION_STATUS.SNOOZED]: 'Snoozed',
	[RECOMMENDATION_STATUS.COMPLETED]: 'Completed',
	[RECOMMENDATION_STATUS.EXPIRED]: 'Expired',
	[RECOMMENDATION_STATUS.SUPERSEDED]: 'Superseded',
};

export const TICKET_WORKFLOW_STATUS = {
	INCOMING: 'incoming',
	ACTIVE: 'active',
	OUTSOURCED: 'outsourced',
};

export const TICKET_WORKFLOW_STATUS_NAME = {
	[TICKET_WORKFLOW_STATUS.INCOMING]: 'Incoming',
	[TICKET_WORKFLOW_STATUS.ACTIVE]: 'Active',
	[TICKET_WORKFLOW_STATUS.OUTSOURCED]: 'Outsourced',
};

export const TICKET_ASSIGNMENT_CATEGORY = {
	DRIVER: 'driver',
	TECHNICIAN: 'technician',
	EXTERNAL: 'external',
};

export const TICKET_ASSIGNMENT_CATEGORY_NAME = {
	[TICKET_ASSIGNMENT_CATEGORY.DRIVER]: 'Driver to resolve',
	[TICKET_ASSIGNMENT_CATEGORY.TECHNICIAN]: 'Emma / technician team to resolve',
	[TICKET_ASSIGNMENT_CATEGORY.EXTERNAL]: 'External tech to resolve',
};

export const TICKET_SERVICE_TAG = {
	NEXT_SERVICE_RUN: 'next_service_run',
	MACHINE_INACTIVE_UNTIL_RESOLVED: 'machine_inactive_until_resolved',
};

export const TICKET_SERVICE_TAG_NAME = {
	[TICKET_SERVICE_TAG.NEXT_SERVICE_RUN]: 'Next service run',
	[TICKET_SERVICE_TAG.MACHINE_INACTIVE_UNTIL_RESOLVED]: 'Machine inactive until resolved',
};

export const TICKET_REPAIR_REPORT_REQUIRED_CATEGORIES = [
	TICKET_ASSIGNMENT_CATEGORY.TECHNICIAN,
	TICKET_ASSIGNMENT_CATEGORY.EXTERNAL,
];

export const TICKET_TRIAGE_COLUMN = {
	INCOMING: 'incoming',
	DRIVER: 'driver',
	TECHNICIAN: 'technician',
	OUTSOURCED: 'outsourced',
	RESOLVED: 'resolved',
};

export const TICKET_TRIAGE_COLUMN_NAME = {
	[TICKET_TRIAGE_COLUMN.INCOMING]: 'Incoming',
	[TICKET_TRIAGE_COLUMN.DRIVER]: 'Driver to resolve',
	[TICKET_TRIAGE_COLUMN.TECHNICIAN]: 'In house tech',
	[TICKET_TRIAGE_COLUMN.OUTSOURCED]: 'Outsourced tech',
	[TICKET_TRIAGE_COLUMN.RESOLVED]: 'Resolved',
};

export const TICKET_TIMER_WARNING_HOURS = 24;
export const TICKET_TIMER_CRITICAL_HOURS = 48;
export const TICKET_RESOLVED_BOARD_WINDOW_DAYS = 7;

export const PRIORITY = {
	LOW: 1,
	NORMAL: 2,
	HIGH: 3,
	CRITICAL: 4,
};

export const PRIORITY_NAME = {
	1: 'Low',
	2: 'Normal',
	3: 'High',
	4: 'Critical',
};

// export const MAPBOX_PUBLIC_API_KEY = 'pk.eyJ1Ijoia25hcGNpbyIsImEiOiJjazJ6Y2lhaGUwMDhmM25wYzA1MjdwbGg0In0.R7fl2IyZRPWMc2MgaGaYyQ';
// no restrictions to access from server
export const MAPBOX_PUBLIC_API_KEY = 'pk.eyJ1Ijoia25hcGNpbyIsImEiOiJjazVoeDR0czYwN3Z6M2xzNjE3ZzFmZGRqIn0.llRCyHG_70eCHzfeYJoivA';

export const TIME_UNITS = [
	{ label: 'Days', value: 'days' },
	{ label: 'Weeks', value: 'weeks' },
	{ label: 'Months', value: 'months' },
	{ label: 'Quarters', value: 'quarters' },
	{ label: 'Years', value: 'years' },
];

export const SERVICE_RUN_MACHINE_ORDER = {
	OPTIMISED: 1,
	CUSTOM: 2,
};

export const SERVICE_RUN_MACHINE_ORDER_NAMES = {
	1: 'Optimized',
	2: 'Location',
	3: 'Custom',
};

export const SERVICE_RUN_PRESELECT_MODE = {
	MANUAL: 'MANUAL',
	AUTOMATIC: 'AUTOMATIC',
};

export const SERVICE_RUN_PRESELECT_MODE_NAMES = {
	MANUAL: 'Manual',
	AUTOMATIC: 'Automatic',
};

export const SERVICE_RUN_PRESELECT_DEFAULT_WEIGHT_LIMIT = 15;

export const SERVICE_RUN_PRESELECT_WEIGHTS = {
	MACHINE: 1,
	MARKET: 3,
};

export const SERVICE_RUN_SOURCE = {
	UNKNOWN: 0,
	CREATOR: 1,
	PLANNER: 2,
	UNPLANNED: 3,
	DEMO_AUTOMATION: 4,
};

export const SERVICE_RUN_SOURCE_NAMES = {
	0: 'Unknown',
	1: 'Service run creator',
	2: 'Service run planner',
	3: 'Unplanned',
	4: 'Demo automation',
};

export const SALES_LAST_X_DAYS_MODE = {
	SUM: 0,
	DAILY_AVERAGE: 1,
};

export const SALES_LAST_X_DAYS_MODE_NAMES = {
	0: 'Sum',
	1: 'Daily average',
};

export const PICK_LIST_ITEM_TYPE = {
	STOCK: 1,
	PREDICTED_STOCK: 2,
	STOCK_WITH_PREDICTED_STOCK: 3,
};

export const CASH_COLLECTION_SETTING = {
	ALWAYS: 1,
	NEVER: 2,
	WHEN_ABOVE: 3,
};

export const CASH_COLLECTION_SETTING_NAMES = {
	1: 'Always collect',
	2: 'Never collect',
	3: 'Collect if above',
};

export const MARKET_VIEW_TYPE = {
	PRODUCT: 1,
	ASSET: 2,
};

export const LIST_GRID_OPTIONS = {
	LIST: 1,
	GRID: 2,
};

export const LIST_GRID_OPTION_NAMES = {
	1: 'List',
	2: 'Grid',
};

export const MEDIA_TYPE = {
	IMAGE: 1,
	VIDEO: 2,
	SOUND: 3,
};

export const MEDIA_TYPE_NAME = {
	1: 'Image',
	2: 'Video',
	3: 'Sound',
};

export const DYNAMIC_PARLEVELS_TYPE = {
	AVERAGE_PERIOD_SALES: 1,
	SALES_PERIOD: 2,
	AUTOMATIC: 3,
};

export const DYNAMIC_PARLEVELS_TYPE_NAMES = {
	1: 'Average sales over period',
	2: 'Sales in the last period',
	3: 'Automatic (intelligent analysis)',
};

export const LIST_TOTALS_TYPE = {
	SUM: 0,
	AVERAGE: 1,
};

export const RESTOCK_EFFECT = {
	FILL_FROM_PICKLIST: 1,
	FILL_TO_PARLEVEL: 2,
};

export const RESTOCK_EFFECT_NAME = {
	1: 'Fill from pick list',
	2: 'Fill to parlevel',
};

export const COMM_DEVICE_MANUFACTURER = {
	NAYAX: 2,
	SENTRY: 3,
	WINDCAVE: 4,
	NETCARD: 6,
};

export const COMM_DEVICE_MANUFACTURER_NAME = {
	2: 'Nayax',
	3: 'Sentry',
	4: 'Windcave',
	6: 'Netcard',
};

export const THERMOMETER_MANUFACTURER = {
	GOVEE: 1,
};

export const THERMOMETER_MANUFACTURER_NAME = {
	1: 'Govee',
};

export const COMMUNICATION_TYPE = {
	DEX: 1,
	LIVE_TRANSACTION: 2,
	HEARTBEAT: 3,
	CORRUPT_DEX: 4,
	MEDIA: 5,
	ALERT: 6,
	VOID_TRANSACTION: 7,
};

export const COMMUNICATION_TYPE_NAME = {
	1: 'Dex',
	2: 'Live transaction',
	3: 'Heartbeat',
	4: 'Corrupt dex',
	5: 'Media',
	6: 'Alert',
	7: 'Void',
};

export const CLOCK_EVENT_ACTION = {
	CLOCK_IN: 1,
	CLOCK_OUT: 2,
};

export const CLOCK_EVENT_ACTION_NAME = {
	1: 'Clock in',
	2: 'Clock out',
};

export const CLOCK_EVENT_MODE = {
	QR: 1,
	MANUAL: 2,
	EXTERNAL: 3,
};

export const CLOCK_EVENT_MODE_NAME = {
	1: 'QR',
	2: 'Manual',
	3: 'External',
};

export const CLOCK_EVENT_DEPUTY_SYNC_STATUS = {
	PENDING: 1,
	SYNCED: 2,
	FAILED: 3,
	NEEDS_MAPPING: 4,
	CONFLICT: 5,
};

export const CLOCK_EVENT_DEPUTY_SYNC_STATUS_NAME = {
	1: 'Pending',
	2: 'Synced',
	3: 'Failed',
	4: 'Needs mapping',
	5: 'Conflict',
};

export const CLOCK_EVENT_ERROR_CODE = {
	ACTION_CONFLICT: 'CLOCK_EVENT_ACTION_CONFLICT',
	PIN_REQUIRED: 'CLOCK_PIN_REQUIRED',
	PIN_INVALID: 'CLOCK_PIN_INVALID',
	USER_NOT_FOUND: 'CLOCK_EVENT_USER_NOT_FOUND',
	ACTION_INVALID: 'CLOCK_EVENT_ACTION_INVALID',
	ACTION_REQUIRES_USER: 'CLOCK_EVENT_ACTION_REQUIRES_USER',
	TENANT_REQUIRED: 'CLOCK_EVENT_TENANT_REQUIRED',
	CLOCK_OUT_TOO_SOON: 'CLOCK_EVENT_CLOCK_OUT_TOO_SOON',
	CLOCK_STATUS_REQUIRED: 'CLOCK_EVENT_CLOCK_STATUS_REQUIRED',
};

export const CLOCK_QR_TOKEN = {
	TTL_SECONDS: 30,
	SKEW_SECONDS: 5,
	OFFLINE_REPLAY_MAX_AGE_SECONDS: 24 * 60 * 60,
};

export const CLOCK_KIOSK_PIN = {
	MIN_LENGTH: 4,
	MAX_LENGTH: 8,
};

export const CLOCK_QR_TOKEN_CLAIM = {
	TYPE: 'CLOCK_EVENT_QR',
};

export const CLOCK_EVENT_PHOTO_CONTENT_TYPE = {
	JPEG: 'image/jpeg',
	PNG: 'image/png',
};

export const PAYMENT_GATEWAY = {
	NMI: 1,
	WINDCAVE: 2,
	STRIPE: 3,
	WALLET: 4,
};

export const PAYMENT_GATEWAY_NAME = {
	1: 'NMI',
	2: 'Windcave',
	3: 'Stripe',
	4: 'Wallet',
};

export const TRANSACTION_TYPE = {
	SALE: 1,
	REFUND: 2,
	VOID: 3,
	TOP_UP: 4,
	OTHER: 5,
};

export const TRANSACTION_TYPE_NAME = {
	1: 'Sale',
	2: 'Refund',
	3: 'Void',
	4: 'Top up',
	5: 'Other',
};

export const TICKET_SCHEDULE_TYPE = {
	FIXED: 1,
	ELASTIC: 2,
};

export const TICKET_SCHEDULE_TYPE_NAME = {
	1: 'Fixed',
	2: 'Elastic',
};

export const PRODUCT_CONTAINER = {
	PACKET: 1,
	BOTTLE_PET: 2,
	BOTTLE_GLASS: 3,
	BOX: 4,
	CAN: 5,
	EACH: 6,
	TETRAPAK: 7,
	CUP: 8,
};

export const PRODUCT_CONTAINER_NAME = {
	1: 'Packet',
	2: 'Bottle (PET)',
	3: 'Bottle (Glass)',
	4: 'Box',
	5: 'Can',
	6: 'Each',
	7: 'Tetrapak',
	8: 'Cup',
};

export const OPERATION_TYPE = {
	UPDATE: 1,
	CREATE: 2,
	DELETE: 3,
};

export const POS_TYPE = {
	MACHINE: 1,
	MARKET: 2,
};

export const POS_TYPE_NAME = {
	1: 'Machine',
	2: 'Market',
};

export const PRODUCT_TYPES = {
	OTHER: 1,
	FOOD: 2,
	DRINK: 3,
};

export const PRODUCT_TYPE_NAMES = {
	1: 'Other',
	2: 'Food',
	3: 'Drink',
};

export const PRODUCT_EXPIRY_DATE_POLICY = {
	OPTIONAL: 'optional',
	RECOMMENDED: 'recommended',
	REQUIRED: 'required',
};

export const PRODUCT_EXPIRY_DATE_POLICY_NAME = {
	[PRODUCT_EXPIRY_DATE_POLICY.OPTIONAL]: 'Optional',
	[PRODUCT_EXPIRY_DATE_POLICY.RECOMMENDED]: 'Recommended',
	[PRODUCT_EXPIRY_DATE_POLICY.REQUIRED]: 'Required',
};

export const HOME_PAGES = {
	DASHBOARD: 1,
	MACHINE_LIST: 2,
	SERVICE_RUN_LIST: 3,
	DAILY_VIEW: 4,
	TICKET_LIST: 5,
	MACHINE_PHOTOS: 6,
	REPORTS: 7,
	MARKET_LIST: 8,
	MY_DAY: 9,
};

export const HOME_PAGE_NAMES = {
	1: 'Dashboard',
	2: 'Machine list',
	3: 'Service run list',
	4: 'Daily view',
	5: 'Ticket list',
	6: 'Machine photos',
	7: 'Reports',
	8: 'Market list',
	9: 'My day',
};

export const ASSET_CREATOR_TYPES = {
	MACHINE: 1,
	COFFEE_MACHINE: 2,
	MARKET: 3,
};

export const ASSET_CREATOR_TYPE_NAMES = {
	1: 'Machine',
	2: 'Coffee machine',
	3: 'Market',
};

export const INCOMING_ASSET_TYPE = {
	VENDING_MACHINE: 'VENDING_MACHINE',
	MICRO_MARKET_KIOSK: 'MICRO_MARKET_KIOSK',
	FRIDGE: 'FRIDGE',
	SMART_FRIDGE: 'SMART_FRIDGE',
	COMM_DEVICE: 'COMM_DEVICE',
	OTHER: 'OTHER',
};

export const INCOMING_ASSET_TYPE_NAME = {
	[INCOMING_ASSET_TYPE.VENDING_MACHINE]: 'Vending machine',
	[INCOMING_ASSET_TYPE.MICRO_MARKET_KIOSK]: 'Micro market kiosk',
	[INCOMING_ASSET_TYPE.FRIDGE]: 'Fridge',
	[INCOMING_ASSET_TYPE.SMART_FRIDGE]: 'Smart fridge',
	[INCOMING_ASSET_TYPE.COMM_DEVICE]: 'Comm device',
	[INCOMING_ASSET_TYPE.OTHER]: 'Other',
};

export const INCOMING_ASSET_ORDER_STATUS = {
	DRAFT: 'DRAFT',
	ORDERED: 'ORDERED',
	CONFIRMED: 'CONFIRMED',
	IN_TRANSIT: 'IN_TRANSIT',
	RECEIVED: 'RECEIVED',
	CLOSED: 'CLOSED',
	CANCELLED: 'CANCELLED',
};

export const INCOMING_ASSET_ORDER_STATUS_NAME = {
	[INCOMING_ASSET_ORDER_STATUS.DRAFT]: 'Draft',
	[INCOMING_ASSET_ORDER_STATUS.ORDERED]: 'Ordered',
	[INCOMING_ASSET_ORDER_STATUS.CONFIRMED]: 'Confirmed',
	[INCOMING_ASSET_ORDER_STATUS.IN_TRANSIT]: 'In transit',
	[INCOMING_ASSET_ORDER_STATUS.RECEIVED]: 'Received',
	[INCOMING_ASSET_ORDER_STATUS.CLOSED]: 'Closed',
	[INCOMING_ASSET_ORDER_STATUS.CANCELLED]: 'Cancelled',
};

export const INCOMING_ASSET_SETUP_TYPE = {
	MACHINE: 'MACHINE',
	MARKET: 'MARKET',
};

export const PLANOGRAM_ITEM_GROUP_TYPE = {
	FRIDGE: 1,
	SHELF: 2,
	COFFEE_MACHINE: 3,
};

export const PLANOGRAM_ITEM_GROUP_TYPE_NAME = {
	1: 'Fridge',
	2: 'Shelf',
	3: 'Coffee machine',
};


export const STOCK_DELIVERY_ENDS = {
	WAREHOUSE: 1,
	SUPPLIER: 2,
};

export const STOCK_DELIVERY_ENDS_NAMES = {
	1: 'Source quantity',
	2: 'Destination quantity',
};

export const AUTH_ERROR_CODES = {
	USERNAME_AND_PASSWORD_EMPTY: 1,
	INVALID_USERNAME: 2,
	INVALID_PASSWORD: 3,
	YOU_ARE_NOT_ALLOWED_TO_LOG_IN: 4,
	USER_INACTIVE: 5,
	USERS_ARE_NOT_ALLOWED_TO_LOG_IN: 6,
	ACCOUNT_INACTIVE: 7,
	WRONG_APP: 8,
	INVALID_TOKEN: 9,
	USER_NOT_FOUND: 10,
	ERROR: 11,
	PASSWORDS_ARE_DIFFERENT: 12,
	AUTHENTICATE_USER_NOT_FOUND: 13,
	INVALID_CURRENT_PASSWORD: 14,
	USER_ALREADY_EXISTS: 15,
	WRONG_EMAIL: 16,
	PASSWORD_MISMATCH: 17,
	MUST_BE_PROVIDED: 18,
	EMAIL_IN_USE: 19,
	TOO_MANY_ATTEMPTS: 20,
};

export const AUTH_ERROR_NAMES = {
	1: 'Both username and password must be provided',
	2: 'Invalid username',
	3: 'Invalid password',
	4: 'You are not allowed to log in here',
	5: 'This user is not active',
	6: 's are not allowed to log in here',
	7: 'Account inactive',
	8: 'Wrong app',
	9: 'Invalid token',
	10: 'User not found',
	11: 'error',
	12: 'Passwords are different',
	13: 'Error: authenticate - user not found',
	14: 'Invalid current password, please retry',
	15: 'User already exists',
	16: 'Wrong email',
	17: 'Password mismatch',
	18: 'must be provided',
	19: 'This email address is already in use',
	20: 'Too many attempts. Please try again in 15 minutes',
};

export const AUTH_NAMES = {
	LOGIN: 'Login',
	RESET: 'Reset password',
	SET_NEW_PASSWORD: 'Set new password',
	REGISTER: 'Register',
	CHANGE_EMAIL: 'Change Email',
};

export const SALES_GRAPH_TYPE = {
	DAILY_SALES: 1,
	WEEKLY_SALES: 2,
	DAILY_UNITS_SOLD: 3,
	WEEKLY_UNITS_SOLD: 4,
};

export const AUSTRALIAN_STATES = {
	NSW: 'NSW',
	VIC: 'VIC',
	QLD: 'QLD',
	TAS: 'TAS',
	SA: 'SA',
	WA: 'WA',
	NT: 'NT',
	ACT: 'ACT',
};

export const COUNTRY = {
	AUSTRALIA: 'au',
	CANADA: 'ca',
	GERMANY: 'de',
	INDIA: 'in',
	NEW_ZEALAND: 'nz',
	POLAND: 'pl',
	UNITED_KINGDOM: 'uk',
	UNITED_STATES: 'us',
};

export const POS_BASKET_LOG_CODES = {
	PRODUCT_ADDED_FROM_SCANNER: 1,
	PRODUCT_ADDED_FROM_LOOKUP: 2,
	SCANNED_PRODUCT_NOT_FOUND: 3,
	USER_NAVIGATED_TO_WELCOME_SCREEN: 4,
	USER_NAVIGATED_TO_PRODUCT_LOOKUP: 5,
	USER_PRESSED_NO_AT_CANCEL_DIALOG: 6,
	USER_PRESSED_YES_AT_CANCEL_DIALOG: 7,
	USER_PRESSED_CHECKOUT_BUTTON: 8,
	USER_NAVIGATED_TO_BASKET_SCREEN: 9,
	PAYMENT_STATUS_IDLE: 10,
	PAYMENT_STATUS_INIT: 11,
	PAYMENT_STATUS_PENDING: 12,
	PAYMENT_STATUS_PROCESSING: 13,
	PAYMENT_STATUS_SUCCES: 14,
	PAYMENT_STATUS_DECLINED: 15,
	PAYMENT_STATUS_ERROR: 16,
	PAYMENT_STATUS_TIMEOUT: 17,
	UNKNOWN_PAYMENT_ACTION: 18,
	NO_INTERACTION_TIMEOUT: 19,
	PICTURE_TAKEN: 20,
	TERMINAL_STATUS_ACTIVE: 21,
	TERMINAL_STATUS_OFFLINE: 22,
	TERMINAL_STATUS_MAINTENANCE: 23,
	PAYMENT_DEVICE_STATUS_ACTIVE: 24,
	PAYMENT_DEVICE_STATUS_OFFLINE: 25,
	NEW_TRANSACTION_STARTED: 26,
	START_OVER_BUTTON_PRESSED: 27,
	UPLOAD_IMAGE_ERROR: 28,
	PICTURE_PRELOADED: 29,
};

export const POS_BASKET_LOG_NAMES = {
	1: 'Product added to basket from scanner - ',
	2: 'Product added to basket from product lookup - ',
	3: 'Scanned product: *barcode* not found in market\'s planogram',
	4: 'User navigated to welcome screen',
	5: 'User navigated to product lookup',
	6: 'User pressed \'no\' on cancel transaction dialog',
	7: 'User pressed \'yes\' on cancel transaction dialog',
	8: 'User pressed checkout button',
	9: 'User navigated to basket view',
	10: 'Payment status: idle',
	11: 'Payment status: initialising',
	12: 'Payment status: pending',
	13: 'Payment status: processing',
	14: 'Payment status: success',
	15: 'Payment status: declined',
	16: 'Payment status: error',
	17: 'Payment status: timeout',
	18: 'Payment status: action',
	19: 'Basket timeout: no interaction within 5 minutes',
	20: 'Picture taken',
	21: 'Terminal status: active',
	22: 'Terminal status: offline',
	23: 'Terminal status: maintenance',
	24: 'Payment device status: active',
	25: 'Payment device status: offline',
	26: 'New transaction started',
	27: '\'Start over\' button pressed',
	28: 'Error occured while uploading image',
	29: 'Photo preloaded at transaction start',
};

export const POS_BASKET_LOG_TRIGGER_TYPE = {
	SYSTEM: 1,
	CUSTOMER: 2,
};

export const POS_BASKET_LOG_TRIGGER_TYPE_NAMES = {
	1: 'System',
	2: 'Customer',
};


export const POS_ITEM_ADDING_METHODS = {
	SCANNER: 1,
	LOOKUP: 2,
};

export const POS_ITEM_ADDING_METHODS_NAMES = {
	1: 'Scanner',
	2: 'Product Lookup',
};

export const PROMOTION_EFFECT_TYPE = {
	FIXED_PRICE: 1,
	DISCOUNT_PERCENTAGE: 2,
};

export const PROMOTION_EFFECT_TYPE_NAME = {
	1: 'Fixed price',
	2: 'Discount',
};

export const STOCK_MOVEMENT_PLACE_TYPE = {
	SUPPLIER: 1,
	WAREHOUSE: 2,
	DRIVER: 3,
	POS: 4,
	PENDING: 5,
};

export const STOCK_MOVEMENT_PLACE_TYPE_NAMES = {
	1: 'Supplier',
	2: 'Warehouse',
	3: 'Driver',
	4: 'POS',
	5: 'Pending stock',
};

export const STOCK_MOVEMENT_TYPE = {
	DELIVERY: 1,
	// SALE: 2, never used
	SPOILAGE: 3,
	RETURN: 4,
	STOCKTAKE: 5,
	PICKED: 6,
	UNPICKED: 7,
	RESTOCK: 8,
	REMOVED: 9,
	MISSING: 10,
	EXTRA: 11,
	PENDING_IN: 12,
	PENDING_OUT: 13,
	// Audit-only records: they never move stock or change a balance
	PICK_LIST_EDITED: 14,
	PICK_LIST_RECALCULATED: 15,
};

export const STOCK_MOVEMENT_TYPE_NAMES = {
	1: 'Delivery',
	// 2: 'Sale', never used
	3: 'Spoilage',
	4: 'Return',
	5: 'Stocktake',
	6: 'Picked',
	7: 'Unpicked',
	8: 'Restock',
	9: 'Removed',
	10: 'Missing',
	11: 'Extra',
	12: 'Pending in',
	13: 'Pending out',
	14: 'Pick list edited',
	15: 'Pick list recalculated',
};

export const WAREHOUSE_PRODUCT_REMOVAL_REASON = {
	SPOILAGE: 'spoilage',
	DAMAGED: 'damaged',
	EXPIRED: 'expired',
	GIVEN_TO_EMPLOYEE: 'given_to_employee',
	OTHER: 'other',
};

export const WAREHOUSE_PRODUCT_REMOVAL_REASON_NAMES = {
	[WAREHOUSE_PRODUCT_REMOVAL_REASON.SPOILAGE]: 'Spoilage',
	[WAREHOUSE_PRODUCT_REMOVAL_REASON.DAMAGED]: 'Damaged',
	[WAREHOUSE_PRODUCT_REMOVAL_REASON.EXPIRED]: 'Expired',
	[WAREHOUSE_PRODUCT_REMOVAL_REASON.GIVEN_TO_EMPLOYEE]: 'Given to employee',
	[WAREHOUSE_PRODUCT_REMOVAL_REASON.OTHER]: 'Other',
};

export const WAREHOUSE_BATCH_EXPIRY_DATE_SOURCE = {
	STOCK_DELIVERY: 'stockDelivery',
	MANUAL_WAREHOUSE_EDIT: 'manualWarehouseEdit',
	PICKER_CORRECTION: 'pickerCorrection',
	STOCKTAKE: 'stocktake',
	BACKFILL: 'backfill',
	UNKNOWN_LEGACY: 'unknownLegacy',
};

export const WAREHOUSE_BATCH_EXPIRY_DATE_SOURCE_NAME = {
	[WAREHOUSE_BATCH_EXPIRY_DATE_SOURCE.STOCK_DELIVERY]: 'Stock delivery',
	[WAREHOUSE_BATCH_EXPIRY_DATE_SOURCE.MANUAL_WAREHOUSE_EDIT]: 'Manual warehouse edit',
	[WAREHOUSE_BATCH_EXPIRY_DATE_SOURCE.PICKER_CORRECTION]: 'Picker correction',
	[WAREHOUSE_BATCH_EXPIRY_DATE_SOURCE.STOCKTAKE]: 'Stocktake',
	[WAREHOUSE_BATCH_EXPIRY_DATE_SOURCE.BACKFILL]: 'Backfill',
	[WAREHOUSE_BATCH_EXPIRY_DATE_SOURCE.UNKNOWN_LEGACY]: 'Unknown legacy',
};

export const PENDING_STOCK_SOURCE_TYPE = {
	REMOVED: 1,
	DELIVERY: 2,
	MANUAL: 3,
};

export const PENDING_STOCK_SOURCE_TYPE_NAMES = {
	1: 'Removed stock',
	2: 'Delivered stock',
	3: 'Manual add',
};

export const PENDING_STOCK_REASON_TYPE = {
	REMOVED_FROM_POS: 1,
	DELIVERED_NOT_STOCKED: 2,
	LOST_MACHINE_OR_MARKET: 3,
	MANUAL_ADJUSTMENT: 4,
};

export const PENDING_STOCK_REASON_TYPE_NAMES = {
	1: 'Removed from machine/market',
	2: 'Delivered not stocked',
	3: 'Lost machine/market',
	4: 'Manual adjustment',
};

export const DEFAULT_LAST_COMM_THRESHOLDS = [
	24,
	48,
];

export const DEFAULT_VENDOUT_THRESHOLDS = [
	1,
	5,
];

export const TRANSACTION_REFUNDABILITY_STATUS_CODES = {
	REFUNDABLE: 1,
	NOT_A_PURCHASE_TRANSACTION: 2,
	TENANT_IS_NOT_INTEGRATED_WITH_GATEWAY: 3,
	NO_EXTERNAL_ID: 4,
	CANNOT_BE_REFUNDED_VIA_SENTRY: 5,
	ERROR: 6,
	SUCCESS: 7,
};

export const TRANSACTION_REFUNDABILITY_STATUS_NAMES = {
	1: 'Refundable',
	2: 'This is not a purchase transaction',
	3: 'You are not integrated with *gateway*',
	4: 'This transaction has no *gateway* ID',
	5: 'This transaction cannot be refunded via Sentry',
	6: 'Error occured when refunding transaction',
	7: 'Transaction succesfully *status*',
};

export const COIN_VALUES = {
	au: [10, 20, 50, 100, 200],
};

export const DEFAULT_SALES_LAST_X_DAYS_THRESHOLDS = [
	1,
	3,
];

export const DEFAULT_LAST_REMOVED_DATE_THRESHOLDS = [
	30,
	60,
];

export const DEFAULT_DAYS_SINCE_LAST_SALE = 30;

export const DEFAULT_REQUIRED_COINS_TRESHOLDS = [10];
export const DEFAULT_REQUIRED_COINS_PERSENTAGE_TRESHOLDS = [50];

export const COINS_INDICATOR = {
	REQUIRED: 'Coin mech fill required',
	NOT_REQUIRED: 'No coin mech fill required',
};

export const IMPORT_TYPE = {
	INSERT: 1,
	UPDATE: 2,
	UPSERT: 3,
};

export const IMPORT_TYPE_NAMES = {
	1: 'Insert',
	2: 'Update',
	3: 'Upsert',
};

export const REPORT_TYPE = {
	PRODUCT_SPOILAGE: 1,
	PRODUCT_PRICING: 2,
	POS_PRODUCT: 3,
	MACHINES: 4,
	MACHINE_SPOILAGE: 5,
	CLIENTS: 6,
	DRIVERS: 7,
	DRIVER_TIME: 8,
	DRIVER_COMMISSIONS: 9,
	ROUTES: 10,
	INGREDIENTS: 11,
	CUSTOMER_INVOICING: 12,
	OPERATOR_BILLING: 13,
	PROFITABILITY: 14,
	PRODUCTS: 15,
	COMMISSIONS: 18,
	PERFORMANCE: 19,
	PERFORMANCE_YEAR_TO_YEAR: 20,
	MARKET_MISSING: 21,
	STOCK: 22,
	PICKLIST: 23,
	PICKLIST_PRODUCT: 24,
	PRODUCT_MISSING: 25,
	PICKING: 26,
	REFERRER: 27,
	PRODUCT_TYPE_SUMMARY: 28,
	HEALTH_COMPLIANCE: 29,
	SERVICE_RUN_DISCREPANCY: 30,
	LOCATION_SALES: 31,
	SUBSIDISED_SITE: 32,
	MARKET_CUSTOMERS: 33,
	ACCOUNT_MANAGER_NEW_BUSINESS_DETAILED: 34,
	ACCOUNT_MANAGER_NEW_BUSINESS_SUMMARY: 35,
	ACCOUNT_MANAGER_LEAD_CONVERSION: 36,
	ACCOUNT_MANAGER_PORTFOLIO: 37,
	COMMISSION_PRODUCT: 38,
	COMMISSION_POS: 39,
};

export const REPORT_TYPE_NAMES = {
	1: 'product-spoilage',
	2: 'product-pricing',
	3: 'pos-product',
	4: 'machines',
	5: 'machine-spoilage',
	6: 'clients',
	7: 'drivers',
	8: 'driver-time',
	9: 'driver-commissions',
	10: 'routes',
	11: 'ingredients',
	12: 'customer-invoicing',
	13: 'operator-billing',
	14: 'profitability',
	15: 'products',
	17: 'commission-group',
	18: 'commissions',
	19: 'performance',
	20: 'performance-year-to-year',
	21: 'market-missing',
	22: 'stock',
	23: 'picklist',
	24: 'picklistproduct',
	25: 'product-missing',
	26: 'picking',
	27: 'referrer',
	28: 'product-type-summary',
	29: 'health-compliance',
	30: 'service-run-discrepancy',
	31: 'location-sales',
	32: 'subsidy',
	33: 'market-customers',
	34: 'account-manager-new-business-detailed',
	35: 'account-manager-new-business-summary',
	36: 'account-manager-lead-conversion',
	37: 'account-manager-portfolio',
	38: 'commission-product',
	39: 'commission-pos',
};

export const MONTHLY_CLIENT_REPORT_TYPES = [
	REPORT_TYPE.MACHINES,
	REPORT_TYPE.MACHINE_SPOILAGE,
	REPORT_TYPE.PRODUCTS,
	REPORT_TYPE.PRODUCT_SPOILAGE,
	REPORT_TYPE.PRODUCT_PRICING,
	REPORT_TYPE.POS_PRODUCT,
	REPORT_TYPE.INGREDIENTS,
	REPORT_TYPE.CUSTOMER_INVOICING,
	REPORT_TYPE.PROFITABILITY,
	REPORT_TYPE.PERFORMANCE,
	REPORT_TYPE.PERFORMANCE_YEAR_TO_YEAR,
	REPORT_TYPE.MARKET_MISSING,
	REPORT_TYPE.PRODUCT_MISSING,
	REPORT_TYPE.PRODUCT_TYPE_SUMMARY,
	REPORT_TYPE.SERVICE_RUN_DISCREPANCY,
	REPORT_TYPE.LOCATION_SALES,
	REPORT_TYPE.SUBSIDISED_SITE,
	REPORT_TYPE.MARKET_CUSTOMERS,
	REPORT_TYPE.COMMISSION_PRODUCT,
	REPORT_TYPE.COMMISSION_POS,
];

export const MONTHLY_REPORT_TYPES = [
	...MONTHLY_CLIENT_REPORT_TYPES,
	REPORT_TYPE.REFERRER,
];

export const MONTHLY_REPORT_TYPE_NAME = {
	[REPORT_TYPE.MACHINES]: 'POS sales report',
	[REPORT_TYPE.MACHINE_SPOILAGE]: 'POS spoilage report',
	[REPORT_TYPE.PRODUCTS]: 'Product sales report',
	[REPORT_TYPE.PRODUCT_SPOILAGE]: 'Product spoilage report',
	[REPORT_TYPE.PRODUCT_PRICING]: 'Product pricing report',
	[REPORT_TYPE.POS_PRODUCT]: 'POS product report',
	[REPORT_TYPE.INGREDIENTS]: 'Ingredient report',
	[REPORT_TYPE.CUSTOMER_INVOICING]: 'Customer invoicing report',
	[REPORT_TYPE.PROFITABILITY]: 'Profitability report',
	[REPORT_TYPE.PERFORMANCE]: 'Performance report',
	[REPORT_TYPE.PERFORMANCE_YEAR_TO_YEAR]: 'Performance year-to-year report',
	[REPORT_TYPE.MARKET_MISSING]: 'Market missing report',
	[REPORT_TYPE.PRODUCT_MISSING]: 'Product missing report',
	[REPORT_TYPE.PRODUCT_TYPE_SUMMARY]: 'Product type summary',
	[REPORT_TYPE.SERVICE_RUN_DISCREPANCY]: 'Service run discrepancy report',
	[REPORT_TYPE.LOCATION_SALES]: 'Location sales report',
	[REPORT_TYPE.SUBSIDISED_SITE]: 'Subsidy report',
	[REPORT_TYPE.MARKET_CUSTOMERS]: 'Market customer report',
	[REPORT_TYPE.REFERRER]: 'Referrer report',
	[REPORT_TYPE.COMMISSION_PRODUCT]: 'Commission product report',
	[REPORT_TYPE.COMMISSION_POS]: 'Commission POS report',
};

export const SCOPING_MODEL_NAME = {
	ROUTE: 'Route',
	CLIENT: 'Client',
	REFERRER: 'Referrer',
	MANAGER: 'User',
};

export const REPORT_GROUP_RESOLVER_TYPE = {
	TOTAL_VALUE: 1,
	PERCENTAGE: 2,
	AVERAGE: 3,
	PER: 4,
};

export const MODIFIERS = {
	NUMBER: 1,
	CURRENCY: 2,
	DATE: 3,
	DATETIME: 4,
	ROUNDED: 5,
	PERCENT: 6,
	PERCENT_FROM_DECIMAL: 7,
	GRAM: 8,
	MILIGRAM: 9,
	ENERGY: 10,
	DURATION: 11,
	DURATION_MS: 12,
};

export const SETTINGS_TYPE = {
	LIST: 1,
	REPORT: 2,
};

export const SETTINGS_TYPE_NAMES = {
	1: 'List',
	2: 'Report',
};

export const DATE_RANGE_TYPE = {
	CURRENT: 1,
	LAST: 2,
	PREVIOUS: 3,
};

// moment month values for country FY years, e.q. 6 for July (Australia)
// FY in Australia ends in 30 of June
export const COUNTRY_FY_MONTHS = {
	[COUNTRY.AUSTRALIA]: 6,
};

export const PLANOGRAM_ITEM_MATCH_STRATEGY = {
	ROW_COLUMN: 1,
	SELECTION: 2,
	WRAP: 3,
};

export const PLANOGRAM_ITEM_MATCH_STRATEGY_NAME = {
	1: 'Match by row-column position',
	2: 'Match by selections',
	3: 'Wrap selections',
};

export const LOCATION_TYPE = {
	UNIVERSITY: 1, // Strong term-time sales, drops during holidays
	SCHOOL: 2, // K-12 schools with distinct term/holiday patterns
	LIBRARY: 3, // Study period peaks, exam time surges
	STUDENT_ACCOMMODATION: 4, // Follows academic calendar closely
	HOSPITAL: 5, // Consistent 24/7 demand, visitor/staff patterns
	MEDICAL_CLINIC: 6, // Business hours focused, appointment-driven traffic
	OFFICE_BUILDING: 7, // Monday-Friday peaks, weather affects foot traffic
	FACTORY: 8, // Shift-based patterns, blue-collar preferences
	GOVERNMENT_BUILDING: 9, // Stable weekday pattern, holiday closures
	GYM_FITNESS_CENTER: 10, // New Year peaks, summer preparations, weather-independent
	OUTDOOR_RECREATION: 11, // Parks, sports fields - highly weather-dependent
	INDOOR_ENTERTAINMENT: 12, // Cinemas, bowling - inverse weather correlation (busy when raining)
	TRANSPORT_HUB: 13, // Airports, train stations - holiday travel peaks, delay-driven sales
	SERVICE_STATION: 14, // Road trip seasons, weather-affected travel
	SHOPPING_CENTER: 15, // Weekend peaks, holiday shopping seasons
	HOTEL_MOTEL: 16, // Tourism seasons, business vs leisure patterns
	COMMUNITY_CENTER: 17, // Event-based spikes, seasonal programs
	RELIGIOUS_FACILITY: 18, // Weekly service patterns, holiday congregations
	RESIDENTIAL_COMPLEX: 19, // Stable daily patterns, weather affects outdoor machine usage
	SEASONAL_VENUE: 20, // Beaches, ski resorts, seasonal attractions - extreme seasonal variations
	OTHER: 21, // Miscellaneous locations
};

export const LOCATION_TYPE_NAME = {
	1: 'University',
	2: 'School',
	3: 'Library',
	4: 'Student accommodation',
	5: 'Hospital',
	6: 'Medical clinic',
	7: 'Office building',
	8: 'Factory',
	9: 'Government building',
	10: 'Gym/fitness center',
	11: 'Outdoor recreation',
	12: 'Indoor entertainment',
	13: 'Transport hub',
	14: 'Service station',
	15: 'Shopping center',
	16: 'Hotel/motel',
	17: 'Community center',
	18: 'Religious facility',
	19: 'Residential complex',
	20: 'Seasonal venue',
	21: 'Other',
};

export const PRODUCT_MIN_PICK_TYPE = {
	QUANTITY: 1,
	PAR_PERCENT: 2,
};

export const PRODUCT_MIN_PICK_TYPE_NAME = {
	1: 'Quantity',
	2: '% of par',
};

export const HEADER_FIELDS = {
	ALL_ROUTES: {
		text: 'All routes',
		target: '/routes',
	},
	ALL_SERVICE_RUNS: {
		text: 'All service runs',
		target: '/serviceruns',
	},
	ALL_SERVICES: {
		text: 'All services',
		target: '/services',
	},
	DAILY_VIEW: {
		text: 'Daily view',
		target: '/serviceruns/daily',
	},
	SERVICE_RUN_PLANNER: {
		text: 'Service run planner',
		target: '/serviceruns/planner',
	},
	PICKING_PLANNER: {
		text: 'Picking planner',
		target: '/picking-planner',
	},
	ROUTES_DIVIDER: {
		divider: true,
		title: 'Routes',
	},
	PLAN_SERVICE_RUN: {
		text: 'Plan service run',
		target: '/route/targetId/serviceruns/new',
	},
	FULL_HISTORY: {
		text: 'Full history',
		target: '/serviceruns/targetId',
	},
	ROUTE_DETAILS: {
		text: 'Route details',
		target: '/route/targetId',
	},
	LAST_5_SERVICES_DIVIDER: {
		divider: true,
		title: 'Last 5 service runs',
	},
	DASHBOARD: {
		label: 'Dashboard',
		target: '/dashboard',
	},
	RECOMMENDATIONS: {
		text: 'Recommendations',
		target: '/recommendations',
	},
	MACHINES: {
		text: 'Machines',
		target: '/machines',
	},
	MACHINES_AS_BUTTON: {
		label: 'Machines',
		target: '/machines',
	},
	PLANOGRAM_TEMPLATES: {
		text: 'Planogram templates',
		target: '/planograms',
	},
	MARKETS: {
		text: 'Markets',
		target: '/markets',
	},
	MARKET_FEEDBACK: {
		text: 'Market feedback',
		target: '/market-feedback',
	},
	ASSET_TEMPLATES: {
		text: 'Asset templates',
		target: '/assets',
	},
	PROMOTIONS_DIVIDER: {
		divider: true,
		hideLine: true,
		title: 'Promotions',
	},
	PURCHASES_DIVIDER: {
		divider: true,
		hideLine: true,
		title: 'Purchases',
	},
	BASKETS: {
		text: 'Baskets',
		target: '/baskets',
	},
	CUSTOMERS: {
		text: 'Customers',
		target: '/customers',
	},
	CAMPAIGNS: {
		text: 'Campaigns',
		target: '/campaigns',
	},
	PROMOTIONS: {
		text: 'Promotions',
		target: '/promotions',
	},
	CLIENT_SUBSIDIES: {
		text: 'Client subsidies',
		target: '/client-subsidies',
	},
	TRANSACTIONS: {
		text: 'Transactions',
		target: '/transactions',
	},
	CLIENTS: {
		text: 'Clients',
		target: '/clients',
	},
	SITE_PERMISSIONS: {
		text: 'Site permissions',
		target: '/site-permissions',
	},
	LOCATIONS: {
		text: 'Locations',
		target: '/locations',
	},
	PLACES: {
		text: 'Places',
		target: '/places',
	},
	ACCESS_PASSES: {
		text: 'Access passes',
		target: '/access-passes',
	},
	CONTACTS: {
		text: 'Contacts',
		target: '/contacts',
	},
	COMMISSIONS: {
		text: 'Commissions',
		target: '/commissions',
	},
	COMMISSION_RUNS: {
		text: 'Commission runs',
		target: '/commission-runs',
	},
	SUBSIDY_RUNS: {
		text: 'Subsidy runs',
		target: '/subsidy-runs',
	},
	KAM_COMMISSION_RUNS: {
		text: 'KAM commission runs',
		target: '/kam-commission-runs',
	},
	PRICE_GROUPS: {
		text: 'Price groups',
		target: '/price-groups',
	},
	PRICE_BOOKS: {
		text: 'Price books',
		target: '/price-books',
	},
	BULK_PRICE_ADJUSTMENTS: {
		text: 'Bulk price adjustments',
		target: '/bulk-price-adjustments',
	},
	REFERRERS: {
		text: 'Referrers',
		target: '/referrers',
	},
	GENERAL_DIVIDER: {
		divider: true,
		hideLine: true,
		title: 'General',
	},
	COMM_DEVICES: {
		text: 'Comm devices',
		target: '/commdevices',
	},
	POS_MAP: {
		text: 'POS map',
		target: '/pos-map',
	},
	LOCATION_MAP: {
		text: 'Locations maps',
		target: '/location-maps',
	},
	PHOTOS: {
		text: 'Photos',
		target: '/machine-photos',
	},
	DATA_HISTORY: {
		text: 'Data history',
		target: '/data-history',
	},
	EVENTS: {
		text: 'Events',
		target: '/events',
	},
	FLEET_DIVIDER: {
		divider: true,
		title: 'Fleet',
	},
	VEHICLES: {
		text: 'Vehicles',
		target: '/fleet/vehicles',
	},
	VEHICLE_SERVICES: {
		text: 'Vehicle services',
		target: '/fleet/vehicle-services',
	},
	CHECKLIST_TEMPLATES: {
		text: 'Checklists',
		target: '/checklists',
	},
	LIVE_MAP: {
		text: 'Live map',
		target: '/live-map',
	},
	ALERT_AND_TICKET_DIVIDER: {
		divider: true,
		title: 'Alerts & Tickets',
	},
	ALERTS: {
		text: 'Alerts',
		target: '/alerts',
	},
	TICKETS: {
		text: 'Tickets',
		target: '/tickets',
	},
	TICKET_TRIAGE_BOARD: {
		text: 'Ticket triage board',
		target: '/tickets/triage',
	},
	TICKET_SCHEDULES: {
		text: 'Ticket schedules',
		target: '/ticketSchedules',
	},
	PRODUCT_EXPIRY_CHECK_SCHEDULES: {
		text: 'Product expiry check schedules',
		target: '/productExpiryCheckSchedules',
	},
	SETUPS_DIVIDER: {
		divider: true,
		title: 'Setups',
	},
	INCOMING_ASSETS: {
		text: 'Incoming assets',
		target: '/incoming-assets',
	},
	TOOLS_DIVIDER: {
		divider: true,
		title: 'Tools',
	},
	MACHINE_IMPORT: {
		text: 'Machine import',
		target: '/tools/machine-import',
	},
	BULK_PLANOGRAM_EXPORT: {
		text: 'Bulk planogram export',
		target: '/tools/bulk-planogram-export',
	},
	TENANT_DATA_EXPORT: {
		text: 'Company data export',
		target: '/tools/tenant-export',
	},
	SALES_IMPORT: {
		text: 'Sales import',
		target: '/tools/sales-import',
	},
	ALLOCATE_SALES: {
		text: 'Re-allocate sales',
		target: '/tools/allocate-sales',
	},
	CANCELLED_TRANSACTIONS: {
		text: 'Cancelled transactions',
		target: '/tools/cancelled-transactions',
	},
	DEPUTY_CLOCK_OFF_AUDIT: {
		text: 'Deputy clock-off audit',
		target: '/tools/deputy-clock-off',
	},
	SALES_VALIDITY_SCHEDULE: {
		text: 'Sales validity schedule',
		target: '/tools/sales-validity',
	},
	PDF_REPORT: {
		text: 'PDF Report',
		target: '/tools/report-pdf-export',
	},
	COMMISSION_PRICES: {
		text: 'Product pricing models report',
		target: '/tools/product-pricing-models',
	},
	PRODUCTS_DIVIDER: {
		divider: true,
		hideLine: true,
		title: 'Products',
	},
	PRODUCTS: {
		text: 'Products',
		target: '/products',
	},
	PRODUCT_DISCONTINUATIONS: {
		text: 'Product discontinuations',
		target: '/product-discontinuations',
	},
	MANUFACTURERS: {
		text: 'Manufacturers',
		target: '/product-manufacturers',
	},
	PRODUCT_GALLERIES: {
		text: 'Product galleries',
		target: '/product-galleries',
	},
	WAREHOUSING_DIVIDER: {
		divider: true,
		title: 'Warehousing',
	},
	WAREHOUSES: {
		text: 'Warehouses',
		target: '/warehouses',
	},
	STOCK: {
		text: 'Stock',
		target: '/stock',
	},
	PENDING_STOCK: {
		text: 'Pending stock',
		target: '/pending-stock',
	},
	STOCKTAKES: {
		text: 'Stocktakes',
		target: '/stocktakes',
	},
	DELIVERIES: {
		text: 'Deliveries',
		target: '/deliveries',
	},
	SUPPLIERS: {
		text: 'Suppliers',
		target: '/suppliers',
	},
	PURCHASE_ORDER: {
		text: 'Purchase orders',
		target: '/purchase-orders',
	},
	FRESH_FOOD_ORDERING: {
		text: 'Fresh food ordering',
		target: '/fresh-food-orders',
	},
	STOCK_MOVEMENT_LOG: {
		text: 'Stock movement log',
		target: '/stock-movement-log',
	},
	WAREHOUSES_DIVIDER: {
		divider: true,
		title: 'Warehouses',
	},
	SELECTIONS: {
		text: 'Selections',
		target: '/selections',
	},
	WAREHOUSE_INFORMATION: {
		text: 'Information',
		target: '/warehouse/targetId',
	},
	WAREHOUSE_STOCK: {
		text: 'Stock',
		target: '/warehouse/targetId/stock',
	},
	WAREHOUSE_PENDING_STOCK: {
		text: 'Pending stock',
		target: '/warehouse/targetId/pending-stock',
	},
	WAREHOUSE_STOCKTAKES: {
		text: 'Stocktakes',
		target: '/warehouse/targetId/stocktakes',
	},
	WAREHOUSE_DELIVERIES: {
		text: 'Deliveries',
		target: '/warehouse/targetId/deliveries',
	},
	WAREHOUSE_PURCHASE_ORDER: {
		text: 'Purchase orders',
		target: '/warehouse/targetId/purchase-orders',
	},
	WAREHOUSE_STOCK_MONITORING: {
		text: 'Stock monitoring',
		target: '/warehouse/targetId/stock-monitoring',
	},
	WAREHOUSE_ORDERING: {
		text: 'Ordering',
		target: '/warehouse/targetId/ordering',
	},
	REPORTS_DIVIDER: {
		divider: true,
		hideLine: true,
	},
	REPORT_MACHINES_SALES: {
		target: '/report/machines',
	},
	REPORT_PERFORMANCE: {
		target: '/report/performance',
	},
	REPORT_PERFORMANCE_YEAR_TO_YEAR: {
		target: '/report/performance-year-to-year',
	},
	REPORT_MACHINE_SPOILAGE: {
		target: '/report/machine-spoilage',
	},
	REPORT_MARKET_MISSING: {
		target: '/report/market-missing',
	},
	REPORT_MARKET_CUSTOMERS: {
		text: 'Market customer report',
		target: '/report/market-customers',
	},
	REPORT_POS_PRODUCT: {
		target: '/report/pos-product',
	},
	LOCATION_REPORTS_DIVIDER: {
		divider: true,
		title: 'Location reports',
	},
	LOCATION_SALES_REPORT: {
		text: 'Location sales report',
		target: '/report/location-sales',
	},
	REPORT_REFERRER: {
		target: '/report/referrer',
		text: 'Referrer report',
	},
	CUSTOMER_INVOICING_REPORT: {
		text: 'Customer invoicing report',
		target: '/report/customer-invoicing',
	},
	PROFITABILITY_REPORT: {
		text: 'Profitability report',
		target: '/report/profitability',
	},
	SUBSIDISED_SITE_REPORT: {
		text: 'Subsidy report',
		target: '/report/subsidy',
	},
	PRODUCT_REPORTS_DIVIDER: {
		divider: true,
		title: 'Product reports',
	},
	PRODUCT_SALES_REPORT: {
		text: 'Product sales report',
		target: '/report/products',
	},
	PRODUCT_SPOILAGE_REPORT: {
		text: 'Product spoilage report',
		target: '/report/product-spoilage',
	},
	PRODUCT_PRICING_REPORT: {
		text: 'Product pricing report',
		target: '/report/product-pricing',
	},
	PRODUCT_TYPE_SUMMARY: {
		text: 'Product type summary',
		target: '/report/product-type-summary',
	},
	PRODUCT_MISSING_REPORT: {
		target: '/report/product-missing',
	},
	PICKING_REPORT: {
		text: 'Picking report',
		target: '/report/picking',
	},
	INGRIDIENT_REPORT: {
		text: 'Ingredient report',
		target: '/report/ingredients',
	},
	MARKET_REPORTS_DIVIDER: {
		divider: true,
		title: 'Market reports',
	},
	CLIENT_REPORTS_DIVIDER: {
		divider: true,
		title: 'Client reports',
	},
	CLIENT_SALES_REPORT: {
		text: 'Client sales report',
		target: '/report/clients',
	},
	COMMISSION_REPORT: {
		text: 'Commission report',
		target: '/report/commissions',
	},
	COMMISSION_PRODUCT_REPORT: {
		text: 'Commission product report',
		target: '/report/commission-product',
	},
	COMMISSION_POS_REPORT: {
		text: 'Commission POS report',
		target: '/report/commission-pos',
	},
	REFERRER_REPORT: {
		text: 'Referrer report',
		target: '/report/referrer',
	},
	ACCOUNT_MANAGER_REPORTS_DIVIDER: {
		divider: true,
		title: 'Account manager reports',
	},
	ACCOUNT_MANAGER_NEW_BUSINESS_DETAILED_REPORT: {
		text: 'New business report (detailed)',
		target: '/report/account-manager-new-business-detailed',
	},
	ACCOUNT_MANAGER_NEW_BUSINESS_SUMMARY_REPORT: {
		text: 'New business report (summary)',
		target: '/report/account-manager-new-business-summary',
	},
	ACCOUNT_MANAGER_LEAD_CONVERSION_REPORT: {
		text: 'Lead conversion report',
		target: '/report/account-manager-lead-conversion',
	},
	ACCOUNT_MANAGER_PORTFOLIO_REPORT: {
		text: 'Portfolio report',
		target: '/report/account-manager-portfolio',
	},
	OTHER_REPORTS_DIVIDER: {
		divider: true,
		title: 'Other reports',
	},
	MONTHLY_REPORTING_DIVIDER: {
		divider: true,
		title: 'Recurring reporting',
	},
	MONTHLY_REPORTS: {
		text: 'Recurring reports',
		target: '/monthly-reporting/reports',
	},
	MONTHLY_REPORT_RUNS: {
		text: 'Recurring report runs',
		target: '/monthly-reporting/runs',
	},
	DRIVER_COMMISSIONS_REPORT: {
		text: 'Driver commission report',
		target: '/report/driver-commissions',
	},
	DRIVER_REPORT: {
		text: 'Driver report',
		target: '/report/drivers',
	},
	DRIVER_TIME_REPORT: {
		text: 'Driver time report',
		target: '/report/driver-time',
	},
	SERVICE_RUN_DISCREPANCY_REPORT: {
		text: 'Service run discrepancy report',
		target: '/report/service-run-discrepancy',
	},
	ROUTE_REPORT: {
		text: 'Route report',
		target: '/report/routes',
	},
	PICKLIST_REPORT: {
		text: 'Pick list report',
		target: '/report/picklist',
	},
	PICKLIST_PRODUCT_REPORT: {
		text: 'Pick list product report',
		target: '/report/picklistproduct',
	},
	STOCK_REPORT: {
		text: 'Stock report',
		target: '/report/stock',
	},
	HEALTH_COMPLIANCE_REPORT: {
		text: 'Health compliance report',
		target: '/health-compliance',
	},
	USERS: {
		text: 'Users',
		target: '/users',
	},
	ROLES: {
		text: 'Roles',
		target: '/roles',
	},
	LOCATION_SETUPS: {
		text: 'Location setups',
		target: '/location-setups',
	},
	MACHINE_SETUPS: {
		text: 'Machine setups',
		target: '/machine-setups',
	},
	MARKET_SETUPS: {
		text: 'Market setups',
		target: '/market-setups',
	},

	// LINK APP
	OPERATORS: {
		label: 'Operators',
		target: '/operators',
	},
	COMMUNICATION_DEVICES: {
		text: 'Communication devices',
		target: '/commdevices',
	},

	// ADMIN APP
	PRODUCT_MANUFACTURERS: {
		text: 'Product manufacturers',
		target: '/product-manufacturers',
	},
	REPORT_OPERATOR_BILLING: {
		text: 'Operator billing',
		target: '/report/operator-billing',
	},
	PRODUCT_LOOKUP: {
		text: 'Product lookup',
		target: '/product-lookup',
	},
	PRODUCT_IMPORT: {
		text: 'Product import',
		target: '/product-import',
	},
	COMMUNICATION: {
		label: 'Communication',
		target: '/communication',
	},
	KIOSK: {
		label: 'Kiosks',
		target: '/commDevices',
	},
	USER_MONITORING: {
		text: 'Monitoring',
		target: '/user-monitoring',
	},
};

export const SENTRY_MARKETS_ROUTE_LABELS = {
	HOME: 'Home',
	BARCODE_SCANNER: 'Barcode scanner',
	PRODUCT_LOOKUP: 'Search',
	WALLET: 'Wallet',
	BASKET: 'Cart',
	TRACKING: 'Tracking',
	WELCOME: 'Welcome',
	GUIDE: 'Guide',
	LOGIN: 'Login',
	REGISTER: 'Register',
	RESET_PASSWORD: 'Reset password',
	REMIND_PASSWORD: 'Remind password',
	AUTH: 'Auth',
	BOARDING: 'Boarding',
	MAIN: 'Main',
	ORDERS: 'Past orders',
	PERSONAL_DATA: 'Personal data',
};

export const CREDIT_CARD_BRAND = {
	VISA: 1,
	MASTERCARD: 2,
};

export const CREDIT_CARD_BRAND_NAME = {
	1: 'Visa',
	2: 'Mastercard',
};

export const MACHINE_DOCUMENT_HISTORY_FIELDS = {
	commDevice: 'Communication Device',
	machineKey: 'Machine Key',
	coinMech: 'Coin Mech',
	parlevel: 'Parlevel',
	location: 'Location',
	place: 'Place',
	assetId: 'Asset ID',
	directions: 'Directions',
	wrap: 'Wrap',
	description: 'Description',
	quantity: 'Quantity',
	price: 'Price',
	capacity: 'Capacity',
	product: 'Product',
	accessHours: 'Access Hours',
	routerModel: 'Router model',
	simNumber: 'SIM number',
};

export const DOCUMENT_HISTORY_FIELDS = {
	dataHistory: {
		name: 'Name',
		defaultPrice: 'Default price',
		priceGroup: 'Product membership',
		commDevice: 'Communication Device',
		machineKey: 'Machine Key',
		coinMech: 'Coin Mech',
		parlevel: 'Parlevel',
		location: 'Location',
		place: 'Place',
		assetId: 'Asset ID',
		directions: 'Directions',
		wrap: 'Wrap',
		description: 'Description',
		quantity: 'Quantity',
		price: 'Price',
		capacity: 'Capacity',
		product: 'Product',
		accessHours: 'Access Hours',
		client: 'Client',
		city: 'City',
		street: 'Street',
		person: 'Primary contact',
		secondaryPerson: 'Secondary contact',
	},
	machine: {
		commDevice: 'Communication Device',
		machineKey: 'Machine Key',
		coinMech: 'Coin Mech',
		parlevel: 'Parlevel',
		location: 'Location',
		place: 'Place',
		assetId: 'Asset ID',
		directions: 'Directions',
		wrap: 'Wrap',
		description: 'Description',
		quantity: 'Quantity',
		price: 'Price',
		capacity: 'Capacity',
		product: 'Product',
		accessHours: 'Access Hours',
		routerModel: 'Router model',
		simNumber: 'SIM number',
	},
	location: {
		client: 'Client',
		city: 'City',
		street: 'Street',
		region: 'State',
		postcode: 'Postcode',
		person: 'Primary contact',
		secondaryPerson: 'Secondary contact',
	},
	client: {
		name: 'Name',
		city: 'City',
		street: 'Street',
		region: 'State',
		postcode: 'Postcode',
		person: 'Primary contact',
		secondaryPerson: 'Secondary contact',
	},
	priceBook: {
		clients: 'Clients',
	},
	priceGroup: {
		name: 'Name',
		defaultPrice: 'Default price',
		priceGroup: 'Product membership',
	},
	lead: {
		name: 'Company name',
		person: 'Contact',
		assignee: 'Assignee',
		type: 'Type',
		status: 'Status',
		source: 'Source',
		websiteOrigin: 'Website',
		message: 'Enquiry message',
		companySize: 'Company size',
		suburb: 'Suburb',
		state: 'State',
		securedAt: 'Secured at',
		deadReason: 'Dead reason',
		client: 'Client',
		lastContactAt: 'Last contact',
		nextFollowUpAt: 'Next follow-up',
	},
	vehicleService: {
		vehicle: 'Vehicle',
		date: 'Date',
		odometer: 'Odometer',
		status: 'Status',
	},
	vehicle: {
		name: 'name',
		registration: 'registration',
	},
	product: {
		name: 'Name',
		cost: 'Cost',
		defaultPrice: 'Default price',
		size: 'Size',
		sizeUnit: 'Size unit',
		caseSize: 'Case size',
		audioName: 'Audio name',
		minPickType: 'Min pick type',
		minPick: 'Min pick',
		HCGCategory: 'HCG category',
		HFDCategory: 'HFD category',
		taxRate: 'GST rate',
		barodes: 'Barcodes',
		type: 'Type',
		excludeFromStock: 'Exclude from stock',
		excludeFromRecommended: 'Exclude from recommended',
		disabledForPlanograms: 'Disabled for planograms',
	},
	machineSetup: {
		type: 'Type',
		machine: 'Machine',
		commDevice: 'Comm device',
		route: 'Route',
		place: 'Place',
		planogram: 'Required planogram',
		assignees: 'Assignees',
		machineQualityObject: 'Required machine quality',
		machineSizeObject: 'Required machine size',
		requiredDoorAngle: 'Required door angle',
		requiresCreditCardReader: 'Requires credit card reader',
		requiresCashPayments: 'Requires cash payment',
		HCGCompliant: 'HCG compilant',
		requiresExtensionLead: 'Requires extenstion lead',
		additionalInstructions: 'Additional instructions',
		checkPowerCord: 'Check power cord',
		cleanMachine: 'Clean machine',
		install8888LockBarrel: 'Install 8888 locak barrel',
		turnOffGlassHeater: 'Turn off glass heater',
		unlockCoinBox: 'Unlock coin box',
		installPaddingInDropBin: 'Install padding in drop bin',
		ensureMachineIdIsPresentOnMachine: 'Ensure machine id is present on machine',
		applyPricingStickerOrPriceTags: 'Apply pricing sicker or price tags',
		installNoteReader: 'Install note reader',
		ensureNoteReaderAcceptsNewBills: 'Ensure note reader accepts new bills',
		installCoinMech: 'Install coin mech',
		fillCoinMechFloatInstallCassette: 'Fill coin mech float and install cassette',
		testCoinMechByDispensingCoins: 'Test coin mech by dispensing coins',
		installCreditCardReader: 'Install credit card reader',
		alignAllCoilsAndTest: 'Align all coils and test vend all coils',
		alignSelectionNumbers: 'Align selection numbers',
		priceMachineElectronically: 'Price machine electronically',
		ensureProductsFitCoils: 'Ensure products fit coils',
		setMachineTemperature: 'Set machine temperature',
		removeTipperBars: 'Remove tipper bars',
		testAllPaymentDevices: 'Test all payment devices',
		sendDexFile: 'Send a dex file',
		cleanMachineCompressor: 'Clean the machine compressor',
		leaveVentilationChute: 'Leave ventilation chute in drop bin and sliders in cabinets',
		updatePosSignage: 'Add / remove relevant POS signage from machine (Fruit2Work or other)',
		loadBranding: 'Load branding onto machine screen',
		machineType: 'Machine type',
		machineKey: 'Machine key',
		machineWrap: 'Machine wrap',
		machineModel: 'Machine model',
		machineDistributor: 'Machine distributor',
		machineCoinMech: 'Machine coin mech',
		machineNoteReader: 'Machine note reader',
		machineSerialNumber: 'Machine serial number',
		buildDate: 'Build date',
		creditCardReaderType: 'Credit card reader type',
		paymentDeviceSerialNo: 'Payment device serial number',
		verifyCreditCardTransaction: 'Verify credit card transaction',
		sendEmail: 'Send email',
		updateAllMachineInformation: 'Update all machine information in Sentry',
		removeOldDirectionsAndNotes: 'Remove old directions & notes',
	},
	marketSetup: {
		assignees: 'Assignees',
		place: 'Place',
		machine: 'Machine',
		route: 'Route',
		planogram: 'Required planogram',
		commDevices: 'Comm devices',
		requiresCreditCardReader: 'Requires credit card reader',
		requiresCashPayments: 'Requires cash payments',
		additionalInstructions: 'Additional instructions',
		stickyNote: 'Put a sticky note on the kiosk(s)',
		assignKiosk: 'Assign the kiosk (comm device) to the market in Sentry',
		paymentDevicesSerialNo: 'Credit card reader',
		testNayaxTransaction: 'Do a test transaction on the Windcave device and confirm receipt',
		phoneTransactionTest: 'Do a test phone transaction on the Windcave device and confirm receipt',
		verifySalesTransactionInSentry: 'Verify the sales transactions in Sentry',
		liftDimensions: 'Confirm lift dimensions',
		availableWidth: 'Confirm available width (mm)',
		availableHeight: 'Confirm available height (mm)',
		availableDepth: 'Confirm available depth (mm)',
		setUpSentryPlanogram: 'Set up Sentry planogram',
		clientCurrentVendingSetup: 'Client current vending setup',
		internetConnectivity: 'Internet connectivity',
		routerModel: 'Router model',
		simNumber: 'SIM number',
		marketType: 'Market type',
		marketFinish: 'Market finish',
		customFinish: 'Custom finish',
		marketBays: 'Market bays',
		informClientOfRelevantInformation: 'Inform client of relevant information',
		sendEmail: 'Send email',
		purchaseOrAllocateFridges: 'Purchase or allocate fridges',
		setUpRequiredFridges: 'Set up required fridges',
		purchaseOrAllocateGondolaShelving: 'Purchase or allocate Gondola shelving',
		confirmConfiguration: 'Confirm configuration with Kamil',
		bookRemovalOfVendingMachines: 'Book removal of vending machines if applicable',
		organiseEmptyingOfVendingMachine: 'Organise emptying of vending machine if applicable',
		purchaseOrAllocateModem: 'Purchase or allocate modem to supply internet connectivity',
		testInternetConnectivity: 'Test for internet connectivity',
		organiseInstallationOfMM: 'Organise installation of the micro market',
	},
	stocktake: {
		warehouse: 'Warehouse',
		user: 'Performer',
		date: 'Date',
		lastSubmit: 'Last submit',
		status: 'Status',
		valueOfDifference: 'Value of difference',
		valueNotAccurate: 'Value not accurate',
		percentageDifference: 'Percentage difference',
		description: 'Description',
		warehouseProduct: 'Product',
		preStocktakeQuantity: 'Pre stocktake quantity',
		quantity: 'Post stocktake quantity',
	},
	locationSetup: {
		dueDate: 'Due date',
		subscribers: 'Subscribers',
		bookTransport: 'Machine transport booked',
		sendEmail: 'Send email',
	},
};

export const DOCUMENT_HISTORY_MODELS = {
	dataHistory: {
		PriceGroup: 'Price group',
		PlanogramItem: 'Selection',
		Machine: 'Machine/Market',
		Note: 'Note',
		Location: 'Location',
		Address: 'Address',
	},
	machine: {
		PlanogramItem: 'Selection',
		Machine: 'Machine/Market',
		Note: 'Note',
	},
	location: {
		Note: 'Note',
		Location: 'Location',
		Address: 'Address',
	},
	client: {
		Client: 'Client',
		Address: 'Address',
	},
	priceBook: {
		PriceBook: 'Price book',
	},
	priceGroup: {
		PriceGroup: 'Price group',
		Product: 'Product',
	},
	lead: {
		Lead: 'Lead',
		Note: 'Note',
	},
	vehicleService: {
		VehicleService: 'Vehicle service',
	},
	vehicle: {
		Vehicle: 'Vehicle',
	},
	product: {
		Product: 'Product',
	},
	stocktake: {
		Stocktake: 'Stocktake',
		StocktakeItem: 'Stocktake item',
	},
	machineSetup: {
		MachineSetup: 'Machine setup',
	},
	marketSetup: {
		MarketSetup: 'Market setup',
	},
	locationSetup: {
		LocationSetup: 'Location setup',
	},
};

export const PLANOGRAM_PRODUCT_SELECTOR_TABS = {
	ALL: 1,
	FAVOURITES: 2,
	RECOMMENDED: 3,
};

export const TOTAL_PRODUCTS_FOOTER = 'Total products in market:';

export const VEHICLE_MAKES = [
	{ name: 'BYD', models: ['Dolphin Premium'] },
	{ name: 'Fiat', models: ['Ducato Maxi'] },
	{ name: 'Holden', models: ['Berlina'] },
	{ name: 'Hyundai', models: ['iLoad'] },
	{ name: 'Jeep', models: [] },
	{ name: 'LDV', models: ['V80', 'G10', 'G10+'] },
	{ name: 'Mercedes', models: ['Vito', 'Sprinter'] },
	{ name: 'Mitsubishi', models: ['Outlander Station Wagon', 'FUSO CANTER 815'] },
	{ name: 'Tesla', models: ['Model 3'] },
	{ name: 'Toyota', models: [] },
];

export const VEHICLE_TYPES = {
	ACCOUNT_MANAGEMENT: 'Account management',
	DELIVERY_INSTALLATIONS: 'Delivery / installations',
	SERVICE_STOCKING: 'Service / stocking',
};

// Single ordered source for the vehicle Type selector, list column, validation and backfill.
export const VEHICLE_TYPE_VALUES = [
	VEHICLE_TYPES.SERVICE_STOCKING,
	VEHICLE_TYPES.DELIVERY_INSTALLATIONS,
	VEHICLE_TYPES.ACCOUNT_MANAGEMENT,
];

export const COLORS = ['White', 'Silver', 'Red', 'Black', 'Blue', 'Yellow'];

export const MACHINE_QUALITY_NAME = {
	1: 'Brand New',
	2: 'Near New',
	3: 'Mid Range',
	4: 'Low Range (Warehouse)',
	5: 'Building Site',
};

export const MACHINE_QUALITY = {
	BRAND_NEW: 1,
	NEAR_NEW: 2,
	MID_RANGE: 3,
	LOW_RANGE: 4,
	BUILDING_SITE: 5,
};

export const MACHINE_SIZE = {
	XL: 1,
	LARGE: 2,
	MEDIUM: 3,
	SMALL: 4,
};

export const MACHINE_SIZE_NAME = {
	1: '6-wide',
	2: '5-wide',
	3: '4-wide',
	4: '3-wide',
};

export const MACHINE_DOOR_ANGLE = {
	NO_RESTRICTION: 1,
	NINETY_DEGREES: 2,
};

export const MACHINE_DOOR_ANGLE_NAME = {
	1: 'No restriction',
	2: '90 degrees (restricted by wall - needs YZ or similar)',
};

export const MACHINE_SETUP_PREFERENCE_VALUE = {
	PREFERABLE: 1,
	ACCEPTABLE: 2,
	NOT_ACCEPTABLE: 3,
};

export const MACHINE_SETUP_PREFERENCE_VALUE_NAME = {
	1: 'Preferable',
	2: 'Acceptable',
	3: 'Not acceptable',
};

export const MACHINE_SETUP_BRANDING_VALUE = {
	LOADED_BRANDING: 1,
	NOT_APPLICABLE: 2,
};

export const MACHINE_SETUP_BRANDING_VALUE_NAME = {
	1: 'Loaded branding',
	2: 'Not applicable (no screen)',
};

export const MACHINE_SETUP_MACHINE_TYPE = {
	M3000: 1,
	M4000: 2,
	M5000: 3,
	M6000: 4,
	YZ250: 5,
	YZ450: 6,
	YZ550: 7,
	ROYAL_VISION_VENDOR: 8,
	VM5: 9,
};

export const MACHINE_SETUP_MACHINE_TYPE_NAME = {
	1: 'M3000',
	2: 'M4000',
	3: 'M5000',
	4: 'M6000',
	5: 'YZ250',
	6: 'YZ450',
	7: 'YZ550',
	8: 'ROYAL_VISION_VENDOR',
	9: 'VM5',
};


export const MACHINE_SETUP_MACHINE_DISTRIBUTOR = {
	ALL_ROUND_VENDING: 1,
	AVS: 2,
	DG: 3,
	VENDZONE: 4,
	WORLDWIDE: 5,
};

export const MACHINE_SETUP_MACHINE_DISTRIBUTOR_NAME = {
	1: 'All Round Vending',
	2: 'AVS',
	3: 'DG',
	4: 'Vendzone',
	5: 'Worldwide',
};

export const MACHINE_SETUP_COIN_MECH_TYPE = {
	CPI_CASHFLOW_7000: 1,
	CPI_GRYPHON: 2,
	NONE: 3,
};

export const MACHINE_SETUP_COIN_MECH_TYPE_NAME = {
	1: 'CPI Cashflow 7000',
	2: 'CPI Gryphon',
	3: 'None',
};

export const MACHINE_SETUP_NOTE_READER_TYPE = {
	CPI5_IN_1BEZEL: 1,
	CPI_TALOS: 2,
	ICT_V5: 3,
};

export const MACHINE_SETUP_NOTE_READER_TYPE_NAME = {
	1: 'CPI 5 -in- 1 Bezel',
	2: 'CPI Talos',
	3: 'ICT V5',
};

export const MACHINE_SETUP_CREDIT_CARD_READER_TYPE = {
	CPI5_IN_1BEZEL: 1,
	NAYAX_AMIT: 2,
	NAYAX_VPOS_TOUCH: 3,
	WINDCAVE_SCR200VN: 4,
};

export const MACHINE_SETUP_CREDIT_CARD_READER_TYPE_NAME = {
	1: 'CPI 5 -in- 1 Bezel',
	2: 'Nayax AMIT (old reader)',
	3: 'Nayax VPOS Touch',
	4: 'Windcave SCR200VN',
};

export const YES_NO_VALUE = {
	YES: 1,
	NO: 2,
	UNSURE: 3,
};

export const YES_NO_VALUE_NAME = {
	1: 'Yes',
	2: 'No',
	3: 'Unsure',
};

export const CLIENT_CURRENT_VENDING_SETUP_VALUE = {
	WE_HAVE_MACHINES_AT_CLIENT_LOCATION_WCHICH_WE_WILL_REMOVE: 1,
	COMPETITOR_HAS_MACHINES_AT_CLITEN_LOCATION_WHICH_WILL_BE_REMOVED: 2,
	COMPETITOR_HAS_MACHINES_AT_CLIENT_LOCATION_WHICH_WILL_REMAIN_ON_SITE: 6,
	CLIENT_HAS_NO_VENDING_MACHINES: 3,
	WE_HAVE_MACHINES_AT_CLIENT_LOCATION_BUT_THEY_WILL_REMAIN_ONSITE: 4,
	WE_ARE_ALSO_SUPPLYING_THE_CLIENT_WITH_VENDING_MACHINES: 5,
};

export const CLIENT_CURRENT_VENDING_SETUP_VALUE_NAME = {
	1: 'We have machines at client location which we will remove',
	2: 'Competitor has machines at client location which will be removed',
	6: 'Competitor has machines at client location which will remain on site',
	3: 'Client has no vending machines',
	4: 'We have machines at client location but they will remain on-site',
	5: 'We are also supplying the client with vending machines',
};

export const CLIENT_SUBSIDY_TYPE = {
	CASH: 1,
	AGORA_POINTS: 2,
};

export const CLIENT_SUBSIDY_TYPE_NAME = {
	1: 'Cash',
	2: 'Agora Points',
};

export const INTERNET_CONNECTIVITY = {
	CLIENT_ETHERNET: 1,
	CLIENT_WIFI: 2,
	CLIENT_USB_MODEM: 3,
	AGORA_USB_MODEM: 4,
};

export const INTERNET_CONNECTIVITY_NAME = {
	1: 'Client Ethernet',
	2: 'Client Wi-Fi',
	3: 'Client USB Modem',
	4: 'Agora USB Modem',
};


export const MARKET_SETUP_MARKET_TYPE = {
	GONDOLA_SHELVING: 1,
	CUSTOM_BUILD: 2,
	GAME_CHANGER: 3,
};

export const MARKET_SETUP_MARKET_TYPE_NAME = {
	1: 'Gondola shelving',
	2: 'Custom build',
	3: 'Game changer',
};

export const MARKET_SETUP_FOOD_OPTIONS = {
	FRESH_FOOD: 1,
	MICROWAVE_MEALS: 2,
	SUSHI: 3,
	YOGHURTS: 4,
	CHEESE: 5,
	DIPS: 6,
	CUSTOM: 99,
};

export const MARKET_SETUP_FOOD_OPTIONS_NAME = {
	1: 'Fresh food',
	2: 'Microwave meals',
	3: 'Sushi',
	4: 'Yoghurts',
	5: 'Cheese',
	6: 'Dips',
	99: 'Custom',
};

export const MARKET_SETUP_MARKET_FINISH_VALUE = {
	BLACK: 1,
	WHITE: 2,
	BAVARIAN_OAK: 3,
	OTHER: 4,
};

export const MARKET_SETUP_MARKET_FINISH_VALUE_NAME = {
	1: 'Black',
	2: 'White',
	3: 'Bavarian oak',
	4: 'Other',
};

export const MARKET_SETUP_BAY_VALUE = {
	SMALL_SHELVING_600: 1,
	MEDIUM_SHELVING_914: 2,
	LARGE_SHELVING_1200: 3,
	SINGLE_DOOR_HELLER_690: 4,
	DOUBLE_DOOR_HELLER_1200: 5,
	SKOPE_FRIDGE: 6,

	CUSTOM_SHELVING: 100,
};

export const MARKET_SETUP_BAY_VALUE_NAME = {
	1: 'Small Shelving (600)',
	2: 'Medium Shelving (914)',
	3: 'Large Shelving (1200)',
	4: 'Single-door Heller (690)',
	5: 'Double-door Heller (1200)',
	6: 'Skope Fridge (1280)',

	100: 'Custom Shelving',
};

export const PRODUCT_SUB_TYPE = {
	WATER_AND_VARIANTS: 1,
	SOFT_DRINKS: 2,
	ENERGY_DRINKS: 3,
	BETTER_FOR_YOU_DRINKS: 4,
	PROTEIN_SHAKES_AND_FITNESS_DRINKS: 5,
	MILK_BASED_DRINKS_AND_ALTERNATIVES: 6,
	COFFEE_AND_TEA_VARIANTS: 7,
	ASIAN_DRINKS: 8,
	FRESH_MEALS: 9,
	CHOCOLATE_AND_CONFECTIONARY: 10,
	POTATO_CHIPS_AND_SAVOURY_SNACKS: 11,
	PROTEIN_BARS_AND_FITNESS_SNACKS: 12,
	BETTER_FOR_YOU_BARS: 13,
	BETTER_FOR_YOU_SNACKS: 14,
	COOKIES_AND_BAKED_GOODS: 15,
	ASIAN_SNACKS: 16,
	ASIAN_MEALS: 17,
	ICE_CREAMS: 18,
	MEALS: 19,
	FROZEN_MEALS: 20,
	ELECTRONICS: 21,
	STATIONERY: 22,
	SANITARY: 23,
	MEDICAL: 24,
	PPE: 25,
	SUSTAINABLE_PRODUCTS: 26,
	BABY_PRODUCTS: 27,
	MISCELLANEOUS: 28,
};

export const PRODUCT_SUB_TYPE_NAME = {
	1: 'Water, sparkling water and water variants',
	2: 'Soft drinks',
	3: 'Energy drinks',
	4: 'Better-for-you drinks',
	5: 'Protein shakes and fitness drinks',
	6: 'Milk-based drinks and milk alternatives',
	7: 'Coffee and tea variants',
	8: 'Asian drinks',
	9: 'Fresh meals',
	10: 'Chocolate bars and confectionary',
	11: 'Potato chips, crisps and other savoury snacks',
	12: 'Protein bars and fitness snacks',
	13: 'Better-for-you bars',
	14: 'Better-for-you snacks',
	15: 'Cookies and baked goods',
	16: 'Asian snacks',
	17: 'Asian meals',
	18: 'Ice creams',
	19: 'Meals',
	20: 'Frozen meals',
	21: 'Electronics',
	22: 'Stationery',
	23: 'Sanitary',
	24: 'Medical',
	25: 'PPE',
	26: 'Sustainable products',
	27: 'Baby products',
	28: 'Miscellaneous',
};

export const MARGIN_THRESHOLDS = [55, 60];

export const REQUEST_METHODS_TYPE = {
	PHONE_CALL: 1,
	VOICEMAIL: 2,
	EMAIL: 3,
	DRIVER_REPORT: 4,
	WEBSITE: 5,
};

export const REQUEST_METHOD_TYPE_NAME = {
	1: 'Phone call',
	2: 'Voicemail',
	3: 'Email',
	4: 'Driver report',
	5: 'Website',
};

export const PLANOGRAM_PRODUCT_SELECTOR_TYPE = {
	ALL: 1,
	FAVOURITE: 2,
	RECOMMENDED_PRODUCTS: 3,
};

export const PLANOGRAM_PRODUCT_SELECTOR_TYPE_NAME = {
	1: 'All',
	2: 'Favourite',
	3: 'Recommended products',
};

export const PRODUCT_CHECK_SCHEDULE_PRODUCT_FILTER_BY = {
	PRODUCT: 1,
	TAG: 2,
};

export const PRODUCT_CHECK_SCHEDULE_PRODUCT_FILTER_BY_NAME = {
	1: 'Product',
	2: 'Tag',
};

export const PRODUCT_CHECK_SCHEDULE_MACHINE_FILTER_BY = {
	MACHINE: 1,
	TAG: 2,
};

export const PRODUCT_CHECK_SCHEDULE_MACHINE_FILTER_BY_NAME = {
	1: 'Machine',
	2: 'Tag',
};

export const PRODUCT_EXPIRY_CHECK_SCHEDULE_TYPE = {
	FIXED: 1,
	FLEXIBLE: 2,
};

export const PRODUCT_EXPIRY_CHECK_SCHEDULE_TYPE_NAME = {
	1: 'Fixed',
	2: 'Flexible',
};

export const PDF_REPORT_PERIODS = {
	LAST_MONTH: 1,
	LAST_QUARTER: 2,
};

export const PDF_REPORT_PERIODS_NAMES = {
	1: 'Last month',
	2: 'Last quarter',
};

export const HFD_SELECTOR_OPTIONS = [
	{ label: 'Everyday', value: 'Everyday' },
	{ label: 'Occasional', value: 'Occasional' },
	{ label: 'n/a', value: 'n/a' },
];

export const HCG_SELECTOR_OPTIONS = [
	{ label: 'Green', value: 'Green' },
	{ label: 'Amber', value: 'Amber' },
	{ label: 'Red', value: 'Red' },
	{ label: 'n/a', value: 'n/a' },
];

// Dietary categories answered per product (Yes/No each) and shown as badges on the
// website product gallery. Order here is the badge and filter order on the website.
export const DIETARY_CATEGORIES = [
	{ key: 'vegetarian', field: 'dietaryVegetarian', label: 'Vegetarian', badge: 'VG' },
	{ key: 'vegan', field: 'dietaryVegan', label: 'Vegan', badge: 'V' },
	{ key: 'glutenFree', field: 'dietaryGlutenFree', label: 'Gluten-free', badge: 'GF' },
	{ key: 'dairyFree', field: 'dietaryDairyFree', label: 'Dairy-free', formLabel: 'Dairy-free / lactose intolerant', badge: 'DF' },
	{ key: 'nutFree', field: 'dietaryNutFree', label: 'Nut-free', badge: 'NF' },
	{ key: 'pescatarian', field: 'dietaryPescatarian', label: 'Pescatarian', badge: 'P' },
	{ key: 'halal', field: 'dietaryHalal', label: 'Halal', badge: 'H' },
	{ key: 'kosher', field: 'dietaryKosher', label: 'Kosher', badge: 'K' },
	{ key: 'lowFodmap', field: 'dietaryLowFodmap', label: 'Low FODMAP', badge: 'LF' },
	{ key: 'lowSugar', field: 'dietaryLowSugar', label: 'Low / no sugar', badge: 'LS' },
];

export const PDF_REPORT_SCOPE = {
	CLIENT: 'CLIENT',
	LOCATION: 'LOCATION',
};

export const REPORT_RUN_HISTORY_REPORT_TYPE = {
	PDF_REPORT: 'PDF_REPORT',
};

export const REPORT_RUN_HISTORY_OUTPUT_TYPE = {
	PDF: 'PDF',
};

export const PDF_REPORT_TITLES = {
	SALES_REPORT: 'Sales report',
	MACHINE_TYPES: 'Machine types',
	MACHINE_BRANDS: 'Machine brands',
	MARKETS: 'Markets',
	SALES_BY_PRODUCT: 'Sales by product',
	SERVICE_REPORTS: 'Service reports',
	WASTAGE_SPOILAGE_REPORT: 'Wastage / spoilage report',
	THEFT_MISSING_STOCK_REPORT: 'Theft / missing stock report',
	TICKET_REPORTS: 'Ticket reports',
	COMMISSION: 'Commission',
	PREVIOUS_PERIOD_COMPARISON: 'Previous period comparison',
};

export const PDF_REPORT_SUBTITLES = {
	SALES_BY_LOCATION: 'Sales by location',
	SALES_BY_PRODUCT_TYPE: 'Sales by product type',
	SALES_BY_LOCATION_AND_MACHINE_TAG: 'Sales by location and machine tag',
	SALES_BY_LOCATION_AND_POS: 'Sales by location and POS',
	TOP_SELLING_PRODUCTS_DRINKS: 'Top-selling products - drinks',
	TOP_SELLING_PRODUCTS_FOOD: 'Top-selling products - food / snacks',
	TOP_SELLING_PRODUCTS_OTHER: 'Top-selling products - other',
	LOW_SELLING_PRODUCTS: 'Low-selling products',
	HIGH_PRICED_ITEMS_PERFORMANCE: 'High priced items performance report',
	ALL_PRODUCT_SALES: 'All product sales',

	MACHINE_MODELS: 'Machine models',
	MACHINE_BRANDS_WRAPS: 'Machine brands / wraps',
	COMPLETE_LIST_OF_MACHINE_BRANDS: 'Complete list of machine brands, models and types',
	MICRO_MARKETS: 'Micro markets',

	SERVICE_REPORT: 'Service report',
	SPOILAGE_REPORT: 'Spoilage report',
	MISSING_STOCK_REPORT: 'Missing stock report',

	ISSUES_REPORT: 'Issues report',
	REPAIRS_AND_MAINTENANCE: 'Repairs and maintenance report',

	COMMISSION_REPORT: 'Commission report',

	PREVIOUS_PERIOD_COMPARISON_DATA: 'Previous period comparison data',
	PREVIOUS_PERIOD_COMPARISON_CHART: 'Previous period comparison chart',
	PREVIOUS_PERIOD_COMPARISON_DATA_SALES: 'Previous period comparison data - sales',
	PREVIOUS_PERIOD_COMPARISON_CHART_SALES: 'Previous period comparison chart - sales',
	PREVIOUS_PERIOD_COMPARISON_DATA_UNITS: 'Previous period comparison data - units',
	PREVIOUS_PERIOD_COMPARISON_CHART_UNITS: 'Previous period comparison chart - units',
	SALES_SUMMARY: 'Sales summary',
};

export const PLANOGRAM_TYPES_ARRAY = [
	{ label: 'Market', value: 'market' },
	{ label: 'Asset Template', value: 'assetTemplate' },
	{ label: 'Machine', value: 'machine' },
	{ label: 'Template', value: 'template' },
];

export const CUSTOMER_NOTIFICATION_TYPES = {
	PROMOTIONS: 1,
	CELEBRATIONS: 2,
	ACCOUNT_UPDATES: 3,
	MARKET_NEWS: 4,
};

export const SENTRY_PUSH_NOTIFICATION_TYPES = {
	OPERATIONS_ALERTS: 1,
	TICKETS_AND_SETUPS: 2,
	ROSTERS: 3,
	DOCUMENTS: 4,
	TRAINING: 5,
	PEOPLE_UPDATES: 6,
	SYSTEM_UPDATES: 7,
	OTHER: 8,
};

export const SENTRY_PUSH_NOTIFICATION_TYPE_NAMES = {
	[SENTRY_PUSH_NOTIFICATION_TYPES.OPERATIONS_ALERTS]: 'Operations alerts',
	[SENTRY_PUSH_NOTIFICATION_TYPES.TICKETS_AND_SETUPS]: 'Tickets and setup',
	[SENTRY_PUSH_NOTIFICATION_TYPES.ROSTERS]: 'Rosters',
	[SENTRY_PUSH_NOTIFICATION_TYPES.DOCUMENTS]: 'Documents',
	[SENTRY_PUSH_NOTIFICATION_TYPES.TRAINING]: 'Training',
	[SENTRY_PUSH_NOTIFICATION_TYPES.PEOPLE_UPDATES]: 'People updates',
	[SENTRY_PUSH_NOTIFICATION_TYPES.SYSTEM_UPDATES]: 'System updates',
	[SENTRY_PUSH_NOTIFICATION_TYPES.OTHER]: 'Other Sentry notifications',
};

export const DEFAULT_SENTRY_PUSH_NOTIFICATION_TYPES = Object.values(SENTRY_PUSH_NOTIFICATION_TYPES);

export const CUSTOMER_DIALOG_NOTIFICATION_TYPE = {
	CLIENT_SUBSIDY: 1,
	BIRTHDAY: 2,
};

export const CUSTOMER_DIALOG_NOTIFICATION_TYPE_NAME = {
	1: 'Client subsidy',
	2: 'Birthday',
};

export const FAMILIARITY_LEVEL = {
	NONE: 1,
	LOW: 2,
	MEDIUM: 3,
	HIGH: 4,
};

export const FREQUENCY = {
	NEVER: 0,
	RARELY: 1,
	OFTEN: 2,
	ALWAYS: 3,
};

export const FREQUENCY_NAMES = {
	0: 'Never',
	1: 'Rarely',
	2: 'Often',
	3: 'Always',
};

export const MACHINE_INACTIVE_CONDITION_TYPE = {
	DATE: 1,
	TICKET: 2,
};

export const MACHINE_INACTIVE_CONDITION_TYPE_NAME = {
	1: 'Date',
	2: 'Ticket',
};

export const PRESET_TYPE = {
	PDF_REPORT: 1,
	REPORT_FILTERS: 2,
};

export const PRESET_TYPE_NAME = {
	1: 'PDF Report',
	2: 'Report filters',
};

export const MACHINE_BRAND = {
	AVC: 1,
	AGORA: 20,
	VENDY: 30,
	ASIA_VEND: 40,
	GALACTIC: 50,
	MR_PANDA: 60,
	PHARMA_VEND: 70,
	RED_BULL: 80,
	HEY_PIZZA: 90,
	HEY_FROZEN: 100,
};

export const MACHINE_BRAND_NAME = {
	1: 'AVC',
	20: 'Agora',
	30: 'Vendy',
	40: 'AsiaVend',
	50: 'Galactic',
	60: 'Mr Panda',
	70: 'Pharma',
	80: 'Red Bull',
	90: 'Hey Pizza',
	100: 'Hey Frozen',
};

// Brand badges show a tint of the brand colour (see getLabelTint).
export const MACHINE_BRAND_COLORS = {
	1: '#2e80c4',
	20: '#e9e4de',
	30: '#a5b646',
	40: '#eab82b',
	50: '#5b7cc0',
	60: '#6f97a6',
	70: '#6f9393',
	80: '#e21b4d',
	90: '#e73010',
	100: '#1f8fc4',
};

export const CHAT_CONVERSATION_TYPE = {
	CHANNEL: 1,
	DIRECT: 2,
	GROUP: 3,
	MEETING: 4,
};

export const CHAT_CONVERSATION_TYPE_NAMES = {
	[CHAT_CONVERSATION_TYPE.CHANNEL]: 'Channel',
	[CHAT_CONVERSATION_TYPE.DIRECT]: 'Direct message',
	[CHAT_CONVERSATION_TYPE.GROUP]: 'Private channel',
	[CHAT_CONVERSATION_TYPE.MEETING]: 'Meeting',
};

export const CHAT_LEGACY_CHANNEL_KEYS = [
	'tickets',
	'setups',
	'state-handover',
	'operations-handover',
];

// Who Sentry Chat adds to a channel automatically (see chatAutoMembers).
export const CHAT_AUTO_MEMBERS_SCOPE = {
	NONE: 'none',
	EVERYONE: 'everyone',
	STATE: 'state',
	TEAM: 'team',
};

export const CHAT_MEMBERSHIP_ROLE = {
	OWNER: 1,
	ADMIN: 2,
	MEMBER: 3,
};

export const CHAT_MEMBERSHIP_ROLE_NAMES = {
	[CHAT_MEMBERSHIP_ROLE.OWNER]: 'Owner',
	[CHAT_MEMBERSHIP_ROLE.ADMIN]: 'Admin',
	[CHAT_MEMBERSHIP_ROLE.MEMBER]: 'Member',
};

export const CHAT_NOTIFICATION_LEVEL = {
	DEFAULT: 1,
	ALL_MESSAGES: 2,
	MENTIONS_ONLY: 3,
	MUTED: 4,
};

export const CHAT_NOTIFICATION_LEVEL_NAMES = {
	[CHAT_NOTIFICATION_LEVEL.DEFAULT]: 'Default',
	[CHAT_NOTIFICATION_LEVEL.ALL_MESSAGES]: 'All messages',
	[CHAT_NOTIFICATION_LEVEL.MENTIONS_ONLY]: 'Mentions only',
	[CHAT_NOTIFICATION_LEVEL.MUTED]: 'Muted',
};

// Acknowledgement-required messages: reminder cadence and escalation defaults.
export const CHAT_ACKNOWLEDGEMENT_DEFAULT_REMINDER_MINUTES = 60;
export const CHAT_ACKNOWLEDGEMENT_MIN_REMINDER_MINUTES = 5;
export const CHAT_ACKNOWLEDGEMENT_MAX_REMINDER_MINUTES = 24 * 60;
export const CHAT_ACKNOWLEDGEMENT_DEFAULT_ESCALATION_NUDGES = 3;
export const CHAT_ACKNOWLEDGEMENT_MIN_ESCALATION_NUDGES = 1;
export const CHAT_ACKNOWLEDGEMENT_MAX_ESCALATION_NUDGES = 20;
export const CHAT_ACKNOWLEDGEMENT_PUSH_TYPE = 'chatAcknowledgement';
export const CHAT_ACKNOWLEDGEMENT_ESCALATION_PUSH_TYPE = 'chatAcknowledgementEscalation';
export const CHAT_ACKNOWLEDGEMENT_REMINDER_PUSH_TYPE = 'chatAcknowledgementReminder';

export const CHAT_USER_STATUS = {
	AVAILABLE: 1,
	IN_SENTRY: 2,
	BUSY: 3,
	IN_SERVICE_RUN: 4,
	PICKING: 5,
	ON_ROUTE: 6,
	AWAY: 7,
	DO_NOT_DISTURB: 8,
	OFFLINE: 9,
};

export const CHAT_MANUAL_USER_STATUSES = [
	CHAT_USER_STATUS.AVAILABLE,
	CHAT_USER_STATUS.OFFLINE,
	CHAT_USER_STATUS.DO_NOT_DISTURB,
];

export const CHAT_USER_STATUS_NAMES = {
	[CHAT_USER_STATUS.AVAILABLE]: 'Available',
	[CHAT_USER_STATUS.IN_SENTRY]: 'In Sentry',
	[CHAT_USER_STATUS.BUSY]: 'Busy',
	[CHAT_USER_STATUS.IN_SERVICE_RUN]: 'In a service run',
	[CHAT_USER_STATUS.PICKING]: 'Picking',
	[CHAT_USER_STATUS.ON_ROUTE]: 'On route',
	[CHAT_USER_STATUS.AWAY]: 'Away',
	[CHAT_USER_STATUS.DO_NOT_DISTURB]: 'Do not disturb',
	[CHAT_USER_STATUS.OFFLINE]: 'Offline',
};

export const CHAT_ATTACHMENT_TYPE = {
	FILE: 1,
	IMAGE: 2,
	VIDEO: 3,
	AUDIO: 4,
	DOCUMENT: 5,
};

export const CHAT_MEETING_TIMEZONE = 'Australia/Brisbane';
export const CHAT_MEETING_TIMEZONE_LABEL = 'AEST';
export const CHAT_MEETING_DEFAULT_REMINDER_MINUTES = 60;
export const CHAT_MEETING_UPDATE_SCOPE = {
	OCCURRENCE: 'occurrence',
	FOLLOWING: 'following',
};

export const CHAT_CALL_SIGNAL = {
	READY: 'ready',
	READY_ACK: 'ready-ack',
	OFFER: 'offer',
	ANSWER: 'answer',
	CANDIDATE: 'candidate',
	SCREEN_SHARE_STARTED: 'screen-share-started',
	SCREEN_SHARE_STOPPED: 'screen-share-stopped',
	MEETING_NOTES_REQUESTED: 'meeting-notes-requested',
	MEETING_NOTES_CONSENT: 'meeting-notes-consent',
	MEETING_NOTES_CONSENT_ACK: 'meeting-notes-consent-ack',
	MEETING_NOTES_STARTED: 'meeting-notes-started',
	MEETING_NOTES_STARTED_ACK: 'meeting-notes-started-ack',
	MEETING_NOTES_STOPPED: 'meeting-notes-stopped',
	MEETING_NOTES_STOPPED_ACK: 'meeting-notes-stopped-ack',
	HEARTBEAT: 'heartbeat',
	LEAVE: 'leave',
	END: 'end',
};

// A call started from a direct message; meetings have no kind.
export const CHAT_CALL_KIND = {
	VOICE: 'voice',
	VIDEO: 'video',
};

export const CHAT_CALL_STATUS = {
	ACTIVE: 1,
	ENDED: 2,
	MISSED: 3,
	CANCELLED: 4,
	SCHEDULED: 5,
};

export const CHAT_CALL_STATUS_NAMES = {
	[CHAT_CALL_STATUS.ACTIVE]: 'Active',
	[CHAT_CALL_STATUS.ENDED]: 'Ended',
	[CHAT_CALL_STATUS.MISSED]: 'Missed',
	[CHAT_CALL_STATUS.CANCELLED]: 'Cancelled',
	[CHAT_CALL_STATUS.SCHEDULED]: 'Scheduled',
};

export const CHAT_MEETING_TRANSCRIPT_STATUS = {
	NOT_RECORDED: 1,
	RECORDING: 2,
	AVAILABLE: 3,
};

export const CHAT_SUBSCRIPTION_CONVERSATION_LIMIT = 500;

export const CHAT_AUDIT_EVENT_TYPE = {
	CONVERSATION_CREATED: 1,
	CONVERSATION_ARCHIVED: 2,
	MEMBER_ADDED: 3,
	MEMBER_REMOVED: 4,
	MEMBER_ROLE_CHANGED: 5,
	MESSAGE_DELETED: 6,
	PIN_ADDED: 7,
	PIN_REMOVED: 8,
	ATTACHMENT_DOWNLOADED: 9,
	SETTINGS_CHANGED: 10,
	RETENTION_CHANGED: 11,
	CALL_CONNECTION_FAILED: 12,
	MEETING_RECORD_CLEARED: 13,
	MESSAGE_EDITED: 14,
	JOIN_REQUEST_DECLINED: 15,
};

export const CHAT_CONVERSATION_EVENT_TYPE = {
	CREATED: 1,
	UPDATED: 2,
	MEMBERS_CHANGED: 3,
	ARCHIVED: 4,
	PINS_CHANGED: 5,
	CALL_STARTED: 6,
	CALL_ENDED: 7,
	RECEIPTS_UPDATED: 8,
};

// Delivered and read ticks are shown for direct messages and groups up to this size.
export const CHAT_RECEIPTS_MAX_MEMBERS = 20;


// const PRODUCT_TYPES = {
// 	CANDY: 0,
// 	CHIPS: 1,
// 	'2': 'Chocolate',
// 	'3': 'Cleaning Products',
// 	'4': 'Coffee',
// 	'5': 'Coffee Additives',
// 	'6': 'Cold Drinks',
// 	'7': 'Cold Foods',
// 	'8': 'Cookies',
// 	'9': 'Crackers',
// 	'10': 'Dairy',
// 	'11': 'Drinks',
// 	'12': 'Electronics',
// 	'13': 'Equipment & Accessories',
// 	'14': 'Frozen Foods',
// 	'15': 'Granola',
// 	'16': 'Gum and Mint',
// 	'17': 'Kitchen Supplies',
// 	'18': 'Not Specified',
// 	'19': 'Parts',
// 	'20': 'Pastries',
// 	'21': 'Personal Care',
// 	'22': 'Pharmaceutical',
// 	'23': 'Produce',
// 	'24': 'Salty Snacks',
// 	'25': 'Service',
// 	'26': 'Specialties',
// 	'27': 'Tea',
// 	'28': 'Tobacco',
// 	'29': 'Water',
// };

// const PRODUCT_TYPE_NAMES = {
// 	'0': 'Candy',
// 	'1': 'Chips',
// 	'2': 'Chocolate',
// 	'3': 'Cleaning Products',
// 	'4': 'Coffee',
// 	'5': 'Coffee Additives',
// 	'6': 'Cold Drinks',
// 	'7': 'Cold Foods',
// 	'8': 'Cookies',
// 	'9': 'Crackers',
// 	'10': 'Dairy',
// 	'11': 'Drinks',
// 	'12': 'Electronics',
// 	'13': 'Equipment & Accessories',
// 	'14': 'Frozen Foods',
// 	'15': 'Granola',
// 	'16': 'Gum and Mint',
// 	'17': 'Kitchen Supplies',
// 	'18': 'Not Specified',
// 	'19': 'Parts',
// 	'20': 'Pastries',
// 	'21': 'Personal Care',
// 	'22': 'Pharmaceutical',
// 	'23': 'Produce',
// 	'24': 'Salty Snacks',
// 	'25': 'Service',
// 	'26': 'Specialties',
// 	'27': 'Tea',
// 	'28': 'Tobacco',
// 	'29': 'Water',
// };
